{
  "decorations": [
    {
      "id": "warfish-logo-outline",
      "shape": "M 298.85 129.26 C 298.66 129.31 298.14 129.56 297.69 129.78 C 297.24 130.01 296.72 130.24 296.53 130.30 C 296.16 130.41 295.16 131.05 294.23 131.76 C 292.99 132.72 291.76 134.61 291.25 136.31 C 290.85 137.71 290.35 138.08 289.04 137.97 C 288.17 137.90 287.80 137.94 287.03 138.17 C 286.12 138.46 285.82 138.47 281.28 138.45 C 277.24 138.42 276.40 138.45 275.90 138.62 C 275.16 138.90 274.50 138.90 273.64 138.64 C 272.79 138.38 267.23 138.35 265.53 138.60 C 264.56 138.73 264.28 138.73 263.41 138.53 C 262.87 138.39 261.83 138.21 261.12 138.12 C 259.22 137.86 258.93 137.61 259.12 136.41 C 259.59 133.44 258.96 131.83 257.11 131.24 C 255.94 130.87 246.58 130.72 245.46 131.05 C 244.08 131.46 243.71 131.49 242.44 131.21 C 241.39 130.98 240.71 130.96 237.53 130.98 C 233.75 131.01 233.16 131.08 232.11 131.61 C 231.39 131.98 231.08 131.94 229.86 131.35 C 228.50 130.71 220.02 130.59 218.43 131.19 C 217.59 131.50 216.67 132.38 216.33 133.20 C 215.95 134.10 216.21 141.47 216.68 143.77 C 216.88 144.61 217.04 146.23 217.16 148.41 C 217.30 150.97 217.42 152.12 217.70 153.27 C 217.93 154.33 218.06 155.41 218.13 156.96 C 218.28 160.43 218.95 161.59 221.13 162.17 C 222.52 162.55 230.77 162.43 232.19 162.02 C 233.64 161.59 233.65 161.59 235.00 162.03 C 236.21 162.40 236.00 162.40 244.85 162.03 C 246.56 161.96 247.84 161.02 248.61 159.30 C 249.21 157.96 249.58 157.98 250.69 159.45 C 252.76 162.21 257.15 163.60 260.30 162.50 C 261.61 162.03 262.07 162.00 263.40 162.28 C 264.85 162.58 269.62 162.50 271.00 162.15 C 271.97 161.92 272.15 161.91 272.98 162.09 C 275.32 162.55 282.05 162.39 283.33 161.83 C 284.74 161.21 285.47 159.34 285.85 155.39 C 286.08 153.06 286.55 152.11 287.45 152.11 C 288.23 152.11 288.39 153.25 287.83 154.94 C 286.15 160.06 287.46 162.20 292.36 162.33 C 295.75 162.41 299.93 162.17 301.15 161.80 C 302.12 161.50 302.16 161.50 302.86 161.73 C 304.59 162.32 310.62 162.46 314.16 161.99 C 316.01 161.74 316.39 161.79 319.15 162.46 C 320.85 162.87 324.12 162.80 326.06 162.30 C 327.93 161.81 329.29 161.77 331.40 162.13 C 333.17 162.41 338.62 162.46 340.13 162.20 C 340.95 162.06 341.26 162.07 342.29 162.26 C 344.32 162.67 351.12 162.30 353.28 161.68 C 353.69 161.57 354.02 161.61 355.47 162.03 C 357.61 162.66 359.43 162.74 360.62 162.25 C 361.48 161.89 362.45 161.87 363.75 162.17 C 364.59 162.36 365.08 162.37 368.58 162.20 C 372.98 161.99 373.20 161.99 379.01 162.22 C 384.01 162.43 384.86 162.32 385.89 161.38 C 387.06 160.29 387.47 160.27 388.89 161.20 C 389.40 161.54 390.04 161.84 390.30 161.88 C 390.58 161.94 391.29 162.13 391.89 162.32 C 393.69 162.92 397.67 162.95 399.48 162.39 C 400.19 162.15 400.99 161.94 401.25 161.89 C 401.51 161.84 402.09 161.59 402.53 161.32 C 403.91 160.47 404.52 160.46 405.45 161.27 C 406.76 162.41 414.94 163.00 417.18 162.10 C 418.78 161.46 419.81 160.20 420.00 158.64 C 420.07 158.12 420.27 157.19 420.46 156.58 C 420.65 155.96 420.87 154.87 420.96 154.16 C 421.02 153.45 421.12 152.72 421.16 152.56 C 421.26 152.05 422.04 151.29 422.81 150.92 C 424.13 150.29 424.78 149.26 425.03 147.38 C 425.10 146.77 425.33 145.68 425.52 144.94 C 426.21 142.29 426.04 141.06 424.82 139.77 C 424.02 138.93 424.03 138.99 424.09 137.38 C 424.13 135.64 422.86 133.77 421.38 133.39 C 420.41 133.14 411.25 133.40 410.69 133.70 C 409.46 134.35 408.50 135.48 408.50 136.30 C 408.49 137.04 408.02 137.79 406.83 138.94 C 405.48 140.25 405.11 140.36 404.18 139.69 C 402.73 138.65 401.50 138.28 398.48 138.02 C 396.70 137.87 393.75 138.19 392.68 138.65 C 392.39 138.78 391.83 138.98 391.44 139.13 C 391.03 139.27 390.30 139.68 389.81 140.03 C 387.86 141.47 387.88 141.47 386.68 140.29 C 385.63 139.25 384.36 138.50 383.30 138.31 C 381.92 138.06 379.23 137.97 378.42 138.16 C 377.90 138.28 376.06 138.34 372.34 138.35 C 367.05 138.38 366.99 138.38 366.39 138.69 C 364.23 139.81 363.63 141.17 363.04 146.39 C 362.88 147.91 362.12 148.39 360.95 147.70 C 360.24 147.29 360.10 147.27 358.61 147.22 C 356.62 147.18 356.36 146.98 356.21 145.45 C 355.79 141.32 353.55 138.78 349.85 138.21 C 347.48 137.87 347.03 137.37 347.52 135.62 C 348.18 133.28 347.80 131.53 346.40 130.53 C 344.68 129.29 336.07 129.26 334.06 130.50 C 333.25 131.00 332.62 132.10 332.47 133.27 C 332.35 134.25 331.36 138.43 331.17 138.72 C 330.93 139.12 330.42 139.12 329.49 138.72 C 328.12 138.12 326.61 137.96 323.88 138.15 C 320.85 138.35 320.93 138.39 320.64 136.38 C 320.12 132.60 318.70 130.93 314.78 129.45 C 313.81 129.08 311.57 129.26 310.47 129.79 C 309.21 130.41 308.44 130.39 307.07 129.72 C 306.04 129.22 300.01 128.88 298.85 129.26 Z",
      "fill": "#000000",
      "role": "warfish-logo"
    },
    {
      "id": "warfish-logo-lettering",
      "shape": "M 300.18 132.96 C 297.29 133.48 295.26 135.96 294.39 139.98 C 294.09 141.40 293.90 141.67 292.90 142.12 C 291.76 142.64 291.66 142.84 291.14 145.90 C 291.03 146.58 291.29 147.24 291.89 147.79 C 292.70 148.54 292.75 148.80 292.44 150.18 C 292.29 150.82 292.10 152.06 292.00 152.93 C 291.92 153.79 291.70 155.09 291.52 155.80 C 290.87 158.41 291.02 158.53 295.08 158.61 C 298.85 158.68 298.88 158.65 299.21 155.77 C 299.32 154.79 299.55 153.42 299.74 152.73 C 299.92 152.05 300.12 150.92 300.19 150.21 C 300.37 148.40 300.74 147.99 302.32 147.73 C 303.71 147.51 303.94 147.21 304.17 145.41 C 304.24 144.76 304.35 143.97 304.40 143.63 C 304.51 142.79 304.17 142.36 303.23 142.12 C 301.31 141.66 301.71 139.38 303.77 139.05 C 305.06 138.84 305.15 138.73 305.74 136.52 C 306.59 133.31 306.37 133.03 302.88 132.91 C 301.75 132.87 300.53 132.90 300.18 132.96 Z M 310.79 133.12 C 308.74 133.72 307.38 136.81 308.34 138.76 C 310.35 142.88 316.28 141.15 316.27 136.45 C 316.27 133.68 313.88 132.23 310.79 133.12 Z M 336.61 133.46 C 336.16 133.77 336.04 134.09 335.82 135.47 C 335.71 136.16 335.53 137.07 335.42 137.49 C 335.31 137.91 335.12 139.12 335.01 140.16 C 334.89 141.21 334.64 142.67 334.47 143.42 C 334.29 144.18 334.07 145.50 333.99 146.36 C 333.91 147.22 333.66 148.70 333.44 149.64 C 333.24 150.59 332.99 151.91 332.91 152.61 C 332.83 153.29 332.61 154.46 332.42 155.17 C 331.60 158.31 331.81 158.53 335.75 158.53 C 339.58 158.53 339.46 158.67 340.41 153.06 C 341.10 149.03 341.97 147.62 343.37 148.29 C 344.23 148.70 344.23 149.25 343.42 154.03 C 342.67 158.48 342.57 158.31 346.06 158.46 C 349.45 158.60 350.13 158.41 350.33 157.18 C 350.38 156.90 350.56 156.14 350.75 155.47 C 350.93 154.81 351.17 153.71 351.30 153.01 C 351.41 152.32 351.65 151.01 351.84 150.11 C 352.68 145.97 352.13 143.38 350.22 142.32 C 349.08 141.69 346.12 141.71 344.71 142.37 C 342.81 143.27 342.46 142.89 342.86 140.32 C 343.01 139.40 343.20 137.93 343.29 137.07 C 343.37 136.21 343.48 135.28 343.53 135.02 C 343.68 134.37 343.50 133.73 343.12 133.55 C 342.57 133.28 336.97 133.21 336.61 133.46 Z M 249.15 134.32 C 246.67 134.44 246.30 134.67 245.59 136.56 C 245.38 137.11 244.96 138.21 244.63 139.05 C 244.31 139.87 243.99 140.83 243.89 141.17 C 243.23 143.79 242.36 145.60 241.80 145.52 C 241.21 145.43 241.16 145.05 241.16 140.35 C 241.16 134.00 241.36 134.36 237.70 134.35 C 234.02 134.35 234.02 134.35 232.56 138.50 C 230.57 144.15 230.23 144.96 229.71 145.08 C 229.18 145.21 228.96 144.87 228.91 143.82 C 228.87 143.30 228.76 141.65 228.65 140.14 C 228.54 138.64 228.43 136.96 228.40 136.40 C 228.33 134.65 228.24 134.61 224.12 134.61 C 219.72 134.61 219.58 134.71 220.16 137.75 C 220.27 138.31 220.39 139.29 220.44 139.94 C 220.48 140.58 220.61 141.84 220.72 142.74 C 220.81 143.64 220.94 144.80 220.98 145.34 C 221.03 145.86 221.15 147.16 221.26 148.21 C 221.46 150.05 221.93 155.15 222.07 156.81 C 222.21 158.42 222.63 158.57 226.96 158.50 C 230.19 158.46 230.19 158.46 230.57 158.12 C 231.18 157.56 232.91 153.83 233.92 150.88 C 234.81 148.28 235.81 148.62 235.97 151.57 C 236.34 158.52 236.28 158.41 239.86 158.54 C 241.16 158.60 242.48 158.68 242.78 158.74 C 244.29 158.98 244.64 158.56 246.62 154.02 C 246.84 153.53 247.54 151.98 248.18 150.57 C 248.83 149.18 249.36 147.99 249.36 147.95 C 249.36 147.91 249.76 147.06 250.23 146.06 C 251.45 143.55 252.93 140.27 253.57 138.64 C 253.87 137.89 254.28 136.92 254.47 136.46 C 255.42 134.32 254.72 134.04 249.15 134.32 Z M 412.92 137.27 C 412.33 137.53 412.12 137.90 411.85 139.25 C 411.52 140.91 411.22 141.41 410.15 141.97 C 409.27 142.44 408.91 142.93 408.91 143.66 C 408.91 143.83 408.75 144.52 408.55 145.17 C 408.10 146.71 408.17 147.12 408.95 147.81 C 409.96 148.71 410.04 149.04 409.59 150.74 C 409.44 151.30 409.22 152.53 409.12 153.47 C 408.99 154.42 408.79 155.59 408.64 156.10 C 407.97 158.33 408.13 158.42 412.14 158.37 C 416.20 158.31 415.77 158.68 416.76 154.50 C 417.02 153.36 417.33 151.76 417.47 150.94 C 417.81 148.63 418.19 148.04 419.57 147.74 C 420.89 147.46 421.06 147.22 421.41 145.41 C 421.52 144.76 421.69 143.98 421.79 143.66 C 422.02 142.84 421.79 142.45 420.85 142.10 C 419.60 141.65 419.34 140.94 419.71 138.95 C 419.90 137.98 419.74 137.53 419.10 137.27 C 418.44 136.98 413.56 136.98 412.92 137.27 Z M 287.76 141.71 C 287.57 141.77 286.90 142.04 286.27 142.33 L 285.12 142.85 L 284.03 142.48 C 282.69 142.04 277.97 141.93 277.04 142.32 C 276.28 142.64 275.88 144.22 274.86 151.08 C 274.67 152.35 274.38 154.28 274.21 155.35 C 273.75 158.41 273.79 158.45 277.74 158.46 C 280.37 158.46 280.54 158.45 280.80 158.18 C 281.17 157.82 281.95 155.17 282.23 153.40 C 282.83 149.44 284.17 147.87 286.60 148.25 C 288.41 148.54 288.88 147.80 289.13 144.39 C 289.27 142.54 289.17 141.97 288.65 141.74 C 288.27 141.56 288.26 141.56 287.76 141.71 Z M 394.71 141.85 C 388.05 143.30 384.77 152.06 389.14 156.73 C 391.22 158.97 395.73 159.76 399.20 158.53 C 401.43 157.72 402.42 157.03 403.43 155.52 C 404.47 153.95 404.17 153.35 402.24 153.19 C 399.57 152.95 399.01 153.01 397.67 153.62 C 396.24 154.28 395.65 154.22 395.22 153.36 C 394.54 152.02 395.80 151.67 401.80 151.48 C 405.74 151.34 406.01 151.03 405.30 147.28 C 404.49 143.05 399.94 140.73 394.71 141.85 Z M 398.26 146.76 C 399.03 147.54 398.60 148.21 397.36 148.20 C 395.99 148.17 395.48 147.43 396.35 146.72 C 396.95 146.21 397.73 146.23 398.26 146.76 Z M 258.79 141.99 C 252.90 142.92 249.85 153.53 254.31 157.64 C 256.24 159.42 258.10 159.67 260.57 158.42 C 262.24 157.59 262.58 157.56 263.66 158.13 C 264.97 158.82 269.58 158.59 269.99 157.81 C 270.24 157.31 270.93 154.70 271.22 153.12 C 271.37 152.30 271.63 151.16 271.78 150.60 C 271.93 150.04 272.12 148.77 272.21 147.80 C 272.27 146.81 272.46 145.47 272.63 144.82 C 273.16 142.47 272.98 142.30 269.80 142.19 C 266.89 142.08 266.65 142.12 265.77 142.89 C 264.90 143.62 264.60 143.64 263.84 143.00 C 262.59 141.96 260.99 141.63 258.79 141.99 Z M 263.30 148.21 C 264.97 149.07 264.52 151.78 262.55 152.71 C 260.93 153.49 259.30 151.16 260.15 149.29 C 260.65 148.17 262.20 147.63 263.30 148.21 Z M 322.53 141.99 C 320.17 142.32 318.03 144.60 317.88 146.96 C 317.73 149.26 318.79 150.96 321.04 152.05 C 322.13 152.57 322.37 152.80 322.37 153.36 C 322.37 154.18 321.45 154.22 319.89 153.47 C 317.98 152.56 317.79 152.62 316.27 154.70 C 314.86 156.63 315.20 157.26 318.35 158.49 C 322.70 160.20 327.84 159.02 329.65 155.92 C 331.38 152.98 329.97 148.77 327.06 148.13 C 325.81 147.84 325.18 147.12 325.73 146.58 C 326.04 146.25 326.59 146.32 327.36 146.77 C 328.64 147.54 329.18 147.24 330.23 145.17 C 331.08 143.52 331.04 143.36 329.71 142.74 C 328.07 141.99 324.88 141.66 322.53 141.99 Z M 379.24 141.93 C 378.41 142.08 377.77 142.32 377.23 142.69 C 376.30 143.33 375.95 143.34 375.06 142.73 C 374.29 142.19 374.29 142.19 371.45 142.15 C 367.40 142.10 367.31 142.15 367.06 144.90 C 366.99 145.73 366.75 147.20 366.51 148.14 C 366.29 149.08 365.98 150.64 365.84 151.63 C 365.69 152.60 365.42 154.29 365.23 155.37 C 364.67 158.49 364.71 158.53 368.82 158.53 C 372.45 158.53 372.13 158.79 372.94 155.18 C 373.16 154.20 373.38 153.04 373.43 152.58 C 373.75 149.54 374.39 148.28 375.65 148.28 C 377.05 148.28 377.26 149.15 376.64 152.45 C 375.78 156.93 375.73 157.77 376.28 158.26 C 376.75 158.71 382.35 158.67 382.87 158.22 C 383.28 157.86 384.21 154.62 384.37 152.93 C 384.42 152.43 384.66 151.18 384.88 150.12 C 386.13 144.34 383.90 141.10 379.24 141.93 Z M 309.49 142.11 C 307.72 142.30 307.33 143.07 306.78 147.46 C 306.70 148.17 306.45 149.64 306.23 150.74 C 304.59 159.24 304.36 158.53 308.82 158.53 C 312.76 158.53 312.77 158.52 313.14 155.46 C 313.26 154.40 313.54 152.71 313.75 151.70 C 313.97 150.68 314.19 149.45 314.23 148.96 C 314.29 148.47 314.48 147.39 314.64 146.57 C 315.27 143.57 315.23 142.63 314.46 142.26 C 314.04 142.04 310.90 141.96 309.49 142.11 Z M 356.96 151.18 C 354.71 151.80 353.47 154.50 354.48 156.55 C 356.19 160.01 360.85 159.72 362.66 156.04 C 364.20 152.93 360.85 150.07 356.96 151.18 Z",
      "fill": "#ffffff",
      "role": "warfish-logo"
    }
  ],
  "id": "europe-classic",
  "name": "Europe Classic",
  "legacy": "warfish",
  "territoryMarkers": {
    "style": "circle",
    "radius": 20
  },
  "opaqueTerritoryFills": true,
  "selectionInnerGlow": true,
  "backdropColor": {
    "light": "#00c1f0",
    "dark": "#00c1f0"
  },
  "edgeConfig": {
    "internalBorderWidth": 2.5,
    "regionBorderWidth": 4,
    "bridgeStrokeWidth": 0
  },
  "viewBox": {
    "x": 0,
    "y": 0,
    "width": 1438,
    "height": 1068
  },
  "gameLayout": {},
  "territories": [
    {
      "id": "ulster",
      "name": "Ulster",
      "regionId": "united-kingdom",
      "adjacencies": [
        "galloway"
      ],
      "shape": "M 0 282.5 L -0.5 201 L 4 203.5 L 8 197.5 L 16.5 200 L 25.5 212 L 30.5 234 L 37.5 247 L 46.5 254 L 46.5 263 L 40 269.5 L 34 271.5 L 16 269.5 L 9 277.5 L 2 275.5 L 0.5 282 Z",
      "position": {
        "x": 17.64,
        "y": 241.92
      },
      "badgeAnchor": {
        "x": 17.64,
        "y": 241.92
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "highlands",
      "name": "Highlands",
      "regionId": "united-kingdom",
      "adjacencies": [
        "grampian",
        "strathclyde"
      ],
      "shape": "M 119.5 83 L 118.5 85 L 118.5 86 L 117.5 87 L 117.5 88 L 115 90.5 L 114 90.5 L 113 91.5 L 112 91.5 L 107.5 96 L 107.5 97 L 98.5 106 L 98.5 107 L 97.5 108 L 97.5 135 L 96.5 136 L 96.5 137 L 96 137.5 L 86 137.5 L 85 138.5 L 82 138.5 L 81 139.5 L 62 139.5 L 61.5 139 L 61.5 134 L 50 135.5 L 48.5 143 L 45 145.5 L 34 145.5 L 30.5 144 L 29.5 129 L 53.5 104 L 59.5 87 L 67.5 77 L 65.5 61 L 80.5 57 L 85.5 40 L 95.5 34 L 97 23.5 L 106 23.5 L 122 30.5 L 144 30.5 L 148.5 34 L 148.5 41 L 143 47.5 L 112.5 60 L 111.5 77 Z",
      "position": {
        "x": 85.81,
        "y": 87
      },
      "badgeAnchor": {
        "x": 85.81,
        "y": 87
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "grampian",
      "name": "Grampian",
      "regionId": "united-kingdom",
      "adjacencies": [
        "highlands",
        "strathclyde",
        "rogaland"
      ],
      "shape": "M 130 162.5 L 127 160.5 L 108 154.5 L 96.5 138 L 96.5 136 L 97.5 108 L 120 83.5 L 121 84.5 L 155 85.5 L 181.5 102 L 181 108.5 L 170 111.5 L 164.5 118 L 166.5 125 L 159.5 140 L 145 146.5 L 141.5 154 Z M 145.5 90 L 131.5 90 L 145 90.5 Z",
      "position": {
        "x": 131.89,
        "y": 119.6
      },
      "badgeAnchor": {
        "x": 131.89,
        "y": 119.6
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "strathclyde",
      "name": "Strathclyde",
      "regionId": "united-kingdom",
      "adjacencies": [
        "galloway",
        "grampian",
        "highlands",
        "lothian"
      ],
      "shape": "M 66 205.5 L 66.5 204 L 66.5 177 L 66 176.5 L 64 176.5 L 63 175.5 L 62 175.5 L 61.5 175 L 61.5 174 L 60.5 173 L 60.5 172 L 60 171.5 L 59 171.5 L 58.5 172 L 58.5 173 L 58 173.5 L 55 173.5 L 54.5 174 L 55 174.5 L 56 174.5 L 58.5 177 L 58.5 189 L 55.5 192 L 55.5 193 L 53 195.5 L 48 195.5 L 43.5 191 L 43.5 182 L 46.5 179 L 46.5 175 L 48 173.5 L 49 173.5 L 50 172.5 L 51 172.5 L 51.5 172 L 51.5 171 L 51 170.5 L 50 170.5 L 49 171.5 L 46 171.5 L 44.5 170 L 44.5 162 L 45.5 161 L 45.5 160 L 47 158.5 L 48 158.5 L 51.5 155 L 51.5 153 L 53.5 151 L 53.5 150 L 55 148.5 L 60 148.5 L 61.5 147 L 61.5 140 L 62 139.5 L 81 139.5 L 82 138.5 L 85 138.5 L 86 137.5 L 96 137.5 L 97.5 139 L 108 154.5 L 121 157.5 L 129.5 163 L 126.5 166 L 126.5 182 L 133 186.5 L 133.5 187 L 130.5 202 L 127 205.5 L 119 205.5 Z",
      "position": {
        "x": 92.28,
        "y": 173.91
      },
      "badgeAnchor": {
        "x": 92.28,
        "y": 173.91
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "galloway",
      "name": "Galloway",
      "regionId": "united-kingdom",
      "adjacencies": [
        "cumbria",
        "lothian",
        "strathclyde",
        "ulster"
      ],
      "shape": "M 98.5 273 L 98.5 266 L 92.5 260 L 93 248.5 L 78 251.5 L 74 248.5 L 60 248.5 L 57.5 246 L 58.5 242 L 53 240.5 L 48.5 235 L 50.5 219 L 57 212.5 L 66 212.5 L 65 205.5 L 81 205.5 L 126 205.5 L 127.5 207 L 130.5 236 L 127.5 242 L 128.5 257 L 122.5 267 L 121 268.5 Z",
      "position": {
        "x": 95.47,
        "y": 232.09
      },
      "badgeAnchor": {
        "x": 95.47,
        "y": 232.09
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "lothian",
      "name": "Lothian",
      "regionId": "united-kingdom",
      "adjacencies": [
        "cumbria",
        "galloway",
        "northumbria",
        "strathclyde"
      ],
      "shape": "M 144 284.5 L 143 283.5 L 127 281.5 L 123.5 278 L 122.5 266 L 122.5 265 L 128.5 257 L 127.5 242 L 130.5 236 L 129.5 212 L 126.5 206 L 130.5 202 L 134 186.5 L 135 186.5 L 158 187.5 L 161.5 191 L 166.5 203 L 166.5 219 L 170.5 227 L 170.5 259 L 168.5 259 L 182.5 274 L 181 274.5 L 171 280.5 L 149 281.5 Z",
      "position": {
        "x": 148.72,
        "y": 238.53
      },
      "badgeAnchor": {
        "x": 148.72,
        "y": 238.53
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "cumbria",
      "name": "Cumbria",
      "regionId": "united-kingdom",
      "adjacencies": [
        "galloway",
        "lothian",
        "mercia",
        "northumbria",
        "wales"
      ],
      "shape": "M 114 354.5 L 113.5 354 L 110.5 349 L 110.5 336 L 101.5 325 L 101.5 323 L 102.5 321 L 94.5 315 L 93.5 310 L 96.5 300 L 102.5 293 L 98.5 274 L 99 273.5 L 123 266.5 L 123.5 267 L 123.5 278 L 127 281.5 L 144.5 285 L 144.5 304 L 142.5 307 L 143.5 350 L 142.5 351 L 134 356.5 Z",
      "position": {
        "x": 121.99,
        "y": 313.21
      },
      "badgeAnchor": {
        "x": 121.99,
        "y": 313.21
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "northumbria",
      "name": "Northumbria",
      "regionId": "united-kingdom",
      "adjacencies": [
        "cumbria",
        "east-anglia",
        "lothian",
        "mercia"
      ],
      "shape": "M 185 381.5 L 184 380.5 L 174.5 377 L 176.5 361 L 173 350.5 L 144 350.5 L 142.5 349 L 144.5 284 L 145 283.5 L 171 280.5 L 184 274.5 L 198 284.5 L 204.5 293 L 205.5 331 L 211.5 340 L 209.5 360 L 211.5 372 L 209 376.5 L 199 380.5 Z",
      "position": {
        "x": 177.97,
        "y": 323.52
      },
      "badgeAnchor": {
        "x": 177.97,
        "y": 323.52
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "wales",
      "name": "Wales",
      "regionId": "united-kingdom",
      "adjacencies": [
        "cornwall",
        "cumbria",
        "mercia"
      ],
      "shape": "M 100 436.5 L 98 436.5 L 88 433.5 L 50 432.5 L 37 418.5 L 14 413.5 L 10.5 410 L 10.5 401 L 25 390.5 L 39 388.5 L 58 370.5 L 63.5 370 L 63.5 358 L 49.5 348 L 53.5 343 L 50.5 337 L 50.5 324 L 53 321.5 L 63 321.5 L 73 335.5 L 86 335.5 L 93 330.5 L 96 331.5 L 101 324.5 L 102 325.5 L 110.5 336 L 110.5 349 L 114.5 355 L 113.5 356 L 111.5 419 L 115.5 428 L 114.5 430 L 112 435.5 L 102 434.5 Z M 51.5 428 L 54.5 426 L 48.5 423 L 51 428.5 Z",
      "position": {
        "x": 76.97,
        "y": 389.21
      },
      "badgeAnchor": {
        "x": 76.97,
        "y": 389.21
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mercia",
      "name": "Mercia",
      "regionId": "united-kingdom",
      "adjacencies": [
        "cornwall",
        "cumbria",
        "east-anglia",
        "northumbria",
        "wales",
        "wessex"
      ],
      "shape": "M 180 434.5 L 179 433.5 L 152 434.5 L 150 433.5 L 130 433.5 L 114.5 427 L 111.5 419 L 111.5 382 L 115 354.5 L 126 354.5 L 134 356.5 L 143 350.5 L 173 350.5 L 176.5 361 L 174.5 377 L 185.5 382 L 185.5 390 L 187.5 393 L 187.5 428 Z",
      "position": {
        "x": 148.19,
        "y": 394.85
      },
      "badgeAnchor": {
        "x": 148.19,
        "y": 394.85
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "east-anglia",
      "name": "East Anglia",
      "regionId": "united-kingdom",
      "adjacencies": [
        "mercia",
        "northumbria",
        "wessex"
      ],
      "shape": "M 220 447.5 L 217 445.5 L 202 441.5 L 186 441.5 L 180.5 434 L 181 433.5 L 187.5 428 L 185.5 381 L 186 380.5 L 199 380.5 L 210 375.5 L 212 376.5 L 224 378.5 L 227 373.5 L 236 372.5 L 247.5 379 L 246.5 383 L 252.5 390 L 252.5 415 L 243.5 432 Z",
      "position": {
        "x": 218.6,
        "y": 409.07
      },
      "badgeAnchor": {
        "x": 218.6,
        "y": 409.07
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "wessex",
      "name": "Wessex",
      "regionId": "united-kingdom",
      "adjacencies": [
        "cornwall",
        "east-anglia",
        "mercia",
        "picardy"
      ],
      "shape": "M 132 483.5 L 131.5 483 L 133.5 461 L 147.5 446 L 153 433.5 L 180.5 435 L 180.5 437 L 186 441.5 L 202 441.5 L 219.5 448 L 215.5 459 L 222 467.5 L 235 470.5 L 237.5 480 L 232 484.5 L 208 490.5 L 202 498.5 L 182 494.5 L 162 483.5 Z",
      "position": {
        "x": 180.01,
        "y": 465.48
      },
      "badgeAnchor": {
        "x": 180.01,
        "y": 465.48
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "cornwall",
      "name": "Cornwall",
      "regionId": "united-kingdom",
      "adjacencies": [
        "mercia",
        "wales",
        "wessex"
      ],
      "shape": "M 101.5 435 L 102 434.5 L 112 435.5 L 116 428.5 L 130 433.5 L 151.5 435 L 147.5 446 L 133.5 461 L 131 483.5 L 108 483.5 L 82 480.5 L 74 484.5 L 55 485.5 L 49.5 491 L 49.5 499 L 47 501.5 L 38 501.5 L 27 493.5 L 12 493.5 L 4 498.5 L 1 497.5 L -0.5 501 L 0 471.5 L 1 476.5 L 8 468.5 L 25 461.5 L 33 450.5 L 40 446.5 L 47 446.5 L 61 455.5 L 77 455.5 L 85 448.5 L 101 446.5 Z M 34.5 456 L 36 454.5 L 37 454.5 L 37.5 454 L 37 453.5 L 36 453.5 L 33.5 456 L 34 456.5 Z",
      "position": {
        "x": 74,
        "y": 469
      },
      "badgeAnchor": {
        "x": 74,
        "y": 469
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "asturias",
      "name": "Asturias",
      "regionId": "spain",
      "adjacencies": [
        "basque-country",
        "galicia",
        "gascony",
        "leon"
      ],
      "shape": "M 48.5 999 L 48.5 998 L 41.5 989 L 33.5 966 L 35.5 947 L 29.5 923 L 31.5 908 L 32 907.5 L 57 907.5 L 61.5 910 L 70.5 918 L 79 933.5 L 96 941.5 L 101.5 950 L 100.5 952 L 103.5 986 L 100 989.5 L 77 998.5 Z",
      "position": {
        "x": 64.62,
        "y": 957.17
      },
      "badgeAnchor": {
        "x": 64.62,
        "y": 957.17
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "basque-country",
      "name": "Basque Country",
      "regionId": "spain",
      "adjacencies": [
        "asturias",
        "castile",
        "catalonia",
        "gascony",
        "leon",
        "toulouse"
      ],
      "shape": "M 137 1020.5 L 134 1018.5 L 114.5 1005 L 103.5 986 L 99.5 961 L 102 950.5 L 105 950.5 L 106 951.5 L 108 951.5 L 109 950.5 L 111 950.5 L 112 949.5 L 113 949.5 L 114 950.5 L 116 950.5 L 118 952.5 L 119 952.5 L 121.5 955 L 121.5 957 L 125 960.5 L 145 960.5 L 147 962.5 L 150 962.5 L 153.5 959 L 153.5 958 L 156 955.5 L 162 955.5 L 165 958.5 L 166 958.5 L 167 959.5 L 168 959.5 L 169 960.5 L 172 960.5 L 174 962.5 L 175 962.5 L 177 964.5 L 179 964.5 L 180 965.5 L 182 965.5 L 184 967.5 L 187 967.5 L 188 968.5 L 189 968.5 L 191 970.5 L 192 970.5 L 193 971.5 L 197 971.5 L 200.5 975 L 200.5 976 L 201.5 977 L 201.5 978 L 200.5 979 L 200.5 983 L 198.5 986 L 199.5 999 L 194.5 1013 L 194 1013.5 L 169 1014.5 Z",
      "position": {
        "x": 150.27,
        "y": 987.43
      },
      "badgeAnchor": {
        "x": 150.27,
        "y": 987.43
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "galicia",
      "name": "Galicia",
      "regionId": "spain",
      "adjacencies": [
        "asturias",
        "leon"
      ],
      "shape": "M -0.5 1014 L -0.5 914 L 9 909.5 L 13 910.5 L 15 904.5 L 31.5 907 L 31.5 909 L 29.5 923 L 35.5 947 L 33.5 966 L 48.5 1002 L 41 1014.5 L 34 1016.5 Z",
      "position": {
        "x": 16,
        "y": 971
      },
      "badgeAnchor": {
        "x": 16,
        "y": 971
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "catalonia",
      "name": "Catalonia",
      "regionId": "spain",
      "adjacencies": [
        "basque-country",
        "castile",
        "toulouse"
      ],
      "shape": "M 198.5 1053 L 198.5 1024 L 194.5 1014 L 194.5 1012 L 199.5 999 L 200.5 982 L 201 981.5 L 212 987.5 L 224 987.5 L 231 991.5 L 252 986.5 L 261.5 988 L 264.5 1019 L 258 1024.5 L 250 1024.5 L 245 1029.5 L 242 1028.5 L 238 1035.5 L 226 1042.5 L 221 1050.5 L 214 1054.5 Z",
      "position": {
        "x": 225.85,
        "y": 1014.95
      },
      "badgeAnchor": {
        "x": 225.85,
        "y": 1014.95
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "leon",
      "name": "León",
      "regionId": "spain",
      "adjacencies": [
        "asturias",
        "basque-country",
        "castile",
        "galicia"
      ],
      "shape": "M 100 1067.5 L 0 1067.5 L -0.5 1015 L 0 1014.5 L 15 1016.5 L 41 1014.5 L 48.5 1000 L 49 999.5 L 77 998.5 L 89 995.5 L 103 986.5 L 106.5 989 L 114.5 1005 L 136.5 1021 L 135.5 1022 L 120.5 1045 L 118.5 1057 L 114 1060.5 L 106 1060.5 Z",
      "position": {
        "x": 66.53,
        "y": 1034.46
      },
      "badgeAnchor": {
        "x": 66.53,
        "y": 1034.46
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "castile",
      "name": "Castile",
      "regionId": "spain",
      "adjacencies": [
        "basque-country",
        "catalonia",
        "leon"
      ],
      "shape": "M 101 1067.5 L 100.5 1067 L 106 1060.5 L 114 1060.5 L 118.5 1057 L 118.5 1051 L 125.5 1035 L 138 1019.5 L 169 1014.5 L 194 1013.5 L 196.5 1016 L 198 1053.5 L 195 1053.5 L 173 1055.5 L 158 1067.5 Z",
      "position": {
        "x": 158.28,
        "y": 1040.32
      },
      "badgeAnchor": {
        "x": 158.28,
        "y": 1040.32
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "picardy",
      "name": "Picardy",
      "regionId": "france",
      "adjacencies": [
        "champagne",
        "ile-de-france",
        "normandy",
        "flanders",
        "wallonia",
        "wessex"
      ],
      "shape": "M 312 615.5 L 223 615.5 L 221.5 614 L 218.5 584 L 221.5 570 L 219.5 550 L 223 546.5 L 244 536.5 L 246 536.5 L 273 565.5 L 314.5 600 L 316.5 608 L 312.5 615 Z",
      "position": {
        "x": 255.85,
        "y": 584.68
      },
      "badgeAnchor": {
        "x": 255.85,
        "y": 584.68
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "normandy",
      "name": "Normandy",
      "regionId": "france",
      "adjacencies": [
        "anjou",
        "brittany",
        "ile-de-france",
        "picardy"
      ],
      "shape": "M 107.5 658 L 107.5 657 L 106.5 650 L 110.5 634 L 108.5 629 L 112.5 623 L 111.5 607 L 115.5 603 L 115.5 553 L 118 550.5 L 130 551.5 L 140.5 559 L 141 567.5 L 154 573.5 L 169 572.5 L 173 575.5 L 182 575.5 L 191 573.5 L 193.5 564 L 211 549.5 L 219 549.5 L 219.5 550 L 221.5 570 L 218.5 595 L 222.5 615 L 221.5 616 L 221.5 650 L 214 660.5 L 211 660.5 L 206 662.5 L 131 662.5 Z",
      "position": {
        "x": 166.35,
        "y": 615.72
      },
      "badgeAnchor": {
        "x": 166.35,
        "y": 615.72
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "champagne",
      "name": "Champagne",
      "regionId": "france",
      "adjacencies": [
        "burgundy",
        "flanders",
        "ile-de-france",
        "lorraine",
        "picardy",
        "rhineland",
        "wallonia"
      ],
      "shape": "M 319 675.5 L 317.5 674 L 319.5 642 L 313.5 630 L 312.5 614 L 316.5 608 L 314.5 600 L 273 565.5 L 251.5 540 L 245 536.5 L 244.5 536 L 244.5 494 L 249 489.5 L 257 489.5 L 261 484.5 L 284.5 485 L 284.5 501 L 288.5 507 L 304 511.5 L 308.5 516 L 308.5 526 L 317 529.5 L 326 538.5 L 326.5 539 L 330.5 552 L 338 561.5 L 363 568.5 L 384 586.5 L 394 586.5 L 397 589.5 L 405 592.5 L 411 589.5 L 419 593.5 L 428.5 605 L 425.5 608 L 423 614.5 L 408 619.5 L 394.5 629 L 393.5 657 L 390 661.5 L 375 668.5 L 368 668.5 L 344 676.5 Z",
      "position": {
        "x": 330.79,
        "y": 589.27
      },
      "badgeAnchor": {
        "x": 330.79,
        "y": 589.27
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "brittany",
      "name": "Brittany",
      "regionId": "france",
      "adjacencies": [
        "anjou",
        "normandy"
      ],
      "shape": "M 73.5 691 L 72 685.5 L 61.5 679 L 53 663.5 L 41 658.5 L 34 651.5 L 28 650.5 L 24 643.5 L 11 639.5 L 1 639.5 L -0.5 642 L -0.5 613 L 1 616.5 L 3 615.5 L 3.5 611 L -0.5 609 L -0.5 585 L 10 590.5 L 30 590.5 L 46 582.5 L 53 582.5 L 63.5 594 L 63.5 599 L 70 606.5 L 111 606.5 L 111.5 607 L 112.5 623 L 108.5 629 L 110.5 634 L 106.5 650 L 107.5 659 L 106.5 660 L 106.5 682 L 99 690.5 L 90 694.5 L 77 694.5 Z",
      "position": {
        "x": 60.45,
        "y": 634.12
      },
      "badgeAnchor": {
        "x": 60.45,
        "y": 634.12
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "lorraine",
      "name": "Lorraine",
      "regionId": "france",
      "adjacencies": [
        "burgundy",
        "champagne",
        "rhineland",
        "swabia",
        "vaud"
      ],
      "shape": "M 401 751.5 L 400.5 751 L 399.5 726 L 393.5 711 L 384.5 699 L 385.5 696 L 374.5 670 L 378 665.5 L 390 661.5 L 393.5 657 L 394.5 629 L 408 619.5 L 423 614.5 L 428 605.5 L 430 605.5 L 438 606.5 L 443 610.5 L 455 610.5 L 463 616.5 L 473 616.5 L 482.5 624 L 481.5 625 L 479.5 631 L 470.5 639 L 466.5 659 L 458.5 670 L 454.5 690 L 457.5 699 L 456.5 701 L 447 710.5 L 437 706.5 L 431.5 713 L 430.5 719 L 412.5 738 L 412.5 744 Z",
      "position": {
        "x": 425.51,
        "y": 665.01
      },
      "badgeAnchor": {
        "x": 425.51,
        "y": 665.01
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ile-de-france",
      "name": "Île-de-France",
      "regionId": "france",
      "adjacencies": [
        "anjou",
        "auvergne",
        "burgundy",
        "champagne",
        "normandy",
        "picardy"
      ],
      "shape": "M 298 716.5 L 297 715.5 L 240 715.5 L 225.5 710 L 225.5 707 L 217.5 681 L 217.5 667 L 213.5 661 L 214.5 660 L 221.5 650 L 222 615.5 L 312 615.5 L 312.5 616 L 312.5 618 L 313.5 630 L 319.5 642 L 318.5 675 L 317.5 676 L 315.5 707 L 312 712.5 Z",
      "position": {
        "x": 268.74,
        "y": 665.4
      },
      "badgeAnchor": {
        "x": 268.74,
        "y": 665.4
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "anjou",
      "name": "Anjou",
      "regionId": "france",
      "adjacencies": [
        "auvergne",
        "brittany",
        "ile-de-france",
        "normandy",
        "poitou"
      ],
      "shape": "M 104.5 764 L 104.5 755 L 104.5 747 L 96.5 742 L 96.5 739 L 90.5 735 L 90.5 731 L 82.5 724 L 77 694.5 L 90 694.5 L 105.5 684 L 108 658.5 L 131 662.5 L 206 662.5 L 213 660.5 L 214.5 662 L 217.5 667 L 217.5 681 L 225.5 711 L 221.5 715 L 217.5 730 L 197.5 745 L 182 770.5 L 161 776.5 L 135 772.5 L 115 763.5 Z",
      "position": {
        "x": 154.2,
        "y": 714.19
      },
      "badgeAnchor": {
        "x": 154.2,
        "y": 714.19
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "burgundy",
      "name": "Burgundy",
      "regionId": "france",
      "adjacencies": [
        "auvergne",
        "champagne",
        "ile-de-france",
        "languedoc",
        "lorraine",
        "provence",
        "vaud"
      ],
      "shape": "M 283.5 824 L 283.5 822 L 289.5 799 L 288.5 765 L 298.5 734 L 298.5 716 L 299 715.5 L 312 712.5 L 315.5 707 L 318 675.5 L 324 675.5 L 344 676.5 L 374 668.5 L 374.5 669 L 385.5 696 L 384.5 699 L 393.5 711 L 399.5 726 L 401.5 752 L 400.5 753 L 396.5 762 L 398.5 773 L 387.5 797 L 359 811.5 L 353.5 821 L 353 821.5 L 338 830.5 L 325 834.5 L 298 834.5 Z",
      "position": {
        "x": 342.92,
        "y": 755.11
      },
      "badgeAnchor": {
        "x": 342.92,
        "y": 755.11
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "auvergne",
      "name": "Auvergne",
      "regionId": "france",
      "adjacencies": [
        "anjou",
        "burgundy",
        "ile-de-france",
        "poitou",
        "toulouse",
        "languedoc"
      ],
      "shape": "M 202.5 817 L 202.5 815 L 192.5 801 L 191.5 791 L 182.5 770 L 185.5 767 L 197.5 745 L 217.5 730 L 221.5 715 L 226 710.5 L 240 715.5 L 298.5 717 L 298.5 734 L 288.5 765 L 289.5 799 L 283.5 823 L 283 823.5 L 276 828.5 L 273 828.5 L 261 834.5 L 252 834.5 L 241 829.5 L 220 825.5 Z",
      "position": {
        "x": 243.88,
        "y": 772.82
      },
      "badgeAnchor": {
        "x": 243.88,
        "y": 772.82
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "poitou",
      "name": "Poitou",
      "regionId": "france",
      "adjacencies": [
        "anjou",
        "auvergne",
        "gascony",
        "toulouse"
      ],
      "shape": "M 94 877.5 L 95.5 875 L 95.5 794 L 99.5 791 L 98.5 785 L 105.5 776 L 104.5 765 L 105 764.5 L 115 763.5 L 135 772.5 L 161 776.5 L 182.5 771 L 182.5 772 L 191.5 791 L 192.5 801 L 200.5 811 L 202.5 819 L 198.5 847 L 178 872.5 L 177 871.5 L 164 872.5 L 160.5 876 L 156.5 892 L 150 895.5 L 129 895.5 L 110 881.5 Z M 101.5 796 L 102.5 793 L 100.5 793 L 101 796.5 Z",
      "position": {
        "x": 143.93,
        "y": 828.65
      },
      "badgeAnchor": {
        "x": 143.93,
        "y": 828.65
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "provence",
      "name": "Provence",
      "regionId": "france",
      "adjacencies": [
        "burgundy",
        "languedoc",
        "piedmont",
        "vaud",
        "corsica"
      ],
      "shape": "M 356.5 941 L 357.5 940 L 360.5 931 L 360.5 896 L 353.5 818 L 359 811.5 L 387.5 797 L 398.5 772 L 399 771.5 L 411 764.5 L 420 765.5 L 423.5 773 L 422.5 782 L 432.5 792 L 433.5 797 L 432 798.5 L 426.5 806 L 436.5 830 L 430 839.5 L 421 841.5 L 418.5 847 L 432.5 860 L 432.5 866 L 425.5 876 L 427.5 889 L 447 898.5 L 455 897.5 L 458.5 902 L 444.5 922 L 444.5 926 L 439 932.5 L 436 931.5 L 425 940.5 L 414 943.5 L 412.5 951 L 407 955.5 L 371 956.5 L 365.5 952 L 365.5 945 Z",
      "position": {
        "x": 396.31,
        "y": 871.68
      },
      "badgeAnchor": {
        "x": 396.31,
        "y": 871.68
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "languedoc",
      "name": "Languedoc",
      "regionId": "france",
      "adjacencies": [
        "burgundy",
        "provence",
        "toulouse",
        "auvergne"
      ],
      "shape": "M 357 940.5 L 352 940.5 L 348 935.5 L 317 935.5 L 315 932.5 L 306 931.5 L 302 935.5 L 274 935.5 L 273.5 935 L 273.5 928 L 284.5 918 L 284.5 906 L 280.5 897 L 281.5 882 L 275.5 829 L 278 826.5 L 284 824.5 L 298 834.5 L 325 834.5 L 353.5 822 L 353.5 823 L 358.5 855 L 360.5 896 L 360.5 931 Z",
      "position": {
        "x": 320.66,
        "y": 883.03
      },
      "badgeAnchor": {
        "x": 320.66,
        "y": 883.03
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "toulouse",
      "name": "Toulouse",
      "regionId": "france",
      "adjacencies": [
        "auvergne",
        "basque-country",
        "catalonia",
        "gascony",
        "languedoc",
        "poitou"
      ],
      "shape": "M 200.5 981 L 200.5 979 L 201.5 978 L 201.5 977 L 200.5 976 L 200.5 975 L 197.5 972 L 197.5 971 L 198.5 970 L 201.5 955 L 212.5 940 L 212.5 926 L 197.5 901 L 180.5 884 L 178.5 872 L 186.5 864 L 198.5 847 L 202.5 818 L 203 817.5 L 220 825.5 L 241 829.5 L 252 834.5 L 261 834.5 L 275 828.5 L 276.5 830 L 277.5 861 L 281.5 882 L 280.5 897 L 284.5 906 L 284.5 918 L 273.5 928 L 272.5 936 L 262.5 944 L 263.5 949 L 259.5 953 L 260 986.5 L 231 991.5 L 224 987.5 L 212 987.5 Z",
      "position": {
        "x": 235.71,
        "y": 900.09
      },
      "badgeAnchor": {
        "x": 235.71,
        "y": 900.09
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "gascony",
      "name": "Gascony",
      "regionId": "france",
      "adjacencies": [
        "asturias",
        "basque-country",
        "poitou",
        "toulouse"
      ],
      "shape": "M 197 971.5 L 177 964.5 L 162 955.5 L 156 955.5 L 150 962.5 L 125 960.5 L 116 950.5 L 106 951.5 L 100.5 949 L 96 941.5 L 84 937.5 L 75.5 930 L 70.5 918 L 62.5 913 L 61.5 908 L 71.5 903 L 85 877.5 L 101 877.5 L 129 895.5 L 150 895.5 L 156.5 892 L 160.5 876 L 164 872.5 L 178.5 873 L 178.5 878 L 180.5 884 L 197.5 901 L 212.5 926 L 212.5 940 L 201.5 955 Z",
      "position": {
        "x": 143.26,
        "y": 922.28
      },
      "badgeAnchor": {
        "x": 143.26,
        "y": 922.28
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "corsica",
      "name": "Corsica",
      "regionId": "france",
      "adjacencies": [
        "provence",
        "tuscany"
      ],
      "shape": "M 520 1060.5 L 507.5 1057 L 504.5 1043 L 491.5 1027 L 496.5 1007 L 494.5 997 L 496.5 989 L 517 986.5 L 525 977.5 L 532.5 980 L 532.5 989 L 537.5 997 L 537.5 1014 L 534.5 1017 L 530.5 1036 L 530.5 1053 L 525 1059.5 L 521 1059.5 Z",
      "position": {
        "x": 515.52,
        "y": 1017.62
      },
      "badgeAnchor": {
        "x": 515.52,
        "y": 1017.62
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "friesland",
      "name": "Friesland",
      "regionId": "netherlands",
      "adjacencies": [
        "hanover",
        "holland",
        "westphalia"
      ],
      "shape": "M 410 454.5 L 408.5 453 L 389.5 434 L 384.5 425 L 382.5 403 L 385 400.5 L 393.5 395 L 387.5 386 L 389 369.5 L 406 363.5 L 442 364.5 L 443 361.5 L 446 364.5 L 447 364.5 L 448 365.5 L 449 365.5 L 450 366.5 L 451 366.5 L 453.5 369 L 453.5 370 L 454.5 371 L 454.5 372 L 453.5 373 L 453.5 388 L 452.5 389 L 452.5 390 L 451.5 391 L 451.5 392 L 449.5 394 L 449.5 395 L 448.5 396 L 448.5 399 L 446.5 401 L 446.5 403 L 445.5 404 L 445.5 405 L 444 406.5 L 441 406.5 L 440 407.5 L 439 407.5 L 436.5 410 L 436.5 415 L 444.5 423 L 444.5 424 L 445.5 425 L 445.5 429 L 444.5 430 L 444.5 431 L 436.5 439 L 436.5 441 L 435.5 442 L 435.5 445 L 432 448.5 L 430 448.5 L 429 449.5 L 421 449.5 L 418 452.5 L 413 452.5 L 412 453.5 L 411 453.5 Z",
      "position": {
        "x": 416.62,
        "y": 404.14
      },
      "badgeAnchor": {
        "x": 416.62,
        "y": 404.14
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "holland",
      "name": "Holland",
      "regionId": "netherlands",
      "adjacencies": [
        "flanders",
        "friesland",
        "wallonia",
        "westphalia"
      ],
      "shape": "M 410 519.5 L 398.5 517 L 393.5 504 L 393.5 489 L 391 486.5 L 379 484.5 L 375 486.5 L 371.5 483 L 371.5 476 L 367 472.5 L 346 474.5 L 324.5 462 L 327.5 459 L 328.5 447 L 335 445.5 L 340.5 439 L 341.5 427 L 349.5 420 L 353.5 403 L 363.5 394 L 363.5 391 L 372 389.5 L 382 402.5 L 382.5 403 L 385.5 427 L 409.5 454 L 408.5 456 L 414.5 478 L 414.5 508 Z",
      "position": {
        "x": 372.62,
        "y": 448.98
      },
      "badgeAnchor": {
        "x": 372.62,
        "y": 448.98
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "flanders",
      "name": "Flanders",
      "regionId": "belgium",
      "adjacencies": [
        "champagne",
        "holland",
        "wallonia",
        "picardy"
      ],
      "shape": "M 327 538.5 L 325 538.5 L 317 529.5 L 308.5 526 L 308.5 516 L 304 511.5 L 292 509.5 L 285.5 503 L 285 484.5 L 299 478.5 L 315 465.5 L 322 462.5 L 327 464.5 L 346 474.5 L 367 472.5 L 371.5 476 L 371.5 483 L 375.5 487 L 371.5 507 L 363 512.5 L 346 516.5 L 337.5 532 Z",
      "position": {
        "x": 329.82,
        "y": 496.45
      },
      "badgeAnchor": {
        "x": 329.82,
        "y": 496.45
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "wallonia",
      "name": "Wallonia",
      "regionId": "belgium",
      "adjacencies": [
        "champagne",
        "flanders",
        "holland",
        "rhineland",
        "westphalia",
        "picardy"
      ],
      "shape": "M 393 586.5 L 384 586.5 L 363 568.5 L 338 561.5 L 330.5 552 L 326.5 541 L 328 537.5 L 337.5 532 L 346 516.5 L 363 512.5 L 371.5 507 L 376 486.5 L 377 486.5 L 379 484.5 L 391 486.5 L 393.5 489 L 393.5 504 L 398.5 517 L 411.5 521 L 412.5 526 L 418 530.5 L 418.5 531 L 420.5 537 L 417.5 545 L 398.5 561 L 396.5 571 L 399.5 577 Z",
      "position": {
        "x": 374.81,
        "y": 540.27
      },
      "badgeAnchor": {
        "x": 374.81,
        "y": 540.27
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "vaud",
      "name": "Vaud",
      "regionId": "switzerland",
      "adjacencies": [
        "burgundy",
        "lorraine",
        "piedmont",
        "provence",
        "swabia",
        "zurich"
      ],
      "shape": "M 433.5 796 L 433.5 795 L 422.5 782 L 423.5 773 L 420 765.5 L 411 764.5 L 398.5 771 L 398.5 770 L 396.5 762 L 402 751.5 L 403 751.5 L 412.5 744 L 412.5 738 L 430.5 719 L 431.5 713 L 437 706.5 L 447 710.5 L 458 699.5 L 459 700.5 L 494.5 701 L 494.5 707 L 484.5 717 L 484.5 764 L 486.5 769 L 478.5 777 L 478.5 783 L 467 794.5 Z",
      "position": {
        "x": 451.69,
        "y": 749.33
      },
      "badgeAnchor": {
        "x": 451.69,
        "y": 749.33
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "zurich",
      "name": "Zürich",
      "regionId": "switzerland",
      "adjacencies": [
        "lombardy",
        "piedmont",
        "swabia",
        "tyrol",
        "vaud"
      ],
      "shape": "M 513 794.5 L 510 794.5 L 497.5 785 L 491.5 772 L 486.5 768 L 486.5 767 L 484.5 764 L 484.5 717 L 494.5 707 L 494.5 700 L 499 695.5 L 517 695.5 L 532 700.5 L 538 707.5 L 543 703.5 L 552.5 707 L 550.5 710 L 554.5 742 L 559.5 759 L 558 759.5 L 555.5 762 L 555 773.5 L 546 772.5 L 538 776.5 L 529 769.5 Z",
      "position": {
        "x": 518.17,
        "y": 740.08
      },
      "badgeAnchor": {
        "x": 518.17,
        "y": 740.08
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "rogaland",
      "name": "Rogaland",
      "regionId": "norway",
      "adjacencies": [
        "viken",
        "grampian"
      ],
      "shape": "M 484 -0.5 L 484.5 0 L 487.5 20 L 486.5 40 L 481.5 55 L 471.5 67 L 470 91.5 L 465 91.5 L 462 93.5 L 443 91.5 L 433.5 77 L 428 76.5 L 421.5 69 L 417.5 60 L 416.5 40 L 423.5 33 L 427.5 20 L 422 14.5 L 408 15.5 L 402.5 5 L 399.5 4 L 399.5 0 Z",
      "position": {
        "x": 452.55,
        "y": 41.43
      },
      "badgeAnchor": {
        "x": 452.55,
        "y": 41.43
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "viken",
      "name": "Viken",
      "regionId": "norway",
      "adjacencies": [
        "rogaland",
        "vastergotland",
        "jutland"
      ],
      "shape": "M 471 91.5 L 470.5 91 L 471.5 67 L 481.5 55 L 486.5 40 L 485 -0.5 L 600 -0.5 L 600.5 0 L 602.5 28 L 600.5 38 L 595 44.5 L 585 38.5 L 579 39.5 L 578 35.5 L 575 36.5 L 572.5 33 L 571.5 21 L 566 17.5 L 563.5 33 L 558 37.5 L 550 38.5 L 545 43.5 L 538 44.5 L 527.5 60 L 514.5 72 L 513.5 77 L 503 86.5 Z",
      "position": {
        "x": 522.49,
        "y": 34.27
      },
      "badgeAnchor": {
        "x": 522.49,
        "y": 34.27
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jutland",
      "name": "Jutland",
      "regionId": "denmark",
      "adjacencies": [
        "schleswig",
        "viken",
        "zealand"
      ],
      "shape": "M 489.5 215 L 489.5 213 L 483.5 205 L 483.5 187 L 494.5 178 L 496.5 152 L 506 145.5 L 531 146.5 L 535.5 143 L 540 129.5 L 564 125.5 L 564.5 152 L 556.5 179 L 580 180.5 L 585.5 185 L 585.5 211 L 583 213.5 L 575 212.5 L 566 215.5 L 565.5 214 L 560 210.5 L 548 210.5 L 529 216.5 Z M 579.5 189 L 579 184.5 L 571.5 185 L 579 189.5 Z",
      "position": {
        "x": 530.78,
        "y": 180.82
      },
      "badgeAnchor": {
        "x": 530.78,
        "y": 180.82
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "schleswig",
      "name": "Schleswig",
      "regionId": "denmark",
      "adjacencies": [
        "holstein",
        "jutland",
        "zealand"
      ],
      "shape": "M 506 280.5 L 505.5 261 L 489.5 241 L 489.5 216 L 490 215.5 L 529 216.5 L 548 210.5 L 560 210.5 L 565.5 216 L 563 218.5 L 556.5 230 L 572 230.5 L 576.5 234 L 578.5 252 L 576.5 253 L 576.5 270 L 564 271.5 L 561 265.5 L 554.5 262 L 554.5 258 L 547 253.5 L 540.5 257 L 539.5 268 L 544.5 274 L 545.5 281 L 535 281.5 L 524 283.5 Z",
      "position": {
        "x": 528.71,
        "y": 242.99
      },
      "badgeAnchor": {
        "x": 528.71,
        "y": 242.99
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "zealand",
      "name": "Zealand",
      "regionId": "denmark",
      "adjacencies": [
        "jutland",
        "schleswig",
        "scania"
      ],
      "shape": "M 603 294.5 L 596 292.5 L 587.5 283 L 590 275.5 L 606.5 275 L 604.5 269 L 595.5 260 L 589.5 246 L 589.5 240 L 599.5 226 L 598.5 219 L 614 206.5 L 625 206.5 L 629.5 215 L 627.5 240 L 633.5 249 L 632.5 259 L 625.5 266 L 625.5 270 L 630.5 275 L 627.5 286 L 621 292.5 L 603.5 294 Z",
      "position": {
        "x": 612.49,
        "y": 245.93
      },
      "badgeAnchor": {
        "x": 612.49,
        "y": 245.93
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "svealand",
      "name": "Svealand",
      "regionId": "sweden",
      "adjacencies": [
        "ostergotland",
        "vastergotland"
      ],
      "shape": "M 663 58.5 L 662.5 57 L 652.5 35 L 641.5 22 L 635 -0.5 L 732 -0.5 L 733.5 5 L 740.5 8 L 740.5 10 L 731 24.5 L 725 24.5 L 719.5 29 L 717.5 36 L 707.5 46 L 704 53.5 L 691 57.5 Z",
      "position": {
        "x": 684.71,
        "y": 24.92
      },
      "badgeAnchor": {
        "x": 684.71,
        "y": 24.92
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "vastergotland",
      "name": "Västergötland",
      "regionId": "sweden",
      "adjacencies": [
        "ostergotland",
        "scania",
        "svealand",
        "viken"
      ],
      "shape": "M 625 165.5 L 624.5 165 L 618.5 158 L 618.5 150 L 615.5 147 L 615.5 129 L 608.5 123 L 608.5 118 L 601.5 107 L 602.5 102 L 597 100.5 L 592 91.5 L 585.5 89 L 584.5 60 L 578.5 53 L 578.5 42 L 582 39.5 L 585 38.5 L 595 44.5 L 600.5 38 L 602.5 28 L 599.5 11 L 601 -0.5 L 634 -0.5 L 634.5 0 L 641.5 22 L 652.5 35 L 662.5 59 L 661.5 60 L 659.5 107 L 666.5 125 L 675.5 133 L 675.5 135 L 666 146.5 Z",
      "position": {
        "x": 625.42,
        "y": 76.15
      },
      "badgeAnchor": {
        "x": 625.42,
        "y": 76.15
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ostergotland",
      "name": "Östergötland",
      "regionId": "sweden",
      "adjacencies": [
        "scania",
        "svealand",
        "vastergotland"
      ],
      "shape": "M 671 128.5 L 666.5 125 L 659.5 107 L 659.5 70 L 664 57.5 L 691 57.5 L 704 53.5 L 707.5 46 L 717.5 36 L 719.5 29 L 725 24.5 L 731 24.5 L 736.5 19 L 740.5 9 L 742 9.5 L 773 10.5 L 779 8.5 L 784.5 3 L 784 -0.5 L 793 -0.5 L 792 1.5 L 798 2.5 L 801.5 7 L 800 14.5 L 787 22.5 L 780 23.5 L 779.5 27 L 772.5 31 L 772.5 37 L 766 43.5 L 761 43.5 L 756.5 50 L 756.5 102 L 750.5 119 L 750.5 127 L 750 127.5 L 739 127.5 L 727 131.5 L 684 130.5 L 679 133.5 Z",
      "position": {
        "x": 720.58,
        "y": 81.3
      },
      "badgeAnchor": {
        "x": 720.58,
        "y": 81.3
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "scania",
      "name": "Scania",
      "regionId": "sweden",
      "adjacencies": [
        "ostergotland",
        "vastergotland",
        "zealand"
      ],
      "shape": "M 625.5 165 L 626 164.5 L 644 158.5 L 666 146.5 L 675.5 134 L 676 133.5 L 684 130.5 L 727 131.5 L 739 127.5 L 750.5 128 L 750.5 139 L 747.5 143 L 747.5 190 L 744.5 197 L 742 199.5 L 717 200.5 L 694 209.5 L 689.5 214 L 690.5 237 L 686 241.5 L 677 243.5 L 676.5 247 L 670 251.5 L 655 251.5 L 649.5 246 L 649.5 225 L 646.5 218 L 632.5 203 L 637.5 187 L 634.5 180 L 627.5 175 Z",
      "position": {
        "x": 689.05,
        "y": 179.41
      },
      "badgeAnchor": {
        "x": 689.05,
        "y": 179.41
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "holstein",
      "name": "Holstein",
      "regionId": "germany",
      "adjacencies": [
        "brandenburg",
        "hanover",
        "mecklenburg",
        "schleswig",
        "thuringia"
      ],
      "shape": "M 539.5 422 L 539.5 421 L 520.5 391 L 517.5 365 L 500.5 346 L 503.5 337 L 510.5 329 L 504.5 281 L 515 280.5 L 524 283.5 L 546 281.5 L 546.5 290 L 560 304.5 L 565 307.5 L 571 306.5 L 576 310.5 L 584 310.5 L 587.5 314 L 586.5 322 L 589.5 325 L 589.5 331 L 588.5 332 L 588.5 333 L 586.5 335 L 586.5 336 L 582.5 340 L 582.5 341 L 581.5 342 L 581.5 347 L 582.5 348 L 582.5 376 L 581.5 377 L 581.5 383 L 583.5 385 L 583.5 387 L 582.5 388 L 582.5 390 L 580.5 392 L 580.5 396 L 578.5 398 L 578.5 400 L 577.5 401 L 577.5 402 L 575.5 404 L 575.5 405 L 572.5 408 L 572.5 409 L 571.5 410 L 571.5 412 L 570.5 413 L 570.5 414 L 564.5 420 L 564.5 422 L 564 422.5 L 563 422.5 Z",
      "position": {
        "x": 545.94,
        "y": 350.29
      },
      "badgeAnchor": {
        "x": 545.94,
        "y": 350.29
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mecklenburg",
      "name": "Mecklenburg",
      "regionId": "germany",
      "adjacencies": [
        "brandenburg",
        "holstein",
        "pomerania",
        "saxony"
      ],
      "shape": "M 664 407.5 L 662 407.5 L 654.5 396 L 648 391.5 L 635 391.5 L 620 387.5 L 584 386.5 L 583.5 385 L 581.5 383 L 581.5 342 L 589 331.5 L 597 331.5 L 609 331.5 L 610.5 326 L 618.5 320 L 621.5 310 L 629 304.5 L 637 302.5 L 654 306.5 L 656 303.5 L 661 303.5 L 666.5 308 L 667.5 315 L 677 325.5 L 692 327.5 L 696.5 333 L 695.5 337 L 694.5 345 L 700.5 371 L 692.5 389 L 692 389.5 L 682 392.5 Z M 683.5 329 L 679.5 329 L 683 329.5 Z",
      "position": {
        "x": 642.75,
        "y": 354.42
      },
      "badgeAnchor": {
        "x": 642.75,
        "y": 354.42
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hanover",
      "name": "Hanover",
      "regionId": "germany",
      "adjacencies": [
        "friesland",
        "holstein",
        "thuringia",
        "westphalia"
      ],
      "shape": "M 490 447.5 L 445 445.5 L 441 447.5 L 436 445.5 L 435.5 445 L 436.5 439 L 445.5 429 L 444.5 423 L 436.5 415 L 436.5 410 L 445.5 405 L 453.5 388 L 454.5 371 L 442.5 361 L 446.5 356 L 446.5 350 L 451.5 347 L 453.5 340 L 458 336.5 L 475 336.5 L 479 340.5 L 486 340.5 L 489 351.5 L 495 351.5 L 498 346.5 L 501 346.5 L 504.5 350 L 518.5 367 L 520.5 391 L 539.5 423 L 533 429.5 L 497 439.5 Z",
      "position": {
        "x": 484.15,
        "y": 397.27
      },
      "badgeAnchor": {
        "x": 484.15,
        "y": 397.27
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "brandenburg",
      "name": "Brandenburg",
      "regionId": "germany",
      "adjacencies": [
        "holstein",
        "mecklenburg",
        "saxony",
        "thuringia"
      ],
      "shape": "M 638 462.5 L 636 461.5 L 635 461.5 L 634 460.5 L 633 460.5 L 631 458.5 L 630 458.5 L 629 457.5 L 625 457.5 L 624 456.5 L 622 456.5 L 621 455.5 L 618 455.5 L 617 454.5 L 616 454.5 L 615 453.5 L 614 453.5 L 613 452.5 L 610 452.5 L 609 453.5 L 603 453.5 L 602 452.5 L 600 452.5 L 599 451.5 L 598 451.5 L 593 446.5 L 591 446.5 L 589 444.5 L 588 444.5 L 586.5 443 L 586.5 442 L 583 438.5 L 581 438.5 L 580 437.5 L 579 437.5 L 574.5 433 L 574.5 432 L 573.5 431 L 573.5 430 L 567 423.5 L 566 423.5 L 564.5 422 L 564.5 420 L 570.5 414 L 570.5 413 L 571.5 412 L 571.5 410 L 572.5 409 L 572.5 408 L 575.5 405 L 575.5 404 L 577.5 402 L 577.5 401 L 578.5 400 L 578.5 398 L 580.5 396 L 580.5 392 L 582.5 390 L 582.5 388 L 585 385.5 L 648 391.5 L 663 407.5 L 663.5 408 L 661.5 424 L 663.5 437 L 660.5 444 L 649 458.5 Z",
      "position": {
        "x": 619.02,
        "y": 421.61
      },
      "badgeAnchor": {
        "x": 619.02,
        "y": 421.61
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "thuringia",
      "name": "Thuringia",
      "regionId": "germany",
      "adjacencies": [
        "brandenburg",
        "franconia",
        "hanover",
        "hesse",
        "holstein",
        "saxony",
        "westphalia"
      ],
      "shape": "M 592 491.5 L 581 484.5 L 526 486.5 L 498.5 480 L 498.5 479 L 497.5 472 L 501.5 462 L 490.5 448 L 491.5 446 L 497 439.5 L 524 433.5 L 533 429.5 L 540 422.5 L 565 422.5 L 566 423.5 L 567 423.5 L 573.5 430 L 573.5 431 L 574.5 432 L 574.5 433 L 579 437.5 L 580 437.5 L 581 438.5 L 583 438.5 L 586.5 442 L 586.5 443 L 588 444.5 L 589 444.5 L 591 446.5 L 593 446.5 L 598 451.5 L 599 451.5 L 600 452.5 L 602 452.5 L 603 453.5 L 609 453.5 L 610 452.5 L 613 452.5 L 614 453.5 L 615 453.5 L 616 454.5 L 617 454.5 L 618 455.5 L 621 455.5 L 622 456.5 L 624 456.5 L 625 457.5 L 629 457.5 L 630 458.5 L 631 458.5 L 633 460.5 L 634 460.5 L 635 461.5 L 636 461.5 L 637.5 463 L 636.5 464 L 636.5 466 L 634.5 468 L 634.5 470 L 633.5 471 L 633.5 473 L 632.5 474 L 632.5 476 L 631.5 477 L 631.5 478 L 630.5 479 L 630.5 481 L 629.5 482 L 629.5 485 L 628.5 486 L 628.5 487 L 627.5 488 L 627.5 490 L 627 490.5 L 625 490.5 Z",
      "position": {
        "x": 558.41,
        "y": 460.12
      },
      "badgeAnchor": {
        "x": 558.41,
        "y": 460.12
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "saxony",
      "name": "Saxony",
      "regionId": "germany",
      "adjacencies": [
        "bohemia",
        "brandenburg",
        "franconia",
        "greater-poland",
        "mecklenburg",
        "moravia",
        "pomerania",
        "thuringia"
      ],
      "shape": "M 659 506.5 L 658 506.5 L 657 505.5 L 653 505.5 L 652 504.5 L 647 504.5 L 646 503.5 L 645 503.5 L 644 502.5 L 641 502.5 L 640 503.5 L 639 503.5 L 638 502.5 L 636 502.5 L 635 501.5 L 634 501.5 L 632 499.5 L 631 499.5 L 629.5 498 L 629.5 496 L 630.5 495 L 629.5 494 L 629.5 493 L 628.5 492 L 628.5 491 L 627.5 490 L 627.5 488 L 628.5 487 L 628.5 486 L 629.5 485 L 629.5 482 L 630.5 481 L 630.5 479 L 631.5 478 L 631.5 477 L 632.5 476 L 632.5 474 L 633.5 473 L 633.5 471 L 634.5 470 L 634.5 468 L 636.5 466 L 636.5 464 L 639 461.5 L 649 458.5 L 658.5 448 L 663.5 437 L 661.5 424 L 663.5 408 L 668 403.5 L 684 391.5 L 692 389.5 L 694.5 392 L 712.5 411 L 712.5 415 L 710.5 419 L 718.5 435 L 714.5 456 L 719.5 468 L 727.5 474 L 725 487.5 L 711 494.5 L 706 494.5 L 684 499.5 L 670 509.5 L 662 509.5 Z",
      "position": {
        "x": 681.02,
        "y": 457.54
      },
      "badgeAnchor": {
        "x": 681.02,
        "y": 457.54
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "westphalia",
      "name": "Westphalia",
      "regionId": "germany",
      "adjacencies": [
        "friesland",
        "hanover",
        "hesse",
        "holland",
        "rhineland",
        "thuringia",
        "wallonia"
      ],
      "shape": "M 419 530.5 L 417 530.5 L 410.5 520 L 411.5 518 L 411.5 516 L 412.5 515 L 412.5 513 L 413.5 512 L 413.5 509 L 414.5 508 L 414.5 506 L 413.5 505 L 413.5 485 L 414.5 484 L 414.5 478 L 413.5 477 L 413.5 471 L 411.5 469 L 411.5 468 L 409.5 466 L 409.5 461 L 408.5 460 L 408.5 456 L 411 453.5 L 412 453.5 L 413 452.5 L 418 452.5 L 421 449.5 L 429 449.5 L 430 448.5 L 432 448.5 L 435 445.5 L 437 445.5 L 441 447.5 L 445 445.5 L 490 447.5 L 498.5 456 L 498.5 457 L 499.5 458 L 499.5 459 L 500.5 460 L 500.5 461 L 501.5 462 L 501.5 465 L 500.5 466 L 500.5 468 L 498.5 470 L 498.5 471 L 497.5 472 L 497.5 478 L 498.5 479 L 498.5 502 L 497.5 503 L 497.5 510 L 498.5 511 L 498.5 524 L 497.5 525 L 497.5 530 L 496 531.5 L 494 531.5 L 452 532.5 L 433 528.5 Z",
      "position": {
        "x": 456.27,
        "y": 489.04
      },
      "badgeAnchor": {
        "x": 456.27,
        "y": 489.04
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hesse",
      "name": "Hesse",
      "regionId": "germany",
      "adjacencies": [
        "franconia",
        "rhineland",
        "thuringia",
        "westphalia"
      ],
      "shape": "M 546 588.5 L 545 587.5 L 544 587.5 L 534 577.5 L 533 577.5 L 528 572.5 L 526 572.5 L 525 571.5 L 521 571.5 L 520 570.5 L 519 570.5 L 517 568.5 L 516 568.5 L 515 567.5 L 514 567.5 L 509.5 563 L 509.5 562 L 508.5 561 L 508.5 557 L 505.5 554 L 505.5 553 L 506.5 552 L 506.5 551 L 507.5 550 L 507.5 538 L 506.5 537 L 506.5 536 L 506 535.5 L 502 535.5 L 501 534.5 L 500 534.5 L 496.5 531 L 497.5 530 L 497.5 525 L 498.5 524 L 498.5 511 L 497.5 510 L 497.5 503 L 498.5 502 L 498.5 481 L 499 480.5 L 526 486.5 L 581 484.5 L 593 491.5 L 593.5 492 L 595.5 546 L 585 550.5 L 558 553.5 L 550.5 567 L 553.5 576 Z",
      "position": {
        "x": 545.29,
        "y": 523.59
      },
      "badgeAnchor": {
        "x": 545.29,
        "y": 523.59
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "franconia",
      "name": "Franconia",
      "regionId": "germany",
      "adjacencies": [
        "bavaria",
        "bohemia",
        "hesse",
        "rhineland",
        "saxony",
        "swabia",
        "thuringia"
      ],
      "shape": "M 608 629.5 L 594 628.5 L 580.5 618 L 575 609.5 L 560 610.5 L 553.5 604 L 546.5 588 L 547.5 587 L 553.5 576 L 550.5 567 L 558 553.5 L 585 550.5 L 595.5 546 L 594 491.5 L 624 491.5 L 628 490.5 L 628.5 491 L 629.5 498 L 634 501.5 L 657 505.5 L 661.5 509 L 658 513.5 L 645.5 522 L 632.5 547 L 641.5 558 L 640.5 563 L 649 589.5 L 627 593.5 L 611.5 612 L 608.5 629 Z",
      "position": {
        "x": 602.12,
        "y": 564.15
      },
      "badgeAnchor": {
        "x": 602.12,
        "y": 564.15
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "rhineland",
      "name": "Rhineland",
      "regionId": "germany",
      "adjacencies": [
        "champagne",
        "franconia",
        "hesse",
        "lorraine",
        "swabia",
        "wallonia",
        "westphalia"
      ],
      "shape": "M 482 623.5 L 481 622.5 L 473 616.5 L 463 616.5 L 455 610.5 L 443 610.5 L 438 606.5 L 429 605.5 L 427.5 604 L 419 593.5 L 411 589.5 L 401 591.5 L 393.5 586 L 394.5 585 L 399.5 577 L 396.5 571 L 398.5 561 L 417.5 545 L 420 529.5 L 433 528.5 L 452 532.5 L 497 531.5 L 500 534.5 L 507.5 538 L 505.5 554 L 509.5 563 L 519 570.5 L 528 572.5 L 546.5 589 L 546.5 590 L 559.5 610 L 559.5 612 L 552.5 628 L 544 633.5 L 521 634.5 L 507 627.5 Z",
      "position": {
        "x": 476.3,
        "y": 580.71
      },
      "badgeAnchor": {
        "x": 476.3,
        "y": 580.71
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "bavaria",
      "name": "Bavaria",
      "regionId": "germany",
      "adjacencies": [
        "bohemia",
        "franconia",
        "salzburg",
        "swabia",
        "tyrol",
        "upper-austria"
      ],
      "shape": "M 593.5 706 L 593.5 703 L 594.5 680 L 610 671.5 L 615.5 665 L 608.5 630 L 608.5 628 L 611.5 612 L 627 593.5 L 641 589.5 L 650.5 591 L 653.5 597 L 675 617.5 L 692.5 629 L 695.5 640 L 689 650.5 L 688 650.5 L 683 658.5 L 676 658.5 L 659.5 667 L 670.5 692 L 668 699.5 L 657 693.5 L 643 692.5 L 639 695.5 L 619 699.5 L 604 707.5 Z",
      "position": {
        "x": 642.21,
        "y": 645.18
      },
      "badgeAnchor": {
        "x": 642.21,
        "y": 645.18
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "swabia",
      "name": "Swabia",
      "regionId": "germany",
      "adjacencies": [
        "bavaria",
        "franconia",
        "lorraine",
        "rhineland",
        "tyrol",
        "vaud",
        "zurich"
      ],
      "shape": "M 550 704.5 L 543 703.5 L 538 707.5 L 528 698.5 L 505 694.5 L 499 695.5 L 494 700.5 L 471 701.5 L 459 700.5 L 456.5 698 L 454.5 690 L 458.5 670 L 466.5 659 L 470.5 639 L 479.5 631 L 483 623.5 L 487 623.5 L 507 627.5 L 521 634.5 L 544 633.5 L 552.5 628 L 559.5 611 L 561 609.5 L 575 609.5 L 580.5 618 L 594 628.5 L 609.5 631 L 615.5 665 L 610 671.5 L 594.5 680 L 593.5 705 L 593 705.5 L 574 702.5 L 567 712.5 L 558 713.5 Z",
      "position": {
        "x": 537.37,
        "y": 663.75
      },
      "badgeAnchor": {
        "x": 537.37,
        "y": 663.75
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "venetia",
      "name": "Venetia",
      "regionId": "italy",
      "adjacencies": [
        "littoral",
        "lombardy",
        "papal-states",
        "salzburg",
        "tuscany",
        "tyrol"
      ],
      "shape": "M 627 888.5 L 596 886.5 L 595.5 886 L 595.5 845 L 599.5 838 L 599.5 821 L 598.5 787 L 591.5 748 L 595.5 737 L 600 733.5 L 622 735.5 L 627 732.5 L 637 732.5 L 639.5 735 L 639.5 740 L 652 751.5 L 692 758.5 L 694.5 761 L 694.5 763 L 687.5 775 L 698.5 792 L 701.5 803 L 700 806.5 L 689 806.5 L 687.5 808 L 687.5 811 L 687 811.5 L 685 811.5 L 684 812.5 L 683 812.5 L 682 811.5 L 678 811.5 L 677 812.5 L 676 812.5 L 675 813.5 L 674 813.5 L 673 814.5 L 664 814.5 L 663 815.5 L 660 815.5 L 659 814.5 L 656 817.5 L 654 817.5 L 652.5 819 L 652.5 868 L 655.5 871 L 655.5 873 L 656.5 874 L 656.5 878 L 655.5 879 L 656.5 880 L 656.5 885 L 656 885.5 L 654 885.5 L 653 886.5 L 650 886.5 L 649 887.5 L 631 887.5 L 630 888.5 Z",
      "position": {
        "x": 644.55,
        "y": 791.95
      },
      "badgeAnchor": {
        "x": 644.55,
        "y": 791.95
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "lombardy",
      "name": "Lombardy",
      "regionId": "italy",
      "adjacencies": [
        "piedmont",
        "tuscany",
        "tyrol",
        "venetia",
        "zurich"
      ],
      "shape": "M 543 892.5 L 539 892.5 L 533 886.5 L 520 886.5 L 519.5 886 L 518.5 810 L 512.5 795 L 513.5 794 L 529 769.5 L 538 776.5 L 546 772.5 L 555 773.5 L 555.5 762 L 563 759.5 L 568.5 759 L 571 745.5 L 579 745.5 L 584 749.5 L 592 748.5 L 592.5 749 L 592.5 750 L 593.5 751 L 593.5 760 L 594.5 761 L 594.5 764 L 595.5 765 L 595.5 769 L 596.5 770 L 596.5 782 L 597.5 783 L 597.5 786 L 598.5 787 L 598.5 799 L 597.5 800 L 597.5 804 L 598.5 805 L 598.5 820 L 599.5 821 L 599.5 838 L 598.5 839 L 598.5 841 L 596.5 843 L 596.5 844 L 595.5 845 L 595.5 886 L 595 886.5 L 594 886.5 L 593 887.5 L 550 887.5 L 549 888.5 L 548 888.5 L 547 889.5 L 546 889.5 Z",
      "position": {
        "x": 559.23,
        "y": 825.97
      },
      "badgeAnchor": {
        "x": 559.23,
        "y": 825.97
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "piedmont",
      "name": "Piedmont",
      "regionId": "italy",
      "adjacencies": [
        "lombardy",
        "provence",
        "vaud",
        "zurich"
      ],
      "shape": "M 444.5 922 L 458.5 902 L 455 897.5 L 447 898.5 L 427.5 889 L 425.5 876 L 432.5 866 L 432.5 860 L 418.5 847 L 421 841.5 L 430 839.5 L 436.5 830 L 426.5 806 L 426.5 803 L 434 796.5 L 453 793.5 L 464 795.5 L 471 792.5 L 478.5 783 L 478.5 777 L 487 768.5 L 488 769.5 L 497.5 785 L 512 794.5 L 513.5 796 L 518.5 810 L 519 886.5 L 509 886.5 L 488.5 898 L 471 926.5 L 451 927.5 L 447 926.5 Z",
      "position": {
        "x": 474.56,
        "y": 846.09
      },
      "badgeAnchor": {
        "x": 474.56,
        "y": 846.09
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tuscany",
      "name": "Tuscany",
      "regionId": "italy",
      "adjacencies": [
        "campania",
        "lombardy",
        "papal-states",
        "venetia",
        "corsica"
      ],
      "shape": "M 605 991.5 L 602.5 990 L 602.5 984 L 602 983.5 L 600 983.5 L 599 984.5 L 598 984.5 L 597 983.5 L 595 983.5 L 594 982.5 L 593 982.5 L 590.5 980 L 590.5 972 L 591.5 971 L 591.5 970 L 590.5 969 L 590.5 968 L 590 967.5 L 589 967.5 L 587.5 966 L 587.5 965 L 587 964.5 L 581 964.5 L 580 963.5 L 579 963.5 L 578 962.5 L 576 962.5 L 573.5 960 L 573.5 957 L 574.5 956 L 574.5 954 L 572.5 952 L 572.5 949 L 573.5 948 L 571.5 946 L 571.5 945 L 571 944.5 L 569 944.5 L 564.5 940 L 564.5 936 L 562.5 934 L 562.5 923 L 562 922.5 L 561 922.5 L 560 921.5 L 559 921.5 L 557.5 920 L 557.5 913 L 556.5 912 L 556.5 909 L 558.5 907 L 558.5 906 L 557 904.5 L 555 904.5 L 554 903.5 L 550 903.5 L 549 902.5 L 548 902.5 L 546.5 901 L 546.5 899 L 545.5 898 L 545.5 895 L 544 893.5 L 543 893.5 L 542.5 893 L 546 889.5 L 547 889.5 L 548 888.5 L 549 888.5 L 550 887.5 L 593 887.5 L 594 886.5 L 597 886.5 L 628 888.5 L 628.5 889 L 628.5 969 L 632.5 978 L 631.5 979 L 622 988.5 L 611 988.5 Z M 563.5 917 L 563 914.5 L 561.5 916 L 563 917.5 Z",
      "position": {
        "x": 597.78,
        "y": 929.98
      },
      "badgeAnchor": {
        "x": 597.78,
        "y": 929.98
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "papal-states",
      "name": "Papal States",
      "regionId": "italy",
      "adjacencies": [
        "apulia",
        "campania",
        "tuscany",
        "venetia"
      ],
      "shape": "M 730 1011.5 L 729 1010.5 L 709 1010.5 L 675 1002.5 L 657 990.5 L 645 988.5 L 633 978.5 L 631.5 977 L 631.5 976 L 630.5 975 L 630.5 973 L 629.5 972 L 629.5 970 L 628.5 969 L 628.5 889 L 629 888.5 L 630 888.5 L 631 887.5 L 649 887.5 L 650 886.5 L 653 886.5 L 654 885.5 L 657 885.5 L 657.5 886 L 657.5 891 L 659.5 893 L 659.5 895 L 664 899.5 L 665 899.5 L 669 903.5 L 670 903.5 L 672 905.5 L 675 905.5 L 678 908.5 L 679 908.5 L 681 910.5 L 682 910.5 L 685 913.5 L 686 913.5 L 687 914.5 L 691 914.5 L 692 915.5 L 693 915.5 L 697 919.5 L 698 919.5 L 701.5 923 L 701.5 924 L 703.5 926 L 703.5 927 L 705.5 929 L 705.5 930 L 707.5 932 L 707.5 933 L 708.5 934 L 708.5 935 L 709.5 936 L 709.5 938 L 710 938.5 L 711 938.5 L 711.5 939 L 711.5 940 L 710.5 941 L 711.5 942 L 711.5 945 L 713.5 947 L 713.5 951 L 715.5 953 L 715.5 956 L 717.5 958 L 717.5 959 L 718.5 960 L 718.5 961 L 719.5 962 L 719.5 963 L 720.5 964 L 720.5 966 L 723.5 969 L 723.5 970 L 726 972.5 L 727 972.5 L 728.5 974 L 728.5 975 L 740.5 987 L 740.5 990 L 742.5 992 L 742.5 993 L 743.5 994 L 743.5 1003 L 744.5 1004 L 743 1005.5 Z",
      "position": {
        "x": 675.5,
        "y": 955.34
      },
      "badgeAnchor": {
        "x": 675.5,
        "y": 955.34
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "campania",
      "name": "Campania",
      "regionId": "italy",
      "adjacencies": [
        "apulia",
        "papal-states",
        "tuscany"
      ],
      "shape": "M 718 1067.5 L 690 1067.5 L 676 1065.5 L 673.5 1062 L 676.5 1060 L 674 1057.5 L 669 1055.5 L 668 1058.5 L 666 1057.5 L 656.5 1046 L 656.5 1041 L 654 1038.5 L 650 1039.5 L 644.5 1034 L 644.5 1017 L 642 1014.5 L 634 1015.5 L 627.5 1011 L 627 1007.5 L 613 1004.5 L 609 997.5 L 604.5 996 L 606 990.5 L 622 988.5 L 632 978.5 L 635 978.5 L 645 988.5 L 657 990.5 L 675 1002.5 L 709 1010.5 L 730.5 1012 L 730.5 1022 L 732.5 1025 L 731.5 1055 L 721 1061.5 Z",
      "position": {
        "x": 684.62,
        "y": 1029.79
      },
      "badgeAnchor": {
        "x": 684.62,
        "y": 1029.79
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "apulia",
      "name": "Apulia",
      "regionId": "italy",
      "adjacencies": [
        "campania",
        "papal-states"
      ],
      "shape": "M 719 1067.5 L 718.5 1067 L 721 1061.5 L 731.5 1055 L 730.5 1011 L 731 1010.5 L 744 1004.5 L 749.5 1009 L 758 1015.5 L 806 1015.5 L 823.5 1029 L 824 1043.5 L 857 1056.5 L 865.5 1062 L 865.5 1067 Z",
      "position": {
        "x": 777.42,
        "y": 1041.52
      },
      "badgeAnchor": {
        "x": 777.42,
        "y": 1041.52
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "upper-austria",
      "name": "Upper Austria",
      "regionId": "austria",
      "adjacencies": [
        "bavaria",
        "bohemia",
        "czech-silesia",
        "moravia",
        "salzburg",
        "styria"
      ],
      "shape": "M 739 698.5 L 736 698.5 L 706.5 674 L 689.5 650 L 696 639.5 L 701 639.5 L 708 635.5 L 709 636.5 L 716 637.5 L 725 623.5 L 745 610.5 L 755 610.5 L 764 614.5 L 786.5 615 L 786.5 616 L 789 620.5 L 800.5 625 L 790 640.5 L 777.5 648 L 778.5 670 L 774.5 678 L 759 691.5 Z",
      "position": {
        "x": 744.49,
        "y": 652.64
      },
      "badgeAnchor": {
        "x": 744.49,
        "y": 652.64
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "styria",
      "name": "Styria",
      "regionId": "austria",
      "adjacencies": [
        "carniola",
        "czech-silesia",
        "pressburg",
        "salzburg",
        "transdanubia",
        "upper-austria"
      ],
      "shape": "M 755.5 748 L 755.5 746 L 754.5 745 L 754.5 744 L 753.5 743 L 753.5 736 L 752.5 735 L 752.5 731 L 751.5 730 L 751.5 728 L 750.5 727 L 750.5 725 L 749.5 724 L 749.5 715 L 748.5 714 L 748.5 712 L 746.5 710 L 746.5 709 L 738.5 701 L 738.5 699 L 740 697.5 L 759 691.5 L 774.5 678 L 778.5 670 L 777.5 648 L 790 640.5 L 802 623.5 L 812 622.5 L 815.5 625 L 815.5 626 L 821.5 633 L 819.5 647 L 831.5 663 L 829.5 665 L 827.5 676 L 824 679.5 L 809.5 683 L 813.5 691 L 805.5 700 L 805.5 705 L 810.5 715 L 799.5 729 L 799 729.5 L 798 729.5 L 797 730.5 L 795 730.5 L 790.5 735 L 790.5 736 L 785 741.5 L 783 741.5 L 782 742.5 L 780 742.5 L 779 743.5 L 775 743.5 L 772 746.5 L 765 746.5 L 764 747.5 L 761 747.5 L 760 748.5 L 756 748.5 Z",
      "position": {
        "x": 787.5,
        "y": 690.48
      },
      "badgeAnchor": {
        "x": 787.5,
        "y": 690.48
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "salzburg",
      "name": "Salzburg",
      "regionId": "austria",
      "adjacencies": [
        "bavaria",
        "carniola",
        "littoral",
        "styria",
        "tyrol",
        "upper-austria",
        "venetia"
      ],
      "shape": "M 695 761.5 L 692 758.5 L 652 751.5 L 639.5 740 L 639.5 735 L 643.5 731 L 645.5 712 L 644.5 704 L 639.5 696 L 641 693.5 L 657 693.5 L 668 699.5 L 670.5 692 L 659.5 667 L 676 658.5 L 683 658.5 L 690 650.5 L 692.5 653 L 692.5 654 L 694.5 656 L 694.5 657 L 695.5 658 L 695.5 661 L 706.5 672 L 706.5 674 L 711 678.5 L 712 678.5 L 720 686.5 L 721 686.5 L 726 691.5 L 727 691.5 L 729 693.5 L 730 693.5 L 734 697.5 L 735 697.5 L 736 698.5 L 738 698.5 L 738.5 699 L 738.5 701 L 746.5 709 L 746.5 710 L 748.5 712 L 748.5 714 L 749.5 715 L 749.5 724 L 750.5 725 L 750.5 727 L 751.5 728 L 751.5 730 L 752.5 731 L 752.5 735 L 753.5 736 L 753.5 743 L 754.5 744 L 754.5 745 L 755.5 746 L 755.5 749 L 754 750.5 L 753 750.5 L 752 751.5 L 745 751.5 L 744.5 752 L 744.5 753 L 740.5 757 L 734 763.5 L 716 763.5 L 708 759.5 Z",
      "position": {
        "x": 697.45,
        "y": 718.79
      },
      "badgeAnchor": {
        "x": 697.45,
        "y": 718.79
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tyrol",
      "name": "Tyrol",
      "regionId": "austria",
      "adjacencies": [
        "bavaria",
        "lombardy",
        "salzburg",
        "swabia",
        "venetia",
        "zurich"
      ],
      "shape": "M 560 759.5 L 558.5 758 L 550.5 712 L 553 707.5 L 555.5 710 L 558 713.5 L 565 713.5 L 574 702.5 L 594 706.5 L 604 707.5 L 619 699.5 L 637 695.5 L 640.5 697 L 644.5 704 L 645.5 726 L 640 734.5 L 637 732.5 L 627 732.5 L 622 735.5 L 600 733.5 L 595.5 737 L 591 748.5 L 587 748.5 L 571 745.5 L 568.5 759 Z",
      "position": {
        "x": 597.66,
        "y": 721.98
      },
      "badgeAnchor": {
        "x": 597.66,
        "y": 721.98
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "carniola",
      "name": "Carniola",
      "regionId": "slovenia",
      "adjacencies": [
        "littoral",
        "salzburg",
        "slavonia",
        "styria",
        "transdanubia"
      ],
      "shape": "M 768 805.5 L 764.5 805 L 742.5 756 L 742.5 755 L 744.5 753 L 744.5 752 L 745 751.5 L 752 751.5 L 753 750.5 L 754 750.5 L 756 748.5 L 760 748.5 L 761 747.5 L 764 747.5 L 765 746.5 L 772 746.5 L 775 743.5 L 779 743.5 L 780 742.5 L 782 742.5 L 783 741.5 L 785 741.5 L 790.5 736 L 790.5 735 L 795 730.5 L 797 730.5 L 798 729.5 L 799 729.5 L 801 731.5 L 806.5 737 L 809 747.5 L 808 747.5 L 788.5 765 L 790.5 777 L 774.5 793 L 775.5 803 L 771 806.5 Z",
      "position": {
        "x": 771.34,
        "y": 766.22
      },
      "badgeAnchor": {
        "x": 771.34,
        "y": 766.22
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "littoral",
      "name": "Littoral",
      "regionId": "slovenia",
      "adjacencies": [
        "carniola",
        "salzburg",
        "venetia",
        "zagorje"
      ],
      "shape": "M 702.5 807 L 701 808.5 L 700.5 806 L 698.5 792 L 687.5 775 L 694.5 762 L 696 760.5 L 708 759.5 L 716 763.5 L 734 763.5 L 742 755.5 L 744.5 758 L 762.5 801 L 765 805.5 L 768.5 806 L 768.5 808 L 765.5 813 L 764 814.5 L 749 815.5 L 745 812.5 L 738 812.5 L 730 817.5 L 710 821.5 L 702.5 816 Z",
      "position": {
        "x": 725.42,
        "y": 789.32
      },
      "badgeAnchor": {
        "x": 725.42,
        "y": 789.32
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "bohemia",
      "name": "Bohemia",
      "regionId": "czech-republic",
      "adjacencies": [
        "bavaria",
        "franconia",
        "moravia",
        "saxony",
        "upper-austria"
      ],
      "shape": "M 697 639.5 L 696.5 639 L 692.5 629 L 675 617.5 L 653.5 597 L 649.5 590 L 649.5 589 L 640.5 563 L 641.5 558 L 632.5 547 L 645.5 522 L 662 509.5 L 670 509.5 L 676 503.5 L 690 497.5 L 710 494.5 L 710.5 495 L 723.5 519 L 723.5 550 L 727.5 564 L 727.5 606 L 710.5 623 L 708.5 635 L 707 636.5 Z",
      "position": {
        "x": 686.47,
        "y": 560.89
      },
      "badgeAnchor": {
        "x": 686.47,
        "y": 560.89
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "moravia",
      "name": "Moravia",
      "regionId": "czech-republic",
      "adjacencies": [
        "bohemia",
        "czech-silesia",
        "greater-poland",
        "lesser-poland",
        "saxony",
        "upper-austria"
      ],
      "shape": "M 708.5 636 L 708.5 633 L 710.5 623 L 727.5 606 L 727.5 564 L 723.5 550 L 723.5 519 L 710.5 498 L 712 493.5 L 726 486.5 L 728 487.5 L 763 506.5 L 773 506.5 L 778 510.5 L 783 510.5 L 788 515.5 L 798.5 528 L 789.5 555 L 792.5 603 L 786 614.5 L 764 614.5 L 755 610.5 L 745 610.5 L 725 623.5 L 716 637.5 Z",
      "position": {
        "x": 757.27,
        "y": 555.09
      },
      "badgeAnchor": {
        "x": 757.27,
        "y": 555.09
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "czech-silesia",
      "name": "Czech Silesia",
      "regionId": "czech-republic",
      "adjacencies": [
        "lesser-poland",
        "liptov",
        "moravia",
        "pressburg",
        "styria",
        "upper-austria"
      ],
      "shape": "M 815 624.5 L 814 623.5 L 801 624.5 L 799 623.5 L 789 620.5 L 786.5 614 L 787.5 613 L 792.5 603 L 789.5 555 L 800 526.5 L 804 524.5 L 830 525.5 L 861 538.5 L 869.5 545 L 879.5 569 L 876.5 572 L 875.5 586 L 866 592.5 L 853 595.5 L 845 607.5 L 826 608.5 L 820.5 614 L 820.5 620 Z",
      "position": {
        "x": 828.52,
        "y": 569.77
      },
      "badgeAnchor": {
        "x": 828.52,
        "y": 569.77
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "spis",
      "name": "Spiš",
      "regionId": "slovakia",
      "adjacencies": [
        "liptov",
        "partium",
        "red-ruthenia",
        "transcarpathia",
        "great-plain"
      ],
      "shape": "M 955.5 611 L 943.5 594 L 944.5 570 L 945 569.5 L 955 567.5 L 962 569.5 L 967 562.5 L 975 558.5 L 991 558.5 L 1026.5 575 L 1025.5 576 L 1018.5 585 L 1015 611.5 L 1014 611.5 L 1001 619.5 L 987 619.5 L 979 613.5 Z",
      "position": {
        "x": 983.41,
        "y": 588.61
      },
      "badgeAnchor": {
        "x": 983.41,
        "y": 588.61
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "liptov",
      "name": "Liptov",
      "regionId": "slovakia",
      "adjacencies": [
        "czech-silesia",
        "great-plain",
        "lesser-poland",
        "pest",
        "pressburg",
        "red-ruthenia",
        "spis"
      ],
      "shape": "M 890 661.5 L 882.5 654 L 881.5 624 L 866.5 593 L 870 588.5 L 875.5 586 L 876.5 572 L 880 568.5 L 886 568.5 L 891 573.5 L 911 570.5 L 927 580.5 L 930 580.5 L 934.5 573 L 935 572.5 L 944.5 571 L 944.5 572 L 943.5 594 L 956.5 612 L 956.5 614 L 950.5 623 L 948.5 631 L 941 638.5 L 929 643.5 L 927 641.5 L 920 640.5 L 913 647.5 L 897 653.5 Z",
      "position": {
        "x": 910.49,
        "y": 609.91
      },
      "badgeAnchor": {
        "x": 910.49,
        "y": 609.91
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "pressburg",
      "name": "Pressburg",
      "regionId": "slovakia",
      "adjacencies": [
        "czech-silesia",
        "liptov",
        "pest",
        "styria",
        "transdanubia"
      ],
      "shape": "M 868 672.5 L 849 671.5 L 832 663.5 L 830.5 662 L 819.5 647 L 821.5 633 L 815.5 624 L 817 622.5 L 826 608.5 L 845 607.5 L 853 595.5 L 858 592.5 L 867.5 594 L 881.5 624 L 882.5 654 L 890.5 662 L 890.5 665 L 883 671.5 Z",
      "position": {
        "x": 852.93,
        "y": 636.86
      },
      "badgeAnchor": {
        "x": 852.93,
        "y": 636.86
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "partium",
      "name": "Partium",
      "regionId": "hungary",
      "adjacencies": [
        "banat",
        "crisana",
        "great-plain",
        "spis",
        "transcarpathia"
      ],
      "shape": "M 984.5 741 L 984.5 740 L 982.5 737 L 981.5 664 L 977.5 648 L 966.5 628 L 955 619.5 L 954.5 619 L 956.5 613 L 957 612.5 L 971 611.5 L 987 619.5 L 1001 619.5 L 1017 611.5 L 1026 621.5 L 1032 620.5 L 1050.5 629 L 1049.5 630 L 1042 643.5 L 1030 646.5 L 1019.5 660 L 1013.5 691 L 1007.5 703 L 1005.5 716 L 999.5 725 L 999.5 737 L 992 742.5 Z",
      "position": {
        "x": 999.82,
        "y": 651.59
      },
      "badgeAnchor": {
        "x": 999.82,
        "y": 651.59
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "great-plain",
      "name": "Great Plain",
      "regionId": "hungary",
      "adjacencies": [
        "banat",
        "liptov",
        "partium",
        "pest",
        "vojvodina",
        "spis"
      ],
      "shape": "M 939 755.5 L 937.5 754 L 935.5 730 L 908.5 703 L 909.5 688 L 922.5 663 L 928.5 644 L 930 642.5 L 941 638.5 L 948.5 631 L 954 619.5 L 956 619.5 L 966.5 628 L 973.5 640 L 981.5 664 L 982.5 737 L 984.5 742 L 982 744.5 L 965 754.5 L 945 754.5 Z",
      "position": {
        "x": 951.07,
        "y": 691.83
      },
      "badgeAnchor": {
        "x": 951.07,
        "y": 691.83
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "transdanubia",
      "name": "Transdanubia",
      "regionId": "hungary",
      "adjacencies": [
        "carniola",
        "pest",
        "pressburg",
        "slavonia",
        "styria"
      ],
      "shape": "M 809.5 747 L 806.5 737 L 799.5 730 L 799.5 728 L 809.5 719 L 810.5 715 L 805.5 705 L 805.5 700 L 813.5 691 L 809.5 683 L 824 679.5 L 827.5 676 L 831 663.5 L 834 663.5 L 849 671.5 L 868.5 673 L 868.5 676 L 867.5 685 L 875.5 715 L 875.5 730 L 886.5 755 L 880 786.5 L 868 787.5 L 850 778.5 Z",
      "position": {
        "x": 845.58,
        "y": 726.43
      },
      "badgeAnchor": {
        "x": 845.58,
        "y": 726.43
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "pest",
      "name": "Pest",
      "regionId": "hungary",
      "adjacencies": [
        "great-plain",
        "liptov",
        "pressburg",
        "slavonia",
        "transdanubia",
        "vojvodina"
      ],
      "shape": "M 882 785.5 L 881.5 785 L 886.5 755 L 875.5 730 L 875.5 715 L 867.5 685 L 868.5 674 L 869 673.5 L 885 670.5 L 890.5 665 L 890.5 661 L 891.5 660 L 897 653.5 L 913 647.5 L 920 640.5 L 928.5 643 L 928.5 646 L 909.5 688 L 908.5 703 L 935.5 730 L 935.5 746 L 938.5 755 L 933 760.5 L 927 766.5 L 917 769.5 L 908 776.5 L 907 775.5 L 903 775.5 L 896 782.5 L 887 786.5 Z",
      "position": {
        "x": 901.08,
        "y": 721.19
      },
      "badgeAnchor": {
        "x": 901.08,
        "y": 721.19
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "slavonia",
      "name": "Slavonia",
      "regionId": "croatia",
      "adjacencies": [
        "carniola",
        "drina",
        "krajina",
        "pest",
        "sarajevo",
        "transdanubia",
        "vojvodina",
        "zagorje"
      ],
      "shape": "M 785 822.5 L 772 819.5 L 765.5 814 L 765.5 812 L 768.5 807 L 769 806.5 L 775.5 803 L 774.5 793 L 790.5 777 L 788.5 765 L 810 747.5 L 813 750.5 L 836 765.5 L 850 778.5 L 868 787.5 L 881 785.5 L 883 785.5 L 892 784.5 L 903 775.5 L 908.5 777 L 908.5 778 L 913.5 785 L 918.5 804 L 929.5 815 L 924.5 821 L 925.5 831 L 919 835.5 L 908 826.5 L 902 827.5 L 880 822.5 L 873 827.5 L 848 827.5 L 843 830.5 L 842 829.5 L 834 825.5 L 820 826.5 L 810 838.5 L 797 827.5 L 789 826.5 Z",
      "position": {
        "x": 838.56,
        "y": 798.92
      },
      "badgeAnchor": {
        "x": 838.56,
        "y": 798.92
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "zagorje",
      "name": "Zagorje",
      "regionId": "croatia",
      "adjacencies": [
        "dalmatia",
        "krajina",
        "littoral",
        "slavonia"
      ],
      "shape": "M 775 894.5 L 771.5 891 L 753.5 862 L 751.5 846 L 743 831.5 L 733 829.5 L 730.5 832 L 731.5 841 L 720 847.5 L 718 852.5 L 705.5 851 L 693.5 831 L 693.5 822 L 697.5 815 L 701 813.5 L 702.5 816 L 710 821.5 L 730 817.5 L 738 812.5 L 745 812.5 L 749 815.5 L 765 813.5 L 770 818.5 L 781 820.5 L 788.5 826 L 788.5 828 L 788.5 846 L 792.5 855 L 791.5 856 L 789.5 884 L 782 893.5 Z",
      "position": {
        "x": 769.96,
        "y": 848.68
      },
      "badgeAnchor": {
        "x": 769.96,
        "y": 848.68
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "dalmatia",
      "name": "Dalmatia",
      "regionId": "croatia",
      "adjacencies": [
        "krajina",
        "sarajevo",
        "zagorje"
      ],
      "shape": "M 880 956.5 L 866 956.5 L 859 952.5 L 843 935.5 L 825 927.5 L 815 918.5 L 808 924.5 L 795 921.5 L 784.5 912 L 776.5 901 L 775.5 895 L 779 894.5 L 789.5 884 L 792 855.5 L 795 855.5 L 810.5 870 L 816.5 887 L 834.5 902 L 847 917.5 L 856 922.5 L 862.5 932 L 878.5 945 Z M 874.5 951 L 871 947.5 L 868.5 949 L 874 951.5 Z",
      "position": {
        "x": 808,
        "y": 904
      },
      "badgeAnchor": {
        "x": 808,
        "y": 904
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "krajina",
      "name": "Krajina",
      "regionId": "bosnia-and-herzegovina",
      "adjacencies": [
        "dalmatia",
        "sarajevo",
        "slavonia",
        "zagorje"
      ],
      "shape": "M 833 900.5 L 816.5 887 L 810.5 870 L 793 855.5 L 791.5 854 L 788.5 846 L 788.5 827 L 789 826.5 L 797 827.5 L 810 838.5 L 820 826.5 L 834 825.5 L 842.5 830 L 842.5 833 L 838.5 841 L 843.5 870 Z",
      "position": {
        "x": 821.42,
        "y": 854.06
      },
      "badgeAnchor": {
        "x": 821.42,
        "y": 854.06
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "sarajevo",
      "name": "Sarajevo",
      "regionId": "bosnia-and-herzegovina",
      "adjacencies": [
        "dalmatia",
        "drina",
        "krajina",
        "slavonia"
      ],
      "shape": "M 881 956.5 L 880.5 956 L 878.5 945 L 862.5 932 L 856 922.5 L 847 917.5 L 833.5 901 L 834.5 899 L 843.5 870 L 838.5 841 L 842.5 831 L 844 829.5 L 873 827.5 L 880 822.5 L 903 827.5 L 903.5 828 L 886.5 945 Z",
      "position": {
        "x": 869.19,
        "y": 876.55
      },
      "badgeAnchor": {
        "x": 869.19,
        "y": 876.55
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "drina",
      "name": "Drina",
      "regionId": "bosnia-and-herzegovina",
      "adjacencies": [
        "sarajevo",
        "slavonia",
        "sumadija",
        "vojvodina"
      ],
      "shape": "M 912 959.5 L 881.5 956 L 882.5 955 L 887.5 939 L 902.5 827 L 903 826.5 L 908 826.5 L 919 835.5 L 926 830.5 L 931 830.5 L 937.5 836 L 934.5 849 L 935.5 868 L 947 874.5 L 950.5 881 L 944.5 886 L 944.5 890 L 953.5 898 L 955.5 905 L 932.5 915 L 932.5 921 L 921.5 934 L 921.5 940 L 915.5 948 Z",
      "position": {
        "x": 918,
        "y": 895
      },
      "badgeAnchor": {
        "x": 918,
        "y": 895
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "vojvodina",
      "name": "Vojvodina",
      "regionId": "serbia",
      "adjacencies": [
        "banat",
        "belgrade",
        "drina",
        "great-plain",
        "pest",
        "slavonia",
        "sumadija"
      ],
      "shape": "M 950.5 879 L 950.5 878 L 935.5 868 L 934.5 849 L 937.5 836 L 934 831.5 L 927 830.5 L 926.5 830 L 924.5 821 L 929.5 815 L 918.5 804 L 908.5 776 L 910 774.5 L 927 766.5 L 938 755.5 L 944 755.5 L 963 754.5 L 963.5 755 L 970 764.5 L 986.5 777 L 987.5 784 L 996 793.5 L 1010.5 800 L 1009.5 802 L 1009.5 824 L 1004 831.5 L 990.5 839 L 986.5 849 L 987.5 856 L 983.5 860 L 972 874.5 L 960 879.5 Z",
      "position": {
        "x": 960.15,
        "y": 812.45
      },
      "badgeAnchor": {
        "x": 960.15,
        "y": 812.45
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "belgrade",
      "name": "Belgrade",
      "regionId": "serbia",
      "adjacencies": [
        "banat",
        "nis",
        "oltenia",
        "sofia",
        "sumadija",
        "vojvodina"
      ],
      "shape": "M 1018 884.5 L 1008 874.5 L 987.5 856 L 986.5 849 L 990.5 839 L 1004 831.5 L 1009.5 824 L 1011 800.5 L 1022 802.5 L 1024.5 808 L 1022.5 810 L 1025.5 822 L 1036 830.5 L 1046 829.5 L 1054 834.5 L 1065 823.5 L 1069 824.5 L 1073.5 829 L 1069.5 839 L 1080.5 850 L 1079.5 852 L 1071.5 864 L 1072.5 877 L 1087.5 897 L 1086.5 898 L 1080 903.5 L 1045 903.5 L 1038.5 898 L 1037.5 890 L 1034 886.5 Z",
      "position": {
        "x": 1037.01,
        "y": 860.49
      },
      "badgeAnchor": {
        "x": 1037.01,
        "y": 860.49
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "sumadija",
      "name": "Šumadija",
      "regionId": "serbia",
      "adjacencies": [
        "belgrade",
        "drina",
        "nis",
        "shkoder",
        "vojvodina"
      ],
      "shape": "M 913.5 958 L 915.5 948 L 921.5 940 L 921.5 934 L 932.5 921 L 932.5 915 L 955.5 905 L 953.5 898 L 944.5 890 L 944.5 886 L 950.5 880 L 951 879.5 L 960 879.5 L 972 874.5 L 987 856.5 L 990.5 859 L 1017.5 884 L 1015.5 887 L 1011.5 896 L 996.5 907 L 994.5 940 L 989 945.5 L 977.5 949 L 977.5 956 L 974.5 960 L 976.5 965 L 975.5 966 L 961.5 976 L 956.5 986 L 955.5 997 L 942 992.5 L 932.5 982 L 932.5 977 L 926.5 969 L 918 964.5 L 915 959.5 L 913 960.5 Z",
      "position": {
        "x": 963.33,
        "y": 926.43
      },
      "badgeAnchor": {
        "x": 963.33,
        "y": 926.43
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "nis",
      "name": "Niš",
      "regionId": "serbia",
      "adjacencies": [
        "belgrade",
        "shkoder",
        "skopje",
        "sofia",
        "sumadija"
      ],
      "shape": "M 1017 987.5 L 1011.5 983 L 1008 976.5 L 1000 973.5 L 988 961.5 L 977 965.5 L 975.5 964 L 977.5 949 L 989 945.5 L 994.5 940 L 996.5 907 L 1011.5 896 L 1019 883.5 L 1034 886.5 L 1037.5 890 L 1038.5 898 L 1045 903.5 L 1080 903.5 L 1087 897.5 L 1093 897.5 L 1099.5 903 L 1102.5 910 L 1095.5 923 L 1085.5 930 L 1087.5 944 L 1092.5 949 L 1092.5 953 L 1088 957.5 L 1069 962.5 L 1045 977.5 L 1035 976.5 Z",
      "position": {
        "x": 1037.59,
        "y": 936.26
      },
      "badgeAnchor": {
        "x": 1037.59,
        "y": 936.26
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "shkoder",
      "name": "Albania",
      "regionId": "albania",
      "adjacencies": [
        "nis",
        "salonika",
        "skopje",
        "sumadija"
      ],
      "shape": "M 1046 1067.5 L 969 1067.5 L 968.5 1067 L 968.5 1062 L 969.5 1061 L 969.5 1059 L 970.5 1058 L 970.5 1057 L 969.5 1056 L 969.5 1054 L 968.5 1053 L 968.5 1042 L 969.5 1041 L 969.5 1024 L 970.5 1023 L 970.5 1022 L 971.5 1021 L 971.5 1019 L 972.5 1018 L 972.5 1015 L 971 1013.5 L 968 1013.5 L 967 1012.5 L 966 1012.5 L 962.5 1009 L 962.5 1008 L 962 1007.5 L 961 1007.5 L 957.5 1004 L 957.5 1001 L 957 1000.5 L 956 1000.5 L 955.5 1000 L 955.5 996 L 956.5 986 L 961.5 976 L 976 965.5 L 978 965.5 L 988 961.5 L 1000 973.5 L 1008 976.5 L 1016.5 988 L 1016.5 990 L 1017.5 991 L 1017.5 993 L 1016.5 994 L 1016.5 995 L 1015.5 996 L 1015.5 998 L 1013.5 1000 L 1013.5 1003 L 1012.5 1004 L 1012.5 1006 L 1013.5 1007 L 1013.5 1009 L 1014.5 1010 L 1014.5 1011 L 1015.5 1012 L 1015.5 1014 L 1014.5 1015 L 1014.5 1016 L 1013.5 1017 L 1013.5 1021 L 1015.5 1023 L 1015.5 1024 L 1016.5 1025 L 1016.5 1034 L 1017.5 1035 L 1017.5 1036 L 1019.5 1038 L 1019.5 1039 L 1021 1040.5 L 1023 1040.5 L 1025.5 1043 L 1025.5 1044 L 1026.5 1045 L 1026.5 1047 L 1027.5 1048 L 1027.5 1049 L 1031 1052.5 L 1038 1052.5 L 1043.5 1058 L 1043.5 1062 L 1045.5 1064 L 1045.5 1065 L 1046.5 1066 L 1046.5 1067 Z",
      "position": {
        "x": 991.16,
        "y": 1018.03
      },
      "badgeAnchor": {
        "x": 991.16,
        "y": 1018.03
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "skopje",
      "name": "North Macedonia",
      "regionId": "north-macedonia",
      "adjacencies": [
        "nis",
        "salonika",
        "shkoder",
        "sofia"
      ],
      "shape": "M 1044 1057.5 L 1038 1052.5 L 1031 1052.5 L 1016.5 1034 L 1016.5 1025 L 1013.5 1021 L 1015.5 1012 L 1012.5 1004 L 1017.5 993 L 1016.5 988 L 1020 984.5 L 1022 984.5 L 1023 983.5 L 1024 983.5 L 1025 982.5 L 1026 982.5 L 1027 981.5 L 1028 981.5 L 1030 979.5 L 1031 979.5 L 1033 977.5 L 1034 977.5 L 1035 976.5 L 1037 976.5 L 1038 977.5 L 1045 977.5 L 1046 976.5 L 1047 976.5 L 1048 975.5 L 1050 975.5 L 1051 974.5 L 1052 974.5 L 1055 971.5 L 1056 971.5 L 1057 970.5 L 1058 970.5 L 1059 969.5 L 1060 969.5 L 1062 967.5 L 1063 967.5 L 1067 963.5 L 1068 963.5 L 1069 962.5 L 1076 962.5 L 1077 961.5 L 1078 961.5 L 1079 960.5 L 1080 960.5 L 1081 959.5 L 1082 959.5 L 1084 957.5 L 1088 957.5 L 1088.5 958 L 1088.5 959 L 1090.5 961 L 1090.5 962 L 1092.5 964 L 1092.5 965 L 1093 965.5 L 1094 965.5 L 1099 970.5 L 1100 970.5 L 1101 971.5 L 1103 971.5 L 1107 975.5 L 1109 975.5 L 1110.5 977 L 1110.5 978 L 1113.5 981 L 1113.5 982 L 1114.5 983 L 1114.5 985 L 1118.5 989 L 1118.5 990 L 1119.5 991 L 1119.5 992 L 1120.5 993 L 1119.5 994 L 1119.5 999 L 1121.5 1001 L 1121.5 1002 L 1122.5 1003 L 1122.5 1011 L 1120.5 1013 L 1110 1026.5 L 1090 1029.5 L 1067 1049.5 L 1058 1050.5 Z",
      "position": {
        "x": 1064.81,
        "y": 1007.14
      },
      "badgeAnchor": {
        "x": 1064.81,
        "y": 1007.14
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "western-thrace",
      "name": "Western Thrace",
      "regionId": "greece",
      "adjacencies": [
        "eastern-rumelia",
        "edirne",
        "salonika",
        "sofia"
      ],
      "shape": "M 1161 1067.5 L 1160.5 1067 L 1160.5 1054 L 1161.5 1053 L 1161.5 1052 L 1162.5 1051 L 1162.5 1050 L 1163.5 1049 L 1163 1048.5 L 1161 1048.5 L 1160 1047.5 L 1159 1047.5 L 1158 1046.5 L 1146 1046.5 L 1144 1044.5 L 1143 1044.5 L 1140 1041.5 L 1138 1041.5 L 1137 1040.5 L 1136 1040.5 L 1134.5 1039 L 1134.5 1038 L 1133.5 1037 L 1133.5 1035 L 1131.5 1033 L 1131.5 1026 L 1132.5 1025 L 1132.5 1024 L 1140.5 1016 L 1140.5 1012 L 1139.5 1011 L 1139.5 1010 L 1138.5 1009 L 1138.5 1008 L 1139 1007.5 L 1140 1007.5 L 1141 1006.5 L 1142 1006.5 L 1145 1003.5 L 1150 1003.5 L 1151 1002.5 L 1152 1002.5 L 1153 1001.5 L 1155 1001.5 L 1157 999.5 L 1158 999.5 L 1159 998.5 L 1162 998.5 L 1163 997.5 L 1164 997.5 L 1168 993.5 L 1169 993.5 L 1170.5 992 L 1170.5 991 L 1173 988.5 L 1176 988.5 L 1177 989.5 L 1178 989.5 L 1179 988.5 L 1181 988.5 L 1182 989.5 L 1183 989.5 L 1184 988.5 L 1187 988.5 L 1188 989.5 L 1190 989.5 L 1194 993.5 L 1195 993.5 L 1196 994.5 L 1201 994.5 L 1202 993.5 L 1217 993.5 L 1218 994.5 L 1219 994.5 L 1223 998.5 L 1224 997.5 L 1226 997.5 L 1227 996.5 L 1228 996.5 L 1229 995.5 L 1231 995.5 L 1232 994.5 L 1233 994.5 L 1234 993.5 L 1235 993.5 L 1236 992.5 L 1237 992.5 L 1238 991.5 L 1242 991.5 L 1245 988.5 L 1246 988.5 L 1248 986.5 L 1252 986.5 L 1253 985.5 L 1254 985.5 L 1258 981.5 L 1259 981.5 L 1259.5 981 L 1259.5 980 L 1258.5 979 L 1258.5 975 L 1259.5 974 L 1258.5 973 L 1258.5 972 L 1256.5 970 L 1256.5 969 L 1254.5 967 L 1254.5 966 L 1253.5 965 L 1253.5 964 L 1257 960.5 L 1259 960.5 L 1260 959.5 L 1261 959.5 L 1264 956.5 L 1265 957.5 L 1277.5 966 L 1281.5 975 L 1270.5 990 L 1276.5 1004 L 1270.5 1011 L 1270 1018.5 L 1204 1019.5 L 1183 1040.5 L 1168.5 1044 L 1168.5 1049 L 1179.5 1056 L 1178.5 1066 Z",
      "position": {
        "x": 1188,
        "y": 1013
      },
      "badgeAnchor": {
        "x": 1188,
        "y": 1013
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "salonika",
      "name": "Salonika",
      "regionId": "greece",
      "adjacencies": [
        "shkoder",
        "skopje",
        "sofia",
        "western-thrace"
      ],
      "shape": "M 1160 1067.5 L 1133 1067.5 L 1132.5 1067 L 1132.5 1057 L 1129 1053.5 L 1128 1053.5 L 1127 1054.5 L 1121 1054.5 L 1120 1055.5 L 1119 1055.5 L 1118 1056.5 L 1117 1056.5 L 1116.5 1057 L 1116.5 1060 L 1117.5 1061 L 1117.5 1067 L 1117 1067.5 L 1047 1067.5 L 1046.5 1067 L 1046.5 1066 L 1045.5 1065 L 1045.5 1064 L 1043.5 1062 L 1043.5 1058 L 1045 1056.5 L 1067 1049.5 L 1090 1029.5 L 1110 1026.5 L 1122 1011.5 L 1124 1011.5 L 1129 1013.5 L 1138 1007.5 L 1138.5 1008 L 1140.5 1016 L 1132.5 1024 L 1131.5 1033 L 1136 1040.5 L 1146 1046.5 L 1163.5 1049 L 1160.5 1054 Z",
      "position": {
        "x": 1101.41,
        "y": 1046.45
      },
      "badgeAnchor": {
        "x": 1101.41,
        "y": 1046.45
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "masuria",
      "name": "Masuria",
      "regionId": "poland",
      "adjacencies": [
        "konigsberg",
        "masovia",
        "podlachia",
        "pomerelia"
      ],
      "shape": "M 891 386.5 L 890.5 386 L 890.5 358 L 879.5 333 L 881.5 310 L 875.5 300 L 870.5 282 L 872 280.5 L 875 278.5 L 881 280.5 L 936 278.5 L 936.5 279 L 943.5 289 L 969.5 353 L 970.5 360 L 965 370.5 L 964 369.5 L 948 370.5 L 919 387.5 L 910 386.5 L 898 390.5 Z",
      "position": {
        "x": 919.57,
        "y": 331.26
      },
      "badgeAnchor": {
        "x": 919.57,
        "y": 331.26
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "pomerelia",
      "name": "Pomerelia",
      "regionId": "poland",
      "adjacencies": [
        "kuyavia",
        "masovia",
        "masuria",
        "pomerania",
        "greater-poland"
      ],
      "shape": "M 815.5 398 L 815.5 397 L 814.5 396 L 814.5 393 L 813.5 392 L 813.5 386 L 812.5 385 L 812.5 383 L 811.5 382 L 811.5 378 L 810.5 377 L 810.5 375 L 809.5 374 L 809.5 368 L 805.5 364 L 805.5 363 L 804.5 362 L 804.5 361 L 803.5 360 L 803.5 359 L 800.5 356 L 800.5 355 L 795.5 350 L 795.5 349 L 786 339.5 L 785 339.5 L 784 338.5 L 783 338.5 L 778 333.5 L 777 333.5 L 776 332.5 L 774 332.5 L 770 328.5 L 768 328.5 L 766 326.5 L 765 326.5 L 760 321.5 L 759 321.5 L 757.5 320 L 757.5 319 L 756.5 318 L 756.5 317 L 755.5 316 L 755.5 315 L 754.5 314 L 754.5 313 L 753.5 312 L 753.5 311 L 752.5 310 L 752.5 308 L 751.5 307 L 753 305.5 L 759 296.5 L 767 291.5 L 772 292.5 L 777 281.5 L 799 279.5 L 805 273.5 L 821 273.5 L 836 277.5 L 839 287.5 L 854 287.5 L 870 281.5 L 871.5 283 L 875.5 300 L 881.5 310 L 879.5 333 L 890.5 358 L 890 386.5 L 889 386.5 L 887 388.5 L 875 388.5 L 874 387.5 L 872 387.5 L 871 386.5 L 858 386.5 L 856 388.5 L 855 388.5 L 854 389.5 L 853 389.5 L 852 390.5 L 841 390.5 L 840 391.5 L 837 391.5 L 836 392.5 L 834 392.5 L 833 393.5 L 832 393.5 L 831 394.5 L 830 394.5 L 829 395.5 L 826 395.5 L 825 396.5 L 824 396.5 L 823 397.5 L 821 397.5 L 820 398.5 L 819 398.5 L 818 399.5 L 817 399.5 Z",
      "position": {
        "x": 830.16,
        "y": 330.95
      },
      "badgeAnchor": {
        "x": 830.16,
        "y": 330.95
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "podlachia",
      "name": "Podlachia",
      "regionId": "poland",
      "adjacencies": [
        "brest",
        "grodno",
        "konigsberg",
        "lublin",
        "masovia",
        "masuria",
        "red-ruthenia",
        "vilna",
        "volhynia"
      ],
      "shape": "M 1012 434.5 L 1010 433.5 L 970 424.5 L 968.5 423 L 965.5 370 L 968.5 367 L 970.5 358 L 963.5 334 L 957.5 328 L 943.5 289 L 937.5 283 L 937 278.5 L 938 278.5 L 968 273.5 L 976 267.5 L 983 267.5 L 997 274.5 L 1009.5 291 L 1009.5 294 L 1012.5 306 L 1034.5 347 L 1033.5 348 L 1033.5 355 L 1021.5 366 L 1015.5 379 L 1015.5 387 L 1030.5 396 L 1030.5 410 L 1033.5 419 L 1033.5 423 L 1036 430.5 L 1035 430.5 L 1029 434.5 Z",
      "position": {
        "x": 991.6,
        "y": 349.94
      },
      "badgeAnchor": {
        "x": 991.6,
        "y": 349.94
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "pomerania",
      "name": "Pomerania",
      "regionId": "poland",
      "adjacencies": [
        "greater-poland",
        "mecklenburg",
        "pomerelia",
        "saxony",
        "kuyavia"
      ],
      "shape": "M 713 411.5 L 710.5 409 L 692.5 390 L 692.5 388 L 700.5 371 L 694.5 345 L 698 334.5 L 708.5 328 L 715 315.5 L 724 311.5 L 746 310.5 L 751 307.5 L 752.5 308 L 757.5 320 L 786 339.5 L 803.5 359 L 809.5 368 L 815 398.5 L 813 398.5 L 805.5 415 L 796 422.5 L 787 425.5 L 773 422.5 L 756 410.5 L 717 409.5 Z",
      "position": {
        "x": 751.92,
        "y": 369.36
      },
      "badgeAnchor": {
        "x": 751.92,
        "y": 369.36
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "masovia",
      "name": "Masovia",
      "regionId": "poland",
      "adjacencies": [
        "kuyavia",
        "lublin",
        "masuria",
        "podlachia",
        "pomerelia"
      ],
      "shape": "M 917.5 471 L 917.5 442 L 914.5 426 L 901 426.5 L 887 432.5 L 878 430.5 L 858.5 409 L 852.5 399 L 851 390.5 L 852 390.5 L 858 386.5 L 875 388.5 L 892 386.5 L 898 390.5 L 910 386.5 L 919 387.5 L 948 370.5 L 965.5 371 L 965.5 372 L 969.5 424 L 968.5 425 L 963.5 440 L 956.5 448 L 955.5 458 L 950 464.5 L 929 474.5 Z",
      "position": {
        "x": 925.65,
        "y": 415.35
      },
      "badgeAnchor": {
        "x": 925.65,
        "y": 415.35
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "greater-poland",
      "name": "Greater Poland",
      "regionId": "poland",
      "adjacencies": [
        "kuyavia",
        "lesser-poland",
        "moravia",
        "pomerania",
        "saxony",
        "pomerelia"
      ],
      "shape": "M 782 510.5 L 778 510.5 L 773 506.5 L 763 506.5 L 736 493.5 L 726.5 486 L 727.5 474 L 719.5 468 L 714.5 456 L 718.5 435 L 710.5 419 L 712.5 412 L 714 410.5 L 716 410.5 L 717 409.5 L 721 409.5 L 722 410.5 L 725 410.5 L 726 411.5 L 728 411.5 L 729 410.5 L 731 410.5 L 732 409.5 L 741 409.5 L 742 410.5 L 744 410.5 L 745 411.5 L 751 411.5 L 752 410.5 L 756 410.5 L 760 414.5 L 761 414.5 L 763 416.5 L 766 416.5 L 768 418.5 L 769 418.5 L 773 422.5 L 775 422.5 L 776 423.5 L 777 423.5 L 778 424.5 L 782 424.5 L 783 425.5 L 787 425.5 L 788 424.5 L 789 424.5 L 790 423.5 L 794 423.5 L 795 422.5 L 796 422.5 L 799 419.5 L 800 419.5 L 801 418.5 L 802 418.5 L 805.5 415 L 805.5 412 L 807.5 410 L 807.5 408 L 808.5 407 L 808.5 405 L 809.5 404 L 809.5 402 L 813 398.5 L 816 398.5 L 816.5 399 L 816.5 401 L 824.5 420 L 825.5 451 L 813.5 459 L 810 469.5 L 808 469.5 L 803.5 478 L 787.5 495 Z",
      "position": {
        "x": 765.85,
        "y": 454.86
      },
      "badgeAnchor": {
        "x": 765.85,
        "y": 454.86
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "kuyavia",
      "name": "Kuyavia",
      "regionId": "poland",
      "adjacencies": [
        "greater-poland",
        "lesser-poland",
        "lublin",
        "masovia",
        "pomerelia",
        "pomerania"
      ],
      "shape": "M 810.5 469 L 811.5 468 L 811.5 466 L 812.5 465 L 812.5 462 L 813.5 461 L 813.5 459 L 815 457.5 L 817 457.5 L 818 456.5 L 819 456.5 L 821 454.5 L 823 454.5 L 824.5 453 L 824.5 452 L 825.5 451 L 825.5 426 L 824.5 425 L 824.5 420 L 823.5 419 L 823.5 418 L 822.5 417 L 822.5 415 L 821.5 414 L 821.5 412 L 820.5 411 L 820.5 409 L 819.5 408 L 819.5 407 L 818.5 406 L 818.5 404 L 817.5 403 L 817.5 402 L 816.5 401 L 816.5 400 L 817 399.5 L 818 399.5 L 819 398.5 L 820 398.5 L 821 397.5 L 823 397.5 L 824 396.5 L 825 396.5 L 826 395.5 L 829 395.5 L 830 394.5 L 831 394.5 L 832 393.5 L 833 393.5 L 834 392.5 L 836 392.5 L 837 391.5 L 840 391.5 L 841 390.5 L 850 390.5 L 850.5 391 L 858.5 409 L 878 430.5 L 887 432.5 L 901 426.5 L 914.5 426 L 918.5 472 L 917.5 474 L 906 484.5 L 903 484.5 L 895 489.5 L 872 492.5 L 863 482.5 L 828 481.5 Z",
      "position": {
        "x": 864.83,
        "y": 449.65
      },
      "badgeAnchor": {
        "x": 864.83,
        "y": 449.65
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "lublin",
      "name": "Lublin",
      "regionId": "poland",
      "adjacencies": [
        "kuyavia",
        "lesser-poland",
        "masovia",
        "podlachia",
        "red-ruthenia"
      ],
      "shape": "M 934 527.5 L 932 525.5 L 926.5 522 L 906.5 484 L 909 481.5 L 919 472.5 L 929 474.5 L 950 464.5 L 955.5 458 L 956.5 448 L 963.5 440 L 969 424.5 L 975 424.5 L 983 428.5 L 1004 430.5 L 1011.5 435 L 1013.5 448 L 1004.5 468 L 1003.5 502 L 986 514.5 L 957 517.5 Z",
      "position": {
        "x": 966.73,
        "y": 479.57
      },
      "badgeAnchor": {
        "x": 966.73,
        "y": 479.57
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "lesser-poland",
      "name": "Lesser Poland",
      "regionId": "poland",
      "adjacencies": [
        "czech-silesia",
        "greater-poland",
        "kuyavia",
        "liptov",
        "lublin",
        "moravia",
        "red-ruthenia"
      ],
      "shape": "M 879.5 568 L 879.5 567 L 869.5 545 L 849 532.5 L 843 532.5 L 830 525.5 L 804 524.5 L 799 527.5 L 797 526.5 L 782.5 510 L 783.5 509 L 789.5 492 L 803.5 478 L 806.5 471 L 811 469.5 L 813 471.5 L 828 481.5 L 863 482.5 L 872 492.5 L 895 489.5 L 907 484.5 L 907.5 485 L 926.5 522 L 933.5 527 L 933.5 535 L 931.5 557 L 934.5 574 L 930 580.5 L 927 580.5 L 911 570.5 L 891 573.5 L 886 568.5 Z",
      "position": {
        "x": 869.39,
        "y": 519.98
      },
      "badgeAnchor": {
        "x": 869.39,
        "y": 519.98
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "red-ruthenia",
      "name": "Red Ruthenia",
      "regionId": "poland",
      "adjacencies": [
        "lesser-poland",
        "liptov",
        "lublin",
        "podlachia",
        "spis",
        "transcarpathia",
        "volhynia"
      ],
      "shape": "M 1027 574.5 L 1025 573.5 L 991 558.5 L 975 558.5 L 967 562.5 L 962 569.5 L 950 567.5 L 944 570.5 L 934.5 572 L 934.5 571 L 931.5 557 L 933.5 528 L 935 526.5 L 957 517.5 L 986 514.5 L 1003.5 502 L 1004.5 468 L 1013.5 448 L 1013 433.5 L 1029 434.5 L 1037 430.5 L 1037.5 431 L 1039.5 437 L 1056.5 457 L 1057.5 467 L 1065.5 473 L 1065 485.5 L 1064 485.5 L 1056 489.5 L 1046.5 502 L 1043.5 513 L 1034.5 524 L 1025.5 542 L 1027.5 558 L 1032.5 571 Z",
      "position": {
        "x": 1010,
        "y": 517
      },
      "badgeAnchor": {
        "x": 1010,
        "y": 517
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "dorpat",
      "name": "Estonia",
      "regionId": "estonia",
      "adjacencies": [
        "livonia",
        "pskov"
      ],
      "shape": "M 991 52.5 L 988.5 49 L 989 40.5 L 953.5 23 L 947 -0.5 L 1070.5 0 L 1073.5 19 L 1080.5 25 L 1085.5 36 L 1077 58.5 L 1067 57.5 L 1055 63.5 L 1031 47.5 L 1025 48.5 L 1020 45.5 L 1005 46.5 L 1001 50.5 Z",
      "position": {
        "x": 1025.35,
        "y": 25.07
      },
      "badgeAnchor": {
        "x": 1025.35,
        "y": 25.07
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "livonia",
      "name": "Livonia",
      "regionId": "latvia",
      "adjacencies": [
        "aukstaitija",
        "courland",
        "dorpat",
        "polotsk",
        "pskov",
        "velikiye-luki"
      ],
      "shape": "M 1085 171.5 L 1083 170.5 L 1047 150.5 L 1032 151.5 L 1022 142.5 L 1014.5 140 L 1008.5 117 L 996 113.5 L 988 106.5 L 986.5 105 L 988.5 55 L 995 52.5 L 1005 46.5 L 1020 45.5 L 1025 48.5 L 1031 47.5 L 1055 63.5 L 1067 57.5 L 1077 58.5 L 1079 56.5 L 1081 56.5 L 1097.5 68 L 1097.5 70 L 1099.5 91 L 1118.5 110 L 1123.5 119 L 1125 129.5 L 1124 129.5 L 1118.5 136 L 1113.5 151 L 1105 157.5 L 1096 158.5 Z",
      "position": {
        "x": 1053.67,
        "y": 105.05
      },
      "badgeAnchor": {
        "x": 1053.67,
        "y": 105.05
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "courland",
      "name": "Courland",
      "regionId": "latvia",
      "adjacencies": [
        "aukstaitija",
        "livonia",
        "samogitia"
      ],
      "shape": "M 902 174.5 L 900.5 164 L 897.5 161 L 897.5 139 L 902.5 131 L 905.5 108 L 908 105.5 L 912 105.5 L 927 92.5 L 940 90.5 L 944 96.5 L 961 102.5 L 963 111.5 L 983 111.5 L 987 106.5 L 990 106.5 L 996 113.5 L 1008.5 117 L 1015.5 141 L 1013.5 144 L 1000 153.5 L 983 154.5 L 981 152.5 L 959 153.5 L 931 159.5 L 911 172.5 Z",
      "position": {
        "x": 954.04,
        "y": 127.48
      },
      "badgeAnchor": {
        "x": 954.04,
        "y": 127.48
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "aukstaitija",
      "name": "Aukštaitija",
      "regionId": "lithuania",
      "adjacencies": [
        "courland",
        "livonia",
        "navahrudak",
        "polotsk",
        "samogitia",
        "vilna"
      ],
      "shape": "M 987.5 201 L 991.5 180 L 984.5 164 L 984 154.5 L 985 154.5 L 1005 151.5 L 1016 141.5 L 1022 142.5 L 1032 151.5 L 1047 150.5 L 1085.5 173 L 1087.5 185 L 1093.5 192 L 1092.5 196 L 1091 197.5 L 1082.5 205 L 1069.5 226 L 1069 226.5 L 1050 227.5 L 1034 222.5 L 1004 218.5 Z",
      "position": {
        "x": 1036.21,
        "y": 187.17
      },
      "badgeAnchor": {
        "x": 1036.21,
        "y": 187.17
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "samogitia",
      "name": "Samogitia",
      "regionId": "lithuania",
      "adjacencies": [
        "aukstaitija",
        "courland",
        "konigsberg",
        "vilna"
      ],
      "shape": "M 913 226.5 L 909.5 219 L 909.5 203 L 901.5 181 L 902.5 175 L 907 174.5 L 931 159.5 L 942 156.5 L 971 152.5 L 981 152.5 L 983.5 155 L 991.5 180 L 987 201.5 L 986 201.5 L 962.5 228 L 961 229.5 L 946 234.5 L 925 227.5 Z",
      "position": {
        "x": 947.79,
        "y": 191.69
      },
      "badgeAnchor": {
        "x": 947.79,
        "y": 191.69
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "vilna",
      "name": "Vilna",
      "regionId": "lithuania",
      "adjacencies": [
        "aukstaitija",
        "grodno",
        "konigsberg",
        "navahrudak",
        "podlachia",
        "samogitia"
      ],
      "shape": "M 1010 291.5 L 1008.5 290 L 997 274.5 L 986 268.5 L 977 267.5 L 976.5 267 L 973.5 253 L 974.5 240 L 962.5 229 L 962.5 226 L 988 201.5 L 990.5 204 L 1004 218.5 L 1034 222.5 L 1050 227.5 L 1070.5 228 L 1073.5 234 L 1071.5 247 L 1074.5 254 L 1071 257.5 L 1062 258.5 L 1050.5 269 L 1049.5 273 L 1037 283.5 L 1019 286.5 Z",
      "position": {
        "x": 1016.72,
        "y": 248.13
      },
      "badgeAnchor": {
        "x": 1016.72,
        "y": 248.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "polotsk",
      "name": "Polotsk",
      "regionId": "belarus",
      "adjacencies": [
        "aukstaitija",
        "livonia",
        "navahrudak",
        "velikiye-luki",
        "vitebsk"
      ],
      "shape": "M 1092.5 197 L 1092.5 194 L 1084.5 172 L 1092.5 164 L 1096 158.5 L 1110 154.5 L 1119.5 134 L 1127 129.5 L 1134 132.5 L 1142 128.5 L 1150 134.5 L 1157 130.5 L 1167 130.5 L 1170.5 134 L 1170.5 139 L 1177.5 145 L 1177.5 146 L 1183.5 150 L 1188.5 165 L 1183 168.5 L 1169 169.5 L 1165.5 173 L 1162.5 190 L 1155.5 198 L 1155 204.5 L 1153 204.5 L 1144 208.5 L 1113 207.5 L 1097 201.5 Z",
      "position": {
        "x": 1133.66,
        "y": 170.29
      },
      "badgeAnchor": {
        "x": 1133.66,
        "y": 170.29
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "vitebsk",
      "name": "Vitebsk",
      "regionId": "belarus",
      "adjacencies": [
        "minsk",
        "mogilev",
        "navahrudak",
        "polotsk",
        "toropets",
        "velikiye-luki",
        "smolensk"
      ],
      "shape": "M 1232 234.5 L 1209 233.5 L 1200 229.5 L 1176 227.5 L 1166 221.5 L 1162 222.5 L 1161.5 221 L 1155.5 204 L 1155.5 198 L 1162.5 190 L 1165.5 173 L 1169 169.5 L 1183 168.5 L 1188.5 165 L 1183.5 150 L 1177.5 144 L 1181 140.5 L 1193 131.5 L 1208 131.5 L 1212 135.5 L 1213 135.5 L 1215 137.5 L 1216 137.5 L 1217 138.5 L 1218 138.5 L 1219 139.5 L 1220 138.5 L 1221 138.5 L 1222 139.5 L 1223 139.5 L 1226.5 143 L 1226.5 146 L 1227.5 147 L 1227.5 148 L 1225.5 150 L 1225.5 151 L 1224.5 152 L 1224.5 155 L 1226 156.5 L 1227 156.5 L 1229.5 159 L 1229.5 160 L 1230.5 161 L 1230.5 162 L 1234.5 166 L 1234.5 167 L 1235.5 168 L 1234.5 169 L 1234.5 170 L 1233.5 171 L 1233.5 172 L 1232.5 173 L 1232.5 174 L 1231.5 175 L 1231.5 176 L 1230.5 177 L 1231.5 178 L 1231.5 179 L 1237 184.5 L 1238 184.5 L 1243 189.5 L 1245 189.5 L 1248.5 193 L 1248.5 194 L 1255.5 201 L 1255.5 202 L 1257.5 204 L 1257.5 206 L 1260.5 209 L 1260.5 210 L 1261.5 211 L 1253 219.5 L 1243.5 226 L 1240 232.5 Z",
      "position": {
        "x": 1205.25,
        "y": 192.32
      },
      "badgeAnchor": {
        "x": 1205.25,
        "y": 192.32
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "navahrudak",
      "name": "Navahrudak",
      "regionId": "belarus",
      "adjacencies": [
        "aukstaitija",
        "grodno",
        "minsk",
        "polotsk",
        "slutsk",
        "vilna",
        "vitebsk"
      ],
      "shape": "M 1135 291.5 L 1133 290.5 L 1110 289.5 L 1096 285.5 L 1081 287.5 L 1069 283.5 L 1050.5 272 L 1050.5 269 L 1062 258.5 L 1071 257.5 L 1074.5 254 L 1071.5 247 L 1073.5 234 L 1069.5 227 L 1069.5 224 L 1081.5 210 L 1082.5 205 L 1092 196.5 L 1097 201.5 L 1122 208.5 L 1144 208.5 L 1156 204.5 L 1156.5 205 L 1161.5 223 L 1160.5 224 L 1167.5 234 L 1165.5 255 L 1152 261.5 L 1145.5 269 L 1147.5 280 L 1143.5 284 Z",
      "position": {
        "x": 1113.95,
        "y": 246.57
      },
      "badgeAnchor": {
        "x": 1113.95,
        "y": 246.57
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mogilev",
      "name": "Mogilev",
      "regionId": "belarus",
      "adjacencies": [
        "bryansk",
        "gomel",
        "minsk",
        "smolensk",
        "vitebsk"
      ],
      "shape": "M 1233 291.5 L 1232.5 291 L 1228.5 282 L 1228.5 266 L 1234 234.5 L 1235 234.5 L 1240 232.5 L 1243.5 226 L 1262 210.5 L 1264 210.5 L 1277 213.5 L 1284 226.5 L 1288 228.5 L 1292 225.5 L 1301 226.5 L 1308 234.5 L 1314 236.5 L 1317.5 240 L 1317.5 244 L 1307 260.5 L 1298 264.5 L 1288 262.5 L 1280.5 270 L 1282.5 277 L 1295.5 289 L 1294.5 296 L 1297.5 303 L 1296 304.5 L 1280 306.5 L 1269 302.5 L 1260 294.5 L 1243 294.5 Z",
      "position": {
        "x": 1265.1,
        "y": 256.49
      },
      "badgeAnchor": {
        "x": 1265.1,
        "y": 256.49
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "minsk",
      "name": "Minsk",
      "regionId": "belarus",
      "adjacencies": [
        "gomel",
        "mogilev",
        "navahrudak",
        "slutsk",
        "vitebsk"
      ],
      "shape": "M 1147.5 280 L 1145.5 269 L 1152 261.5 L 1165.5 255 L 1167.5 234 L 1160.5 227 L 1163 221.5 L 1176 227.5 L 1200 229.5 L 1209 233.5 L 1233 234.5 L 1233.5 235 L 1228.5 266 L 1228.5 282 L 1233.5 292 L 1232.5 293 L 1230.5 306 L 1227 310.5 L 1185 310.5 L 1168 304.5 L 1156.5 297 Z",
      "position": {
        "x": 1193.23,
        "y": 271.51
      },
      "badgeAnchor": {
        "x": 1193.23,
        "y": 271.51
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "grodno",
      "name": "Grodno",
      "regionId": "belarus",
      "adjacencies": [
        "brest",
        "navahrudak",
        "podlachia",
        "slutsk",
        "vilna"
      ],
      "shape": "M 1033.5 346 L 1012.5 306 L 1009.5 292 L 1011 290.5 L 1037 283.5 L 1050 272.5 L 1052 273.5 L 1081 287.5 L 1096 285.5 L 1110 289.5 L 1131 289.5 L 1135.5 293 L 1143.5 314 L 1143.5 323 L 1134 347.5 L 1126 348.5 L 1104 342.5 L 1085 346.5 Z",
      "position": {
        "x": 1077.47,
        "y": 314.4
      },
      "badgeAnchor": {
        "x": 1077.47,
        "y": 314.4
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "slutsk",
      "name": "Slutsk",
      "regionId": "belarus",
      "adjacencies": [
        "brest",
        "gomel",
        "grodno",
        "minsk",
        "navahrudak",
        "volhynia",
        "zhytomyr"
      ],
      "shape": "M 1183 392.5 L 1181 392.5 L 1177 389.5 L 1168 391.5 L 1151.5 385 L 1151.5 372 L 1138.5 358 L 1134.5 348 L 1135.5 346 L 1143.5 323 L 1143.5 314 L 1134.5 292 L 1138 288.5 L 1147 280.5 L 1149.5 282 L 1156.5 297 L 1168 304.5 L 1185 310.5 L 1227.5 311 L 1227.5 312 L 1230.5 327 L 1224.5 344 L 1224.5 374 L 1226.5 377 L 1225 378.5 L 1216 385.5 L 1196 385.5 Z",
      "position": {
        "x": 1182.53,
        "y": 346.25
      },
      "badgeAnchor": {
        "x": 1182.53,
        "y": 346.25
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "gomel",
      "name": "Gomel",
      "regionId": "belarus",
      "adjacencies": [
        "bryansk",
        "kyiv",
        "minsk",
        "mogilev",
        "slutsk",
        "zhytomyr"
      ],
      "shape": "M 1227 377.5 L 1225.5 376 L 1224.5 344 L 1230.5 327 L 1227.5 310 L 1229.5 308 L 1234 291.5 L 1237 291.5 L 1243 294.5 L 1260 294.5 L 1269 302.5 L 1280 306.5 L 1297 303.5 L 1302.5 309 L 1308 321.5 L 1307 321.5 L 1292 328.5 L 1281.5 343 L 1278.5 361 L 1285.5 373 L 1282 381.5 L 1281 380.5 L 1272 373.5 L 1256 380.5 L 1248 380.5 L 1244 384.5 L 1232 377.5 Z",
      "position": {
        "x": 1256.02,
        "y": 336.85
      },
      "badgeAnchor": {
        "x": 1256.02,
        "y": 336.85
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "brest",
      "name": "Brest",
      "regionId": "belarus",
      "adjacencies": [
        "grodno",
        "podlachia",
        "slutsk",
        "volhynia"
      ],
      "shape": "M 1031.5 417 L 1030.5 396 L 1015.5 387 L 1015.5 379 L 1018.5 370 L 1033.5 355 L 1034 347.5 L 1035 347.5 L 1085 346.5 L 1104 342.5 L 1126 348.5 L 1134 347.5 L 1136.5 350 L 1138.5 358 L 1151.5 372 L 1151 385.5 L 1150 385.5 L 1146 387.5 L 1107 387.5 L 1060 402.5 L 1057.5 410 L 1048 417.5 L 1034 419.5 Z",
      "position": {
        "x": 1071.93,
        "y": 372.41
      },
      "badgeAnchor": {
        "x": 1071.93,
        "y": 372.41
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "chernihiv",
      "name": "Chernihiv",
      "regionId": "ukraine",
      "adjacencies": [
        "bryansk",
        "kyiv",
        "poltava"
      ],
      "shape": "M 1364 396.5 L 1362 396.5 L 1330 374.5 L 1320.5 362 L 1319 323.5 L 1329.5 316 L 1329.5 307 L 1334 302.5 L 1341 302.5 L 1349 298.5 L 1357 290.5 L 1380 288.5 L 1395 304.5 L 1405.5 310 L 1401.5 321 L 1414.5 339 L 1411 342.5 L 1395.5 356 L 1395.5 379 L 1390 384.5 L 1374 389.5 Z",
      "position": {
        "x": 1363.01,
        "y": 340.79
      },
      "badgeAnchor": {
        "x": 1363.01,
        "y": 340.79
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "poltava",
      "name": "Poltava",
      "regionId": "ukraine",
      "adjacencies": [
        "bryansk",
        "cherkasy",
        "chernihiv",
        "kyiv"
      ],
      "shape": "M 1437 479.5 L 1368.5 453 L 1368.5 452 L 1367.5 406 L 1363.5 401 L 1367 393.5 L 1390 384.5 L 1395.5 379 L 1395.5 356 L 1414 339.5 L 1417 339.5 L 1437.5 338 L 1437.5 479 Z",
      "position": {
        "x": 1407.27,
        "y": 412.54
      },
      "badgeAnchor": {
        "x": 1407.27,
        "y": 412.54
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "kyiv",
      "name": "Kyiv",
      "regionId": "ukraine",
      "adjacencies": [
        "bratslav",
        "cherkasy",
        "chernihiv",
        "gomel",
        "poltava",
        "zhytomyr"
      ],
      "shape": "M 1311 473.5 L 1310 472.5 L 1263.5 446 L 1267.5 439 L 1267.5 393 L 1280 385.5 L 1281.5 382 L 1284.5 379 L 1285.5 373 L 1278.5 361 L 1281.5 343 L 1292 328.5 L 1310 321.5 L 1317 324.5 L 1317.5 325 L 1320.5 330 L 1320.5 362 L 1325.5 370 L 1363 396.5 L 1363.5 397 L 1367.5 406 L 1368.5 454 L 1366 456.5 L 1362.5 459 L 1362.5 470 L 1356 474.5 L 1348 474.5 L 1341 468.5 L 1315 469.5 Z",
      "position": {
        "x": 1315.7,
        "y": 412.75
      },
      "badgeAnchor": {
        "x": 1315.7,
        "y": 412.75
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "zhytomyr",
      "name": "Zhytomyr",
      "regionId": "ukraine",
      "adjacencies": [
        "bratslav",
        "gomel",
        "kyiv",
        "podolia",
        "slutsk",
        "volhynia"
      ],
      "shape": "M 1217.5 508 L 1216.5 501 L 1202.5 475 L 1177.5 452 L 1177.5 450 L 1180.5 446 L 1180.5 396 L 1184 391.5 L 1196 385.5 L 1216 385.5 L 1226 377.5 L 1232 377.5 L 1244 384.5 L 1248 380.5 L 1256 380.5 L 1272 373.5 L 1281.5 381 L 1281.5 384 L 1267.5 393 L 1267.5 439 L 1263 446.5 L 1262 446.5 L 1253.5 454 L 1253.5 484 L 1251.5 487 L 1235 503.5 L 1219 509.5 Z",
      "position": {
        "x": 1224.17,
        "y": 433.86
      },
      "badgeAnchor": {
        "x": 1224.17,
        "y": 433.86
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "volhynia",
      "name": "Volhynia",
      "regionId": "ukraine",
      "adjacencies": [
        "brest",
        "podlachia",
        "podolia",
        "red-ruthenia",
        "slutsk",
        "transcarpathia",
        "zhytomyr"
      ],
      "shape": "M 1118 540.5 L 1117 539.5 L 1093 531.5 L 1079.5 523 L 1076.5 519 L 1076.5 499 L 1073.5 489 L 1066 485.5 L 1065.5 485 L 1065.5 473 L 1057.5 467 L 1056.5 457 L 1036.5 430 L 1033.5 420 L 1034 419.5 L 1052 415.5 L 1057.5 410 L 1058.5 404 L 1070 397.5 L 1084 396.5 L 1107 387.5 L 1152 385.5 L 1153 386.5 L 1162 387.5 L 1168 391.5 L 1177 389.5 L 1182 392.5 L 1181.5 394 L 1180.5 446 L 1177.5 451 L 1177 451.5 L 1155 456.5 L 1143.5 465 L 1135.5 516 L 1128.5 529 Z",
      "position": {
        "x": 1111.55,
        "y": 448.22
      },
      "badgeAnchor": {
        "x": 1111.55,
        "y": 448.22
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "cherkasy",
      "name": "Cherkasy",
      "regionId": "ukraine",
      "adjacencies": [
        "bratslav",
        "kyiv",
        "odessa",
        "poltava",
        "zaporizhzhia"
      ],
      "shape": "M 1370 565.5 L 1368 564.5 L 1343 562.5 L 1332.5 557 L 1335 554.5 L 1342.5 545 L 1343.5 514 L 1340.5 502 L 1311.5 473 L 1315 469.5 L 1341 468.5 L 1348 474.5 L 1356 474.5 L 1362.5 470 L 1362.5 459 L 1369 453.5 L 1374 453.5 L 1375 456.5 L 1437.5 480 L 1437 509.5 L 1409 511.5 L 1401.5 526 L 1387.5 538 L 1379.5 560 Z",
      "position": {
        "x": 1377.94,
        "y": 505.03
      },
      "badgeAnchor": {
        "x": 1377.94,
        "y": 505.03
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "bratslav",
      "name": "Bratslav",
      "regionId": "ukraine",
      "adjacencies": [
        "bessarabia",
        "cherkasy",
        "kyiv",
        "odessa",
        "podolia",
        "zhytomyr"
      ],
      "shape": "M 1280 582.5 L 1279 581.5 L 1269 574.5 L 1257 576.5 L 1253.5 574 L 1253.5 571 L 1254.5 546 L 1219.5 530 L 1215.5 520 L 1218 509.5 L 1219 509.5 L 1235 503.5 L 1251.5 487 L 1253.5 484 L 1253.5 454 L 1258 448.5 L 1264 446.5 L 1266 448.5 L 1276 451.5 L 1311.5 474 L 1311.5 475 L 1340.5 502 L 1343.5 514 L 1342.5 545 L 1333 556.5 L 1331 556.5 L 1308 556.5 L 1305.5 568 L 1301 573.5 L 1287 575.5 Z",
      "position": {
        "x": 1285.79,
        "y": 516.9
      },
      "badgeAnchor": {
        "x": 1285.79,
        "y": 516.9
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "podolia",
      "name": "Podolia",
      "regionId": "ukraine",
      "adjacencies": [
        "bessarabia",
        "bratslav",
        "maramures",
        "transcarpathia",
        "volhynia",
        "zhytomyr"
      ],
      "shape": "M 1179 589.5 L 1177 587.5 L 1150 584.5 L 1135 578.5 L 1124.5 562 L 1118.5 540 L 1119 539.5 L 1135.5 516 L 1143.5 465 L 1155 456.5 L 1173 451.5 L 1177 451.5 L 1185 459.5 L 1202.5 475 L 1218.5 509 L 1217.5 510 L 1215.5 520 L 1220 530.5 L 1254.5 546 L 1253.5 573 L 1253 573.5 L 1242 573.5 L 1230 567.5 L 1221 566.5 L 1204 577.5 L 1197 578.5 L 1192 584.5 L 1190 584.5 Z",
      "position": {
        "x": 1176.56,
        "y": 528.05
      },
      "badgeAnchor": {
        "x": 1176.56,
        "y": 528.05
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "transcarpathia",
      "name": "Transcarpathia",
      "regionId": "ukraine",
      "adjacencies": [
        "crisana",
        "maramures",
        "partium",
        "podolia",
        "red-ruthenia",
        "spis",
        "volhynia"
      ],
      "shape": "M 1128 629.5 L 1124 626.5 L 1111 620.5 L 1087 626.5 L 1058 622.5 L 1050 628.5 L 1047 625.5 L 1039 625.5 L 1032 620.5 L 1026 621.5 L 1016 611.5 L 1015.5 611 L 1018.5 585 L 1030 571.5 L 1032.5 571 L 1027.5 558 L 1025.5 542 L 1053.5 492 L 1067 485.5 L 1073.5 489 L 1076.5 499 L 1076.5 519 L 1079.5 523 L 1093 531.5 L 1118.5 541 L 1118.5 542 L 1124.5 562 L 1135 578.5 L 1155 585.5 L 1172 585.5 L 1179.5 590 L 1167 607.5 L 1143 615.5 Z",
      "position": {
        "x": 1079.09,
        "y": 575.05
      },
      "badgeAnchor": {
        "x": 1079.09,
        "y": 575.05
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "zaporizhzhia",
      "name": "Zaporizhzhia",
      "regionId": "ukraine",
      "adjacencies": [
        "cherkasy",
        "odessa"
      ],
      "shape": "M 1395 625.5 L 1394.5 625 L 1391.5 608 L 1370.5 594 L 1371 564.5 L 1379.5 560 L 1387.5 538 L 1401.5 526 L 1409 511.5 L 1437.5 510 L 1437.5 615 L 1430 616.5 L 1427 612.5 L 1420 612.5 L 1411 621.5 Z",
      "position": {
        "x": 1408.71,
        "y": 568.6
      },
      "badgeAnchor": {
        "x": 1408.71,
        "y": 568.6
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "odessa",
      "name": "Odessa",
      "regionId": "ukraine",
      "adjacencies": [
        "bessarabia",
        "bratslav",
        "budjak",
        "cherkasy",
        "dobruja",
        "zaporizhzhia"
      ],
      "shape": "M 1300.5 722 L 1300.5 720 L 1298.5 713 L 1305.5 701 L 1310.5 682 L 1306.5 674 L 1307.5 665 L 1318 661.5 L 1329 662.5 L 1336.5 656 L 1337.5 648 L 1333.5 638 L 1324 634.5 L 1312.5 617 L 1298.5 606 L 1290.5 590 L 1280.5 582 L 1287 575.5 L 1301 573.5 L 1305.5 568 L 1306.5 558 L 1310 555.5 L 1332 556.5 L 1336 560.5 L 1366 563.5 L 1369.5 566 L 1370.5 594 L 1391.5 608 L 1394 625.5 L 1392 625.5 L 1363.5 646 L 1364.5 694 L 1359 700.5 L 1352 700.5 L 1342.5 708 L 1343.5 716 L 1340 721.5 L 1338 720.5 L 1329 719.5 L 1325 723.5 Z",
      "position": {
        "x": 1351.7,
        "y": 616.77
      },
      "badgeAnchor": {
        "x": 1351.7,
        "y": 616.77
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "bessarabia",
      "name": "Bessarabia",
      "regionId": "moldova",
      "adjacencies": [
        "bratslav",
        "budjak",
        "maramures",
        "moldavia",
        "odessa",
        "podolia"
      ],
      "shape": "M 1258 645.5 L 1253 640.5 L 1251 640.5 L 1250 639.5 L 1249 639.5 L 1247.5 638 L 1202 588.5 L 1192.5 584 L 1193.5 583 L 1197 578.5 L 1204 577.5 L 1221 566.5 L 1255 575.5 L 1269 574.5 L 1280.5 583 L 1280.5 584 L 1290.5 590 L 1299.5 607 L 1297 610.5 L 1265 636.5 Z",
      "position": {
        "x": 1251.22,
        "y": 601.02
      },
      "badgeAnchor": {
        "x": 1251.22,
        "y": 601.02
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "budjak",
      "name": "Budjak",
      "regionId": "moldova",
      "adjacencies": [
        "bessarabia",
        "dobruja",
        "moldavia",
        "odessa"
      ],
      "shape": "M 1283 723.5 L 1282.5 723 L 1274.5 698 L 1273.5 672 L 1263.5 651 L 1258.5 646 L 1259.5 644 L 1265 636.5 L 1300 607.5 L 1302 609.5 L 1312.5 617 L 1324 634.5 L 1333.5 638 L 1337.5 654 L 1329 662.5 L 1318 661.5 L 1307.5 665 L 1306.5 674 L 1310.5 682 L 1305.5 701 L 1298.5 713 L 1300.5 723 L 1300 723.5 L 1287 725.5 Z",
      "position": {
        "x": 1294.69,
        "y": 649.46
      },
      "badgeAnchor": {
        "x": 1294.69,
        "y": 649.46
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "maramures",
      "name": "Maramureș",
      "regionId": "romania",
      "adjacencies": [
        "bessarabia",
        "crisana",
        "moldavia",
        "podolia",
        "szekely-land",
        "transcarpathia",
        "transylvania"
      ],
      "shape": "M 1150 711.5 L 1138 707.5 L 1124 707.5 L 1116.5 703 L 1116.5 660 L 1126.5 647 L 1125.5 640 L 1129 628.5 L 1143 615.5 L 1167 607.5 L 1180 589.5 L 1182 589.5 L 1193 584.5 L 1194 585.5 L 1202 588.5 L 1248.5 639 L 1247 641.5 L 1234 647.5 L 1211 647.5 L 1200.5 655 L 1198.5 687 L 1187 708.5 L 1185 708.5 L 1184 709.5 L 1175 709.5 L 1174 710.5 L 1171 710.5 L 1170 711.5 Z",
      "position": {
        "x": 1170.14,
        "y": 652.28
      },
      "badgeAnchor": {
        "x": 1170.14,
        "y": 652.28
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crisana",
      "name": "Crișana",
      "regionId": "romania",
      "adjacencies": [
        "banat",
        "maramures",
        "partium",
        "transcarpathia",
        "transylvania"
      ],
      "shape": "M 1059 717.5 L 1013.5 689 L 1013.5 688 L 1019.5 669 L 1019.5 660 L 1030 646.5 L 1042 643.5 L 1051 628.5 L 1052 628.5 L 1058 622.5 L 1087 626.5 L 1113 620.5 L 1127.5 630 L 1126.5 647 L 1116.5 660 L 1116 703.5 L 1115 703.5 L 1107 709.5 L 1072 720.5 L 1062 720.5 Z",
      "position": {
        "x": 1073.16,
        "y": 670.1
      },
      "badgeAnchor": {
        "x": 1073.16,
        "y": 670.1
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "moldavia",
      "name": "Moldavia",
      "regionId": "romania",
      "adjacencies": [
        "bessarabia",
        "budjak",
        "dobruja",
        "maramures",
        "szekely-land"
      ],
      "shape": "M 1188 708.5 L 1187.5 708 L 1187.5 707 L 1188.5 706 L 1188.5 705 L 1191.5 702 L 1191.5 701 L 1193.5 699 L 1193.5 698 L 1195.5 696 L 1195.5 695 L 1196.5 694 L 1196.5 691 L 1197.5 690 L 1197.5 688 L 1198.5 687 L 1198.5 659 L 1199.5 658 L 1199.5 657 L 1200.5 656 L 1200.5 655 L 1201 654.5 L 1202 654.5 L 1203 653.5 L 1204 653.5 L 1205 652.5 L 1206 652.5 L 1211 647.5 L 1234 647.5 L 1235 646.5 L 1238 646.5 L 1239 645.5 L 1240 645.5 L 1242 643.5 L 1243 643.5 L 1245 641.5 L 1247 641.5 L 1249 639.5 L 1250 639.5 L 1251 640.5 L 1253 640.5 L 1263.5 651 L 1273.5 672 L 1274.5 698 L 1280.5 712 L 1282 723.5 L 1281 723.5 L 1268 725.5 L 1262.5 738 L 1262 738.5 L 1225 739.5 L 1196 730.5 L 1189.5 725 L 1192.5 713 Z",
      "position": {
        "x": 1235.03,
        "y": 693.55
      },
      "badgeAnchor": {
        "x": 1235.03,
        "y": 693.55
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "transylvania",
      "name": "Transylvania",
      "regionId": "romania",
      "adjacencies": [
        "banat",
        "crisana",
        "maramures",
        "oltenia",
        "szekely-land"
      ],
      "shape": "M 1071.5 780 L 1071.5 778 L 1061.5 752 L 1061.5 721 L 1062 720.5 L 1080 718.5 L 1107 709.5 L 1117 703.5 L 1118 704.5 L 1151 711.5 L 1150.5 713 L 1149.5 782 L 1148 783.5 L 1133 788.5 L 1116 788.5 L 1098 778.5 Z",
      "position": {
        "x": 1109.51,
        "y": 746.85
      },
      "badgeAnchor": {
        "x": 1109.51,
        "y": 746.85
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "banat",
      "name": "Banat",
      "regionId": "romania",
      "adjacencies": [
        "belgrade",
        "crisana",
        "great-plain",
        "oltenia",
        "partium",
        "transylvania",
        "vojvodina"
      ],
      "shape": "M 1024.5 807 L 1024.5 806 L 1020 801.5 L 1010 799.5 L 996 793.5 L 987.5 784 L 986.5 777 L 970 764.5 L 964 754.5 L 965 754.5 L 969 750.5 L 976 749.5 L 985 741.5 L 992 742.5 L 999.5 737 L 999.5 725 L 1005.5 716 L 1007.5 703 L 1013.5 690 L 1015 690.5 L 1061.5 720 L 1061.5 752 L 1070.5 773 L 1071.5 783 L 1060 792.5 L 1032 806.5 Z",
      "position": {
        "x": 1025.68,
        "y": 755.83
      },
      "badgeAnchor": {
        "x": 1025.68,
        "y": 755.83
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "szekely-land",
      "name": "Székely Land",
      "regionId": "romania",
      "adjacencies": [
        "dobruja",
        "maramures",
        "moldavia",
        "oltenia",
        "transylvania",
        "wallachia"
      ],
      "shape": "M 1177 808.5 L 1169 796.5 L 1149.5 783 L 1149.5 781 L 1152 711.5 L 1170 711.5 L 1171 710.5 L 1174 710.5 L 1175 709.5 L 1184 709.5 L 1185 708.5 L 1189 708.5 L 1192.5 713 L 1189.5 725 L 1196 730.5 L 1225 739.5 L 1262.5 739 L 1262.5 741 L 1250.5 775 L 1245.5 781 L 1245 781.5 L 1208 781.5 L 1187 803.5 Z",
      "position": {
        "x": 1192.92,
        "y": 757.86
      },
      "badgeAnchor": {
        "x": 1192.92,
        "y": 757.86
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "dobruja",
      "name": "Dobruja",
      "regionId": "romania",
      "adjacencies": [
        "budjak",
        "moldavia",
        "odessa",
        "szekely-land",
        "varna",
        "wallachia"
      ],
      "shape": "M 1249 820.5 L 1247.5 819 L 1245.5 780 L 1250.5 775 L 1258.5 756 L 1258.5 748 L 1263.5 742 L 1262.5 737 L 1268 725.5 L 1284 723.5 L 1297 725.5 L 1301 722.5 L 1325 723.5 L 1329 719.5 L 1340 722.5 L 1346.5 726 L 1347 730.5 L 1353.5 732 L 1353.5 748 L 1335 749.5 L 1325.5 756 L 1328.5 764 L 1327.5 814 L 1330.5 821 L 1328 821.5 L 1310 824.5 L 1298 817.5 L 1280 818.5 L 1272 814.5 L 1259 815.5 Z M 1349.5 743 L 1348.5 737 L 1349 743.5 Z",
      "position": {
        "x": 1293.11,
        "y": 771.62
      },
      "badgeAnchor": {
        "x": 1293.11,
        "y": 771.62
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "oltenia",
      "name": "Oltenia",
      "regionId": "romania",
      "adjacencies": [
        "banat",
        "belgrade",
        "eastern-rumelia",
        "sofia",
        "szekely-land",
        "transylvania",
        "wallachia"
      ],
      "shape": "M 1075.5 845 L 1069.5 839 L 1073.5 829 L 1069 824.5 L 1065 823.5 L 1054 834.5 L 1046 829.5 L 1036 830.5 L 1025.5 822 L 1022.5 814 L 1025 807.5 L 1032 806.5 L 1060 792.5 L 1071.5 781 L 1072 780.5 L 1098 778.5 L 1116 788.5 L 1133 788.5 L 1149 782.5 L 1156 789.5 L 1169 796.5 L 1178 808.5 L 1178.5 809 L 1183.5 830 L 1183.5 844 L 1177 857.5 L 1173 860.5 L 1161 860.5 L 1154 866.5 L 1111 863.5 L 1104 868.5 L 1097 869.5 L 1090.5 864 L 1093.5 857 Z",
      "position": {
        "x": 1117.79,
        "y": 822.36
      },
      "badgeAnchor": {
        "x": 1117.79,
        "y": 822.36
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "wallachia",
      "name": "Wallachia",
      "regionId": "romania",
      "adjacencies": [
        "dobruja",
        "eastern-rumelia",
        "oltenia",
        "szekely-land",
        "varna",
        "sofia"
      ],
      "shape": "M 1178.5 856 L 1183.5 844 L 1179 808.5 L 1180 808.5 L 1208 781.5 L 1245.5 782 L 1245.5 783 L 1248.5 820 L 1246 822.5 L 1231 829.5 L 1220.5 839 L 1218.5 846 L 1213 852.5 L 1202 857.5 L 1183 858.5 Z",
      "position": {
        "x": 1212.13,
        "y": 815.8
      },
      "badgeAnchor": {
        "x": 1212.13,
        "y": 815.8
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "varna",
      "name": "Varna",
      "regionId": "bulgaria",
      "adjacencies": [
        "dobruja",
        "eastern-rumelia",
        "edirne",
        "wallachia"
      ],
      "shape": "M 1275.5 939 L 1272.5 911 L 1266 903.5 L 1259 901.5 L 1229.5 873 L 1226.5 865 L 1226.5 850 L 1220 845.5 L 1219.5 845 L 1220.5 839 L 1231 829.5 L 1248 820.5 L 1252 820.5 L 1259 815.5 L 1272 814.5 L 1280 818.5 L 1298 817.5 L 1310 824.5 L 1331 821.5 L 1330.5 841 L 1319.5 850 L 1320.5 858 L 1315.5 864 L 1312.5 876 L 1299.5 891 L 1299.5 897 L 1303.5 902 L 1302.5 913 L 1304 911.5 L 1311 915.5 L 1315 921.5 L 1322 921.5 L 1324.5 925 L 1322.5 927 L 1314 934.5 L 1310 935.5 L 1301 929.5 L 1295 929.5 L 1281 939.5 Z",
      "position": {
        "x": 1274.92,
        "y": 861.04
      },
      "badgeAnchor": {
        "x": 1274.92,
        "y": 861.04
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "eastern-rumelia",
      "name": "Eastern Rumelia",
      "regionId": "bulgaria",
      "adjacencies": [
        "edirne",
        "oltenia",
        "sofia",
        "varna",
        "wallachia",
        "western-thrace"
      ],
      "shape": "M 1172.5 988 L 1172.5 987 L 1171.5 924 L 1166.5 913 L 1164.5 893 L 1157.5 884 L 1154.5 866 L 1157 863.5 L 1161 860.5 L 1173 860.5 L 1178 856.5 L 1180 857.5 L 1202 857.5 L 1213 852.5 L 1219 845.5 L 1221 845.5 L 1226.5 850 L 1226.5 865 L 1229.5 873 L 1259 901.5 L 1266 903.5 L 1272.5 911 L 1276.5 940 L 1271.5 946 L 1264.5 956 L 1261 959.5 L 1253.5 964 L 1259.5 974 L 1259.5 981 L 1242 991.5 L 1223 998.5 L 1217 993.5 L 1196 994.5 L 1187 988.5 Z",
      "position": {
        "x": 1213.97,
        "y": 926.51
      },
      "badgeAnchor": {
        "x": 1213.97,
        "y": 926.51
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "sofia",
      "name": "Sofia",
      "regionId": "bulgaria",
      "adjacencies": [
        "belgrade",
        "eastern-rumelia",
        "nis",
        "oltenia",
        "salonika",
        "skopje",
        "western-thrace",
        "wallachia"
      ],
      "shape": "M 1123 1011.5 L 1122.5 1011 L 1122.5 1003 L 1121.5 1002 L 1121.5 1001 L 1119.5 999 L 1119.5 994 L 1120.5 993 L 1119.5 992 L 1119.5 991 L 1118.5 990 L 1118.5 989 L 1114.5 985 L 1114.5 983 L 1113.5 982 L 1113.5 981 L 1110.5 978 L 1110.5 977 L 1109 975.5 L 1107 975.5 L 1103 971.5 L 1101 971.5 L 1100 970.5 L 1099 970.5 L 1094 965.5 L 1093 965.5 L 1092.5 965 L 1092.5 964 L 1090.5 962 L 1090.5 961 L 1088.5 959 L 1088.5 957 L 1092.5 953 L 1091.5 947 L 1087.5 944 L 1085.5 930 L 1095.5 923 L 1102.5 908 L 1095 898.5 L 1088 897.5 L 1078.5 888 L 1072.5 877 L 1071.5 864 L 1081 850.5 L 1093.5 857 L 1090.5 864 L 1097 869.5 L 1104 868.5 L 1111 863.5 L 1154.5 867 L 1154.5 868 L 1155.5 869 L 1155.5 873 L 1156.5 874 L 1156.5 875 L 1157.5 876 L 1157.5 884 L 1158.5 885 L 1158.5 886 L 1159.5 887 L 1159.5 888 L 1164.5 893 L 1164.5 895 L 1165.5 896 L 1165.5 900 L 1166.5 901 L 1166.5 913 L 1167.5 914 L 1167.5 915 L 1168.5 916 L 1168.5 920 L 1170.5 922 L 1170.5 923 L 1171.5 924 L 1171.5 986 L 1172.5 987 L 1172.5 989 L 1170.5 991 L 1170.5 992 L 1169 993.5 L 1168 993.5 L 1164 997.5 L 1163 997.5 L 1162 998.5 L 1159 998.5 L 1158 999.5 L 1157 999.5 L 1155 1001.5 L 1153 1001.5 L 1152 1002.5 L 1151 1002.5 L 1150 1003.5 L 1145 1003.5 L 1142 1006.5 L 1141 1006.5 L 1140 1007.5 L 1137 1007.5 L 1136 1008.5 L 1135 1008.5 L 1131 1012.5 L 1130 1012.5 L 1129 1013.5 L 1127 1013.5 L 1126 1012.5 L 1125 1012.5 L 1124 1011.5 Z",
      "position": {
        "x": 1131.26,
        "y": 931.53
      },
      "badgeAnchor": {
        "x": 1131.26,
        "y": 931.53
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "edirne",
      "name": "Edirne",
      "regionId": "turkey",
      "adjacencies": [
        "constantinople",
        "eastern-rumelia",
        "varna",
        "western-thrace"
      ],
      "shape": "M 1270.5 1018 L 1270.5 1011 L 1276.5 1001 L 1270.5 994 L 1270.5 990 L 1281.5 975 L 1277.5 966 L 1264.5 957 L 1264.5 954 L 1277 940.5 L 1295 929.5 L 1301 929.5 L 1310 935.5 L 1314 934.5 L 1324 925.5 L 1332.5 933 L 1337 941.5 L 1355 952.5 L 1358 950.5 L 1404 950.5 L 1408.5 954 L 1406.5 963 L 1400.5 968 L 1398 983.5 L 1358 983.5 L 1345 990.5 L 1340 989.5 L 1335 993.5 L 1330 993.5 L 1321.5 1003 L 1321.5 1011 L 1313 1018.5 Z",
      "position": {
        "x": 1320.74,
        "y": 970.93
      },
      "badgeAnchor": {
        "x": 1320.74,
        "y": 970.93
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "constantinople",
      "name": "Constantinople",
      "regionId": "turkey",
      "adjacencies": [
        "edirne",
        "gallipoli"
      ],
      "shape": "M 1412 1067.5 L 1411.5 1067 L 1411.5 1040 L 1392 1022.5 L 1386 1020.5 L 1379.5 1011 L 1380 1010.5 L 1407.5 1001 L 1409.5 994 L 1404.5 989 L 1404.5 985 L 1398.5 983 L 1400.5 968 L 1406.5 963 L 1409 953.5 L 1414 953.5 L 1430 941.5 L 1437.5 943 L 1437.5 1067 Z M 1433.5 949 L 1434 945.5 L 1431.5 948 L 1433 949.5 Z",
      "position": {
        "x": 1422,
        "y": 1006
      },
      "badgeAnchor": {
        "x": 1422,
        "y": 1006
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "gallipoli",
      "name": "Gallipoli",
      "regionId": "turkey",
      "adjacencies": [
        "constantinople"
      ],
      "shape": "M 1411 1067.5 L 1285 1067.5 L 1286 1036.5 L 1297 1035.5 L 1309 1029.5 L 1313 1030.5 L 1320 1022.5 L 1337 1027.5 L 1342.5 1024 L 1343 1020.5 L 1362 1019.5 L 1371 1012.5 L 1379 1011.5 L 1379.5 1013 L 1411.5 1040 Z",
      "position": {
        "x": 1352.6,
        "y": 1045.36
      },
      "badgeAnchor": {
        "x": 1352.6,
        "y": 1045.36
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "konigsberg",
      "name": "Prussia",
      "regionId": "prussia",
      "adjacencies": [
        "masuria",
        "podlachia",
        "samogitia",
        "vilna"
      ],
      "shape": "M 874.5 278 L 876.5 270 L 889 254.5 L 896 250.5 L 903 251.5 L 913.5 245 L 913.5 227 L 920 226.5 L 946 234.5 L 962 228.5 L 963 229.5 L 973.5 238 L 975.5 243 L 973.5 253 L 976.5 267 L 974 269.5 L 968 273.5 L 935 278.5 L 881 280.5 Z M 889.5 263 L 891.5 261 L 891 260.5 L 890 260.5 L 889.5 261 L 889.5 262 L 888.5 263 L 889 263.5 Z M 881.5 274 L 883.5 272 L 883 271.5 L 882 272.5 L 881 272.5 L 880.5 273 L 880.5 274 L 881 274.5 Z",
      "position": {
        "x": 934.04,
        "y": 256.73
      },
      "badgeAnchor": {
        "x": 934.04,
        "y": 256.73
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "pskov",
      "name": "Pskov",
      "regionId": "russia",
      "adjacencies": [
        "dorpat",
        "livonia",
        "novgorod",
        "velikiye-luki",
        "toropets"
      ],
      "shape": "M 1191 71.5 L 1174 67.5 L 1123 68.5 L 1113 64.5 L 1097 67.5 L 1080 56.5 L 1079.5 56 L 1080.5 46 L 1085.5 36 L 1080.5 25 L 1073.5 19 L 1071 -0.5 L 1178 -0.5 L 1178.5 0 L 1179.5 22 L 1188.5 33 L 1193.5 46 L 1193.5 67 Z",
      "position": {
        "x": 1134.11,
        "y": 33.9
      },
      "badgeAnchor": {
        "x": 1134.11,
        "y": 33.9
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "novgorod",
      "name": "Novgorod",
      "regionId": "russia",
      "adjacencies": [
        "pskov",
        "rzhev",
        "toropets",
        "tver",
        "velikiye-luki"
      ],
      "shape": "M 1198 80.5 L 1192.5 76 L 1191.5 71 L 1192.5 70 L 1193.5 46 L 1188.5 33 L 1179.5 22 L 1179 -0.5 L 1358.5 0 L 1358.5 65 L 1355 72.5 L 1354 72.5 L 1339 77.5 L 1322 77.5 L 1299 70.5 L 1294 75.5 L 1288 76.5 L 1209 75.5 Z",
      "position": {
        "x": 1273.08,
        "y": 37.12
      },
      "badgeAnchor": {
        "x": 1273.08,
        "y": 37.12
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tver",
      "name": "Tver",
      "regionId": "russia",
      "adjacencies": [
        "novgorod",
        "rzhev"
      ],
      "shape": "M 1355.5 72 L 1358.5 65 L 1359 -0.5 L 1437 -0.5 L 1437.5 88 L 1437 88.5 L 1416 94.5 L 1395 94.5 L 1384.5 88 L 1380 75.5 L 1362 75.5 Z",
      "position": {
        "x": 1399.71,
        "y": 43.88
      },
      "badgeAnchor": {
        "x": 1399.71,
        "y": 43.88
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "velikiye-luki",
      "name": "Velikiye Luki",
      "regionId": "russia",
      "adjacencies": [
        "livonia",
        "polotsk",
        "pskov",
        "toropets",
        "vitebsk",
        "novgorod"
      ],
      "shape": "M 1177 144.5 L 1176 143.5 L 1170.5 139 L 1170.5 134 L 1167 130.5 L 1157 130.5 L 1150 134.5 L 1142 128.5 L 1134 132.5 L 1126 129.5 L 1125.5 129 L 1118.5 110 L 1099.5 91 L 1097.5 69 L 1098 68.5 L 1113 64.5 L 1123 68.5 L 1174 67.5 L 1191.5 72 L 1191.5 73 L 1197.5 81 L 1198.5 92 L 1204.5 98 L 1210.5 114 L 1207 131.5 L 1203 131.5 L 1193 131.5 Z",
      "position": {
        "x": 1156.78,
        "y": 99.34
      },
      "badgeAnchor": {
        "x": 1156.78,
        "y": 99.34
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "toropets",
      "name": "Toropets",
      "regionId": "russia",
      "adjacencies": [
        "novgorod",
        "rzhev",
        "smolensk",
        "velikiye-luki",
        "vitebsk",
        "pskov"
      ],
      "shape": "M 1258 203.5 L 1255.5 202 L 1230.5 177 L 1235.5 168 L 1224.5 155 L 1227.5 148 L 1226.5 143 L 1207.5 131 L 1208.5 130 L 1210.5 114 L 1204.5 98 L 1198.5 92 L 1199 79.5 L 1209 75.5 L 1289 76.5 L 1289.5 77 L 1299.5 100 L 1295.5 130 L 1294 131.5 L 1286.5 138 L 1276.5 158 L 1275.5 195 Z",
      "position": {
        "x": 1252.64,
        "y": 123.85
      },
      "badgeAnchor": {
        "x": 1252.64,
        "y": 123.85
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "rzhev",
      "name": "Rzhev",
      "regionId": "russia",
      "adjacencies": [
        "kaluga",
        "novgorod",
        "smolensk",
        "toropets",
        "tver"
      ],
      "shape": "M 1373 166.5 L 1371 165.5 L 1349 164.5 L 1341.5 160 L 1340.5 152 L 1332 143.5 L 1301 135.5 L 1295.5 131 L 1295.5 129 L 1298.5 121 L 1299.5 100 L 1289.5 81 L 1290 76.5 L 1291 76.5 L 1299 70.5 L 1322 77.5 L 1339 77.5 L 1356 72.5 L 1357 73.5 L 1380 75.5 L 1384.5 88 L 1395 94.5 L 1416 94.5 L 1427 89.5 L 1437.5 89 L 1437 150.5 L 1425 153.5 L 1396 154.5 Z",
      "position": {
        "x": 1365.67,
        "y": 118.07
      },
      "badgeAnchor": {
        "x": 1365.67,
        "y": 118.07
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "smolensk",
      "name": "Smolensk",
      "regionId": "russia",
      "adjacencies": [
        "bryansk",
        "kaluga",
        "mogilev",
        "rzhev",
        "toropets",
        "vitebsk"
      ],
      "shape": "M 1315 236.5 L 1312 236.5 L 1311 235.5 L 1310 235.5 L 1309 234.5 L 1308 234.5 L 1304.5 231 L 1304.5 229 L 1303 227.5 L 1302 227.5 L 1301 226.5 L 1295 226.5 L 1294 225.5 L 1292 225.5 L 1290 227.5 L 1289 227.5 L 1288 228.5 L 1287 227.5 L 1286 227.5 L 1285 226.5 L 1284 226.5 L 1282.5 225 L 1282.5 221 L 1281.5 220 L 1281.5 219 L 1279.5 217 L 1279.5 216 L 1277 213.5 L 1269 213.5 L 1268 212.5 L 1267 212.5 L 1266 211.5 L 1265 211.5 L 1264 210.5 L 1261 210.5 L 1260.5 210 L 1260.5 209 L 1257.5 206 L 1257.5 204 L 1259 202.5 L 1268 200.5 L 1275.5 195 L 1276.5 158 L 1286.5 138 L 1295 130.5 L 1298 133.5 L 1332 143.5 L 1340.5 152 L 1341.5 160 L 1349 164.5 L 1372.5 167 L 1374.5 194 L 1372.5 201 L 1367 209.5 L 1357.5 216 L 1357 216.5 L 1348 217.5 L 1336 228.5 L 1330 231.5 L 1319 231.5 Z",
      "position": {
        "x": 1318.6,
        "y": 185.83
      },
      "badgeAnchor": {
        "x": 1318.6,
        "y": 185.83
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "kaluga",
      "name": "Kaluga",
      "regionId": "russia",
      "adjacencies": [
        "bryansk",
        "rzhev",
        "smolensk"
      ],
      "shape": "M 1437 247.5 L 1409 247.5 L 1400 237.5 L 1393 236.5 L 1389.5 233 L 1389.5 228 L 1384 222.5 L 1357.5 217 L 1357.5 215 L 1371.5 204 L 1374.5 194 L 1372.5 185 L 1374 165.5 L 1400 153.5 L 1437.5 151 Z",
      "position": {
        "x": 1407.5,
        "y": 197.02
      },
      "badgeAnchor": {
        "x": 1407.5,
        "y": 197.02
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "bryansk",
      "name": "Bryansk",
      "regionId": "russia",
      "adjacencies": [
        "chernihiv",
        "gomel",
        "kaluga",
        "mogilev",
        "poltava",
        "smolensk"
      ],
      "shape": "M 1415 339.5 L 1413.5 338 L 1401.5 321 L 1405.5 310 L 1395 304.5 L 1380 288.5 L 1357 290.5 L 1349 298.5 L 1341 302.5 L 1334 302.5 L 1329.5 307 L 1329.5 316 L 1318 324.5 L 1315 324.5 L 1309 321.5 L 1308.5 321 L 1297.5 304 L 1297.5 301 L 1294.5 296 L 1295.5 289 L 1282.5 277 L 1280.5 270 L 1288 262.5 L 1298 264.5 L 1307 260.5 L 1318.5 242 L 1314.5 237 L 1315.5 236 L 1319 231.5 L 1330 231.5 L 1336 228.5 L 1348 217.5 L 1358 217.5 L 1384 222.5 L 1389.5 228 L 1389.5 233 L 1393 236.5 L 1400 237.5 L 1409 247.5 L 1437.5 248 L 1437.5 337 L 1437 337.5 Z",
      "position": {
        "x": 1365.98,
        "y": 258.25
      },
      "badgeAnchor": {
        "x": 1365.98,
        "y": 258.25
      },
      "ownerId": "",
      "armies": 0
    }
  ],
  "regions": [
    {
      "id": "united-kingdom",
      "name": "United Kingdom",
      "bonus": 7,
      "color": "#a0d673",
      "territoryIds": [
        "ulster",
        "highlands",
        "grampian",
        "strathclyde",
        "galloway",
        "lothian",
        "cumbria",
        "northumbria",
        "wales",
        "mercia",
        "east-anglia",
        "wessex",
        "cornwall"
      ],
      "shape": "M 102 435.5 L 98 436.5 L 88 433.5 L 50 432.5 L 37 418.5 L 14 413.5 L 10.5 410 L 10.5 401 L 25 390.5 L 39 388.5 L 58 370.5 L 63.5 370 L 63.5 358 L 49.5 348 L 53.5 343 L 50.5 337 L 50.5 324 L 53 321.5 L 63 321.5 L 73 335.5 L 86 335.5 L 93 330.5 L 96 331.5 L 101.5 324 L 101.5 323 L 102.5 321 L 94.5 315 L 93.5 310 L 96.5 300 L 102.5 293 L 98.5 266 L 92.5 260 L 93 248.5 L 78 251.5 L 74 248.5 L 60 248.5 L 57.5 246 L 58.5 242 L 53 240.5 L 48.5 235 L 50.5 219 L 57 212.5 L 66 212.5 L 64.5 206 L 66.5 204 L 66.5 177 L 60 171.5 L 54.5 174 L 58.5 177 L 58.5 189 L 55.5 193 L 48 195.5 L 43.5 191 L 43.5 182 L 46.5 175 L 51.5 172 L 44.5 170 L 44.5 162 L 55 148.5 L 61.5 147 L 61.5 134 L 50 135.5 L 48.5 143 L 45 145.5 L 34 145.5 L 30.5 144 L 29.5 129 L 53.5 104 L 59.5 87 L 67.5 77 L 65.5 61 L 80.5 57 L 85.5 40 L 95.5 34 L 97 23.5 L 106 23.5 L 122 30.5 L 144 30.5 L 148.5 34 L 148.5 41 L 143 47.5 L 112.5 60 L 111.5 77 L 121 84.5 L 155 85.5 L 181.5 102 L 181 108.5 L 170 111.5 L 164.5 118 L 166.5 125 L 159.5 140 L 145 146.5 L 141.5 154 L 126.5 166 L 126.5 182 L 135 186.5 L 158 187.5 L 161.5 191 L 166.5 203 L 166.5 219 L 170.5 227 L 170.5 259 L 168.5 259 L 183 274.5 L 184 274.5 L 198 284.5 L 204.5 293 L 205.5 331 L 211.5 340 L 209.5 363 L 212 376.5 L 224 378.5 L 227 373.5 L 236 372.5 L 247.5 379 L 246.5 383 L 252.5 390 L 252.5 415 L 243.5 432 L 226 441.5 L 219.5 448 L 215.5 459 L 222 467.5 L 235 470.5 L 237.5 480 L 232 484.5 L 208 490.5 L 202 498.5 L 182 494.5 L 162 483.5 L 108 483.5 L 82 480.5 L 74 484.5 L 55 485.5 L 49.5 491 L 49.5 499 L 47 501.5 L 38 501.5 L 27 493.5 L 12 493.5 L 4 498.5 L 1 497.5 L -0.5 501 L 0 471.5 L 1 476.5 L 8 468.5 L 25 461.5 L 33 450.5 L 40 446.5 L 47 446.5 L 61 455.5 L 77 455.5 L 85 448.5 L 101 446.5 Z M 145.5 90 L 131.5 90 L 145 90.5 Z M 0 282.5 L -0.5 201 L 4 203.5 L 8 197.5 L 16.5 200 L 25.5 212 L 30.5 234 L 37.5 247 L 46.5 254 L 46.5 263 L 40 269.5 L 34 271.5 L 16 269.5 L 9 277.5 L 2 275.5 L 0.5 282 Z M 51.5 428 L 54.5 426 L 48.5 423 L 51 428.5 Z M 34.5 456 L 36 454.5 L 37 454.5 L 37.5 454 L 37 453.5 L 36 453.5 L 33.5 456 L 34 456.5 Z",
      "bonusAnchor": {
        "x": 140.39,
        "y": 339.94
      }
    },
    {
      "id": "spain",
      "name": "Spain",
      "bonus": 3,
      "color": "#fc7344",
      "territoryIds": [
        "asturias",
        "basque-country",
        "galicia",
        "catalonia",
        "leon",
        "castile"
      ],
      "shape": "M 0 1067.5 L -0.5 914 L 9 909.5 L 13 910.5 L 15 904.5 L 27 904.5 L 32 907.5 L 57 907.5 L 61.5 910 L 70.5 918 L 79 933.5 L 96 941.5 L 102 950.5 L 105 950.5 L 106 951.5 L 108 951.5 L 109 950.5 L 111 950.5 L 112 949.5 L 113 949.5 L 114 950.5 L 116 950.5 L 118 952.5 L 119 952.5 L 121.5 955 L 121.5 957 L 125 960.5 L 145 960.5 L 147 962.5 L 150 962.5 L 153.5 959 L 153.5 958 L 156 955.5 L 162 955.5 L 165 958.5 L 166 958.5 L 167 959.5 L 168 959.5 L 169 960.5 L 172 960.5 L 174 962.5 L 175 962.5 L 177 964.5 L 179 964.5 L 180 965.5 L 182 965.5 L 184 967.5 L 187 967.5 L 188 968.5 L 189 968.5 L 191 970.5 L 192 970.5 L 193 971.5 L 197 971.5 L 200.5 975 L 200.5 981 L 201 981.5 L 212 987.5 L 224 987.5 L 231 991.5 L 252 986.5 L 261.5 988 L 264.5 1019 L 258 1024.5 L 250 1024.5 L 245 1029.5 L 242 1028.5 L 238 1035.5 L 226 1042.5 L 221 1050.5 L 214 1054.5 L 199 1053.5 L 195 1053.5 L 173 1055.5 L 158 1067.5 Z",
      "bonusAnchor": {
        "x": 111.07,
        "y": 1006.93
      }
    },
    {
      "id": "france",
      "name": "France",
      "bonus": 8,
      "color": "#fdfc84",
      "territoryIds": [
        "picardy",
        "normandy",
        "champagne",
        "brittany",
        "lorraine",
        "ile-de-france",
        "anjou",
        "burgundy",
        "auvergne",
        "poitou",
        "provence",
        "languedoc",
        "toulouse",
        "gascony",
        "corsica"
      ],
      "shape": "M 200.5 981 L 200.5 979 L 197 971.5 L 177 964.5 L 162 955.5 L 156 955.5 L 150 962.5 L 125 960.5 L 116 950.5 L 106 951.5 L 100.5 949 L 96 941.5 L 84 937.5 L 75.5 930 L 70.5 918 L 62.5 913 L 61.5 908 L 71.5 903 L 85 877.5 L 93 877.5 L 95.5 875 L 95.5 794 L 99.5 791 L 98.5 785 L 105.5 776 L 104.5 755 L 104.5 747 L 96.5 742 L 96.5 739 L 90.5 735 L 90.5 731 L 82.5 724 L 76.5 694 L 73.5 691 L 72 685.5 L 61.5 679 L 53 663.5 L 41 658.5 L 34 651.5 L 28 650.5 L 24 643.5 L 11 639.5 L 1 639.5 L -0.5 642 L -0.5 613 L 1 616.5 L 3 615.5 L 3.5 611 L -0.5 609 L -0.5 585 L 10 590.5 L 30 590.5 L 46 582.5 L 53 582.5 L 63.5 594 L 63.5 599 L 70 606.5 L 112 606.5 L 115.5 603 L 115.5 553 L 118 550.5 L 130 551.5 L 140.5 559 L 141 567.5 L 154 573.5 L 169 572.5 L 173 575.5 L 182 575.5 L 191 573.5 L 193.5 564 L 211 549.5 L 220 549.5 L 223 546.5 L 244.5 536 L 244.5 494 L 249 489.5 L 257 489.5 L 261 484.5 L 284.5 485 L 284.5 501 L 288.5 507 L 304 511.5 L 308.5 516 L 308.5 526 L 317 529.5 L 326 538.5 L 326.5 539 L 330.5 552 L 338 561.5 L 363 568.5 L 384 586.5 L 394 586.5 L 397 589.5 L 405 592.5 L 411 589.5 L 419 593.5 L 429 605.5 L 430 605.5 L 438 606.5 L 443 610.5 L 455 610.5 L 463 616.5 L 473 616.5 L 482.5 624 L 481.5 625 L 479.5 631 L 470.5 639 L 466.5 659 L 458.5 670 L 454.5 690 L 457.5 699 L 456.5 701 L 447 710.5 L 437 706.5 L 431.5 713 L 430.5 719 L 412.5 738 L 412.5 744 L 402 751.5 L 400.5 753 L 396.5 762 L 398.5 771 L 399 771.5 L 411 764.5 L 420 765.5 L 423.5 773 L 422.5 782 L 432.5 792 L 433.5 797 L 432 798.5 L 426.5 806 L 436.5 830 L 430 839.5 L 421 841.5 L 418.5 847 L 432.5 860 L 432.5 866 L 425.5 876 L 427.5 889 L 447 898.5 L 455 897.5 L 458.5 902 L 444.5 922 L 444.5 926 L 439 932.5 L 436 931.5 L 425 940.5 L 414 943.5 L 412.5 951 L 407 955.5 L 371 956.5 L 365.5 952 L 365.5 945 L 356 940.5 L 352 940.5 L 348 935.5 L 317 935.5 L 315 932.5 L 306 931.5 L 302 935.5 L 273 935.5 L 272.5 936 L 262.5 944 L 263.5 949 L 259.5 953 L 260 986.5 L 231 991.5 L 224 987.5 L 212 987.5 Z M 101.5 796 L 102.5 793 L 100.5 793 L 101 796.5 Z M 520 1060.5 L 507.5 1057 L 504.5 1043 L 491.5 1027 L 496.5 1007 L 494.5 997 L 496.5 989 L 517 986.5 L 525 977.5 L 532.5 980 L 532.5 989 L 537.5 997 L 537.5 1014 L 534.5 1017 L 530.5 1036 L 530.5 1053 L 525 1059.5 L 521 1059.5 Z",
      "bonusAnchor": {
        "x": 267.51,
        "y": 743.96
      }
    },
    {
      "id": "netherlands",
      "name": "Netherlands",
      "bonus": 1,
      "color": "#fc8001",
      "territoryIds": [
        "friesland",
        "holland"
      ],
      "shape": "M 410 519.5 L 398.5 517 L 393.5 504 L 393.5 489 L 391 486.5 L 379 484.5 L 375 486.5 L 371.5 483 L 371.5 476 L 367 472.5 L 346 474.5 L 324.5 462 L 327.5 459 L 328.5 447 L 335 445.5 L 340.5 439 L 341.5 427 L 349.5 420 L 353.5 403 L 363.5 394 L 363.5 391 L 372 389.5 L 380.5 398 L 379.5 402 L 383 402.5 L 385 400.5 L 393.5 395 L 387.5 386 L 389 369.5 L 406 363.5 L 442 364.5 L 443 361.5 L 446 364.5 L 447 364.5 L 448 365.5 L 449 365.5 L 450 366.5 L 451 366.5 L 453.5 369 L 453.5 370 L 454.5 371 L 454.5 372 L 453.5 373 L 453.5 388 L 452.5 389 L 452.5 390 L 451.5 391 L 451.5 392 L 449.5 394 L 449.5 395 L 448.5 396 L 448.5 399 L 446.5 401 L 446.5 403 L 445.5 404 L 445.5 405 L 444 406.5 L 441 406.5 L 440 407.5 L 439 407.5 L 436.5 410 L 436.5 415 L 444.5 423 L 444.5 424 L 445.5 425 L 445.5 429 L 444.5 430 L 444.5 431 L 436.5 439 L 436.5 441 L 435.5 442 L 435.5 445 L 432 448.5 L 421 449.5 L 408.5 456 L 414.5 478 L 414.5 508 Z",
      "bonusAnchor": {
        "x": 396.55,
        "y": 428.21
      }
    },
    {
      "id": "belgium",
      "name": "Belgium",
      "bonus": 1,
      "color": "#aac201",
      "territoryIds": [
        "flanders",
        "wallonia"
      ],
      "shape": "M 393 586.5 L 384 586.5 L 363 568.5 L 338 561.5 L 330.5 552 L 326 538.5 L 325 538.5 L 317 529.5 L 308.5 526 L 308.5 516 L 304 511.5 L 292 509.5 L 285.5 503 L 285 484.5 L 299 478.5 L 315 465.5 L 322 462.5 L 327 464.5 L 346 474.5 L 367 472.5 L 371.5 476 L 371.5 483 L 375 486.5 L 377 486.5 L 379 484.5 L 391 486.5 L 393.5 489 L 393.5 504 L 398.5 517 L 411.5 521 L 412.5 526 L 418 530.5 L 418.5 531 L 420.5 537 L 417.5 545 L 398.5 561 L 396.5 571 L 399.5 577 Z",
      "bonusAnchor": {
        "x": 356.75,
        "y": 520.15
      }
    },
    {
      "id": "switzerland",
      "name": "Switzerland",
      "bonus": 1,
      "color": "#fd8101",
      "territoryIds": [
        "vaud",
        "zurich"
      ],
      "shape": "M 433.5 796 L 433.5 795 L 422.5 782 L 423.5 773 L 420 765.5 L 411 764.5 L 398.5 771 L 398.5 770 L 396.5 762 L 402 751.5 L 403 751.5 L 412.5 744 L 412.5 738 L 430.5 719 L 431.5 713 L 437 706.5 L 447 710.5 L 458 699.5 L 459 700.5 L 484 699.5 L 489 701.5 L 499 695.5 L 517 695.5 L 532 700.5 L 538 707.5 L 543 703.5 L 552.5 707 L 550.5 710 L 554.5 742 L 559.5 759 L 558 759.5 L 555.5 762 L 555 773.5 L 546 772.5 L 538 776.5 L 529 769.5 L 513 794.5 L 510 794.5 L 497.5 785 L 491.5 772 L 487 768.5 L 478.5 777 L 478.5 783 L 467 794.5 Z",
      "bonusAnchor": {
        "x": 483.52,
        "y": 737.2
      }
    },
    {
      "id": "norway",
      "name": "Norway",
      "bonus": 1,
      "color": "#fcfc7a",
      "territoryIds": [
        "rogaland",
        "viken"
      ],
      "shape": "M 600 -0.5 L 600.5 0 L 602.5 28 L 600.5 38 L 595 44.5 L 585 38.5 L 579 39.5 L 578 35.5 L 575 36.5 L 572.5 33 L 571.5 21 L 566 17.5 L 563.5 33 L 558 37.5 L 550 38.5 L 545 43.5 L 538 44.5 L 527.5 60 L 514.5 72 L 513.5 77 L 503 86.5 L 465 91.5 L 462 93.5 L 443 91.5 L 433.5 77 L 428 76.5 L 421.5 69 L 417.5 60 L 416.5 40 L 423.5 33 L 427.5 20 L 422 14.5 L 408 15.5 L 402.5 5 L 399.5 4 L 400 -0.5 Z",
      "bonusAnchor": {
        "x": 480.72,
        "y": 43
      }
    },
    {
      "id": "denmark",
      "name": "Denmark",
      "bonus": 2,
      "color": "#fcb3e3",
      "territoryIds": [
        "jutland",
        "schleswig",
        "zealand"
      ],
      "shape": "M 506 280.5 L 505.5 261 L 489.5 241 L 489.5 213 L 483.5 205 L 483.5 187 L 494.5 178 L 496.5 152 L 506 145.5 L 531 146.5 L 535.5 143 L 540 129.5 L 564 125.5 L 564.5 152 L 556.5 179 L 580 180.5 L 585.5 185 L 585.5 211 L 583 213.5 L 569 213.5 L 563 218.5 L 556.5 230 L 572 230.5 L 576.5 234 L 578.5 252 L 576.5 253 L 576.5 270 L 564 271.5 L 561 265.5 L 554.5 262 L 554.5 258 L 547 253.5 L 540.5 257 L 539.5 268 L 544.5 274 L 545.5 281 L 535 281.5 L 524 283.5 Z M 579.5 189 L 579 184.5 L 571.5 185 L 579 189.5 Z M 603 294.5 L 596 292.5 L 587.5 283 L 590 275.5 L 606.5 275 L 604.5 269 L 595.5 260 L 589.5 246 L 589.5 240 L 599.5 226 L 598.5 219 L 614 206.5 L 625 206.5 L 629.5 215 L 627.5 240 L 633.5 249 L 632.5 259 L 625.5 266 L 625.5 270 L 630.5 275 L 627.5 286 L 621 292.5 L 603.5 294 Z",
      "bonusAnchor": {
        "x": 566.96,
        "y": 216.77
      }
    },
    {
      "id": "sweden",
      "name": "Sweden",
      "bonus": 2,
      "color": "#adc401",
      "territoryIds": [
        "svealand",
        "vastergotland",
        "ostergotland",
        "scania"
      ],
      "shape": "M 625.5 166 L 624.5 165 L 618.5 158 L 618.5 150 L 615.5 147 L 615.5 129 L 608.5 123 L 608.5 118 L 601.5 107 L 602.5 102 L 597 100.5 L 592 91.5 L 585.5 89 L 584.5 60 L 578.5 53 L 578.5 42 L 582 39.5 L 585 38.5 L 595 44.5 L 600.5 38 L 602.5 28 L 599.5 11 L 601 -0.5 L 732 -0.5 L 733.5 5 L 742 9.5 L 773 10.5 L 779 8.5 L 784.5 3 L 784 -0.5 L 793 -0.5 L 792 1.5 L 798 2.5 L 801.5 7 L 800 14.5 L 787 22.5 L 780 23.5 L 779.5 27 L 772.5 31 L 772.5 37 L 766 43.5 L 761 43.5 L 756.5 50 L 756.5 102 L 750.5 119 L 750.5 139 L 747.5 143 L 747.5 190 L 744.5 197 L 742 199.5 L 717 200.5 L 694 209.5 L 689.5 214 L 690.5 237 L 686 241.5 L 677 243.5 L 676.5 247 L 670 251.5 L 655 251.5 L 649.5 246 L 649.5 225 L 646.5 218 L 632.5 203 L 637.5 187 L 634.5 180 L 627.5 175 Z",
      "bonusAnchor": {
        "x": 676.32,
        "y": 107.8
      }
    },
    {
      "id": "germany",
      "name": "Germany",
      "bonus": 6,
      "color": "#9066c7",
      "territoryIds": [
        "holstein",
        "mecklenburg",
        "hanover",
        "brandenburg",
        "thuringia",
        "saxony",
        "westphalia",
        "hesse",
        "franconia",
        "rhineland",
        "bavaria",
        "swabia"
      ],
      "shape": "M 550 704.5 L 543 703.5 L 538 707.5 L 528 698.5 L 505 694.5 L 499 695.5 L 494 700.5 L 471 701.5 L 459 700.5 L 456.5 698 L 454.5 690 L 458.5 670 L 466.5 659 L 470.5 639 L 479.5 631 L 482.5 624 L 481 622.5 L 473 616.5 L 463 616.5 L 455 610.5 L 443 610.5 L 438 606.5 L 429 605.5 L 427.5 604 L 419 593.5 L 411 589.5 L 401 591.5 L 393.5 586 L 394.5 585 L 399.5 577 L 396.5 571 L 398.5 561 L 417.5 545 L 420.5 537 L 418 530.5 L 417 530.5 L 410.5 520 L 411.5 518 L 411.5 516 L 412.5 515 L 412.5 513 L 413.5 512 L 413.5 509 L 414.5 508 L 414.5 506 L 413.5 505 L 413.5 485 L 414.5 484 L 414.5 478 L 413.5 477 L 413.5 471 L 411.5 469 L 411.5 468 L 409.5 466 L 409.5 461 L 408.5 460 L 408.5 456 L 411 453.5 L 432 448.5 L 435.5 445 L 436.5 439 L 445.5 429 L 444.5 423 L 436.5 415 L 436.5 410 L 445.5 405 L 453.5 388 L 454.5 371 L 442.5 361 L 446.5 356 L 446.5 350 L 451.5 347 L 453.5 340 L 458 336.5 L 475 336.5 L 479 340.5 L 486 340.5 L 489 351.5 L 495 351.5 L 500 346.5 L 500.5 346 L 503.5 337 L 510.5 329 L 504.5 281 L 515 280.5 L 524 283.5 L 546 281.5 L 546.5 290 L 560 304.5 L 565 307.5 L 571 306.5 L 576 310.5 L 584 310.5 L 587.5 314 L 586.5 322 L 590 331.5 L 597 331.5 L 609 331.5 L 610.5 326 L 618.5 320 L 621.5 310 L 629 304.5 L 637 302.5 L 654 306.5 L 656 303.5 L 661 303.5 L 666.5 308 L 667.5 315 L 677 325.5 L 692 327.5 L 696.5 333 L 695.5 337 L 694.5 345 L 700.5 371 L 692.5 390 L 694.5 392 L 712.5 411 L 712.5 415 L 710.5 419 L 718.5 435 L 714.5 456 L 719.5 468 L 727.5 474 L 725 487.5 L 711 494.5 L 706 494.5 L 684 499.5 L 670 509.5 L 662 509.5 L 658 513.5 L 645.5 522 L 632.5 547 L 641.5 558 L 640.5 563 L 649.5 590 L 650.5 591 L 653.5 597 L 675 617.5 L 692.5 629 L 695.5 640 L 689 650.5 L 688 650.5 L 683 658.5 L 676 658.5 L 659.5 667 L 670.5 692 L 668 699.5 L 657 693.5 L 643 692.5 L 639 695.5 L 619 699.5 L 604 707.5 L 593 705.5 L 574 702.5 L 567 712.5 L 558 713.5 Z M 683.5 329 L 679.5 329 L 683 329.5 Z",
      "bonusAnchor": {
        "x": 572.99,
        "y": 496.41
      }
    },
    {
      "id": "italy",
      "name": "Italy",
      "bonus": 4,
      "color": "#a0d575",
      "territoryIds": [
        "venetia",
        "lombardy",
        "piedmont",
        "tuscany",
        "papal-states",
        "campania",
        "apulia"
      ],
      "shape": "M 690 1067.5 L 676 1065.5 L 673.5 1062 L 676.5 1060 L 674 1057.5 L 669 1055.5 L 668 1058.5 L 666 1057.5 L 656.5 1046 L 656.5 1041 L 654 1038.5 L 650 1039.5 L 644.5 1034 L 644.5 1017 L 642 1014.5 L 634 1015.5 L 627.5 1011 L 627 1007.5 L 613 1004.5 L 609 997.5 L 604.5 996 L 602.5 990 L 602 983.5 L 598 984.5 L 590.5 980 L 590.5 968 L 573.5 960 L 573.5 948 L 564.5 940 L 562.5 923 L 557.5 920 L 558.5 906 L 548 902.5 L 542 892.5 L 539 892.5 L 533 886.5 L 509 886.5 L 488.5 898 L 471 926.5 L 451 927.5 L 447 926.5 L 444.5 922 L 458.5 902 L 455 897.5 L 447 898.5 L 427.5 889 L 425.5 876 L 432.5 866 L 432.5 860 L 418.5 847 L 421 841.5 L 430 839.5 L 436.5 830 L 426.5 806 L 426.5 803 L 434 796.5 L 453 793.5 L 464 795.5 L 471 792.5 L 478.5 783 L 478.5 777 L 487 768.5 L 488 769.5 L 497.5 785 L 513 794.5 L 513.5 794 L 529 769.5 L 538 776.5 L 546 772.5 L 555 773.5 L 555.5 762 L 563 759.5 L 568.5 759 L 571 745.5 L 579 745.5 L 584 749.5 L 591 748.5 L 591.5 748 L 595.5 737 L 600 733.5 L 622 735.5 L 627 732.5 L 637 732.5 L 639.5 735 L 639.5 740 L 652 751.5 L 692 758.5 L 694.5 761 L 694.5 763 L 687.5 775 L 698.5 792 L 701.5 803 L 700 806.5 L 689 806.5 L 687 811.5 L 659 814.5 L 652.5 819 L 652.5 868 L 656.5 874 L 657.5 886 L 657.5 891 L 664 899.5 L 685 913.5 L 693 915.5 L 701.5 923 L 711.5 939 L 711.5 945 L 720.5 966 L 740.5 987 L 743.5 1003 L 749.5 1009 L 758 1015.5 L 806 1015.5 L 823.5 1029 L 824 1043.5 L 834 1048.5 L 841 1048.5 L 864 1060.5 L 865 1067.5 Z M 563.5 917 L 563 914.5 L 561.5 916 L 563 917.5 Z",
      "bonusAnchor": {
        "x": 621.41,
        "y": 915.42
      }
    },
    {
      "id": "austria",
      "name": "Austria",
      "bonus": 2,
      "color": "#fdfc04",
      "territoryIds": [
        "upper-austria",
        "styria",
        "salzburg",
        "tyrol"
      ],
      "shape": "M 695 761.5 L 692 758.5 L 652 751.5 L 639.5 740 L 637 732.5 L 627 732.5 L 622 735.5 L 600 733.5 L 595.5 737 L 591 748.5 L 587 748.5 L 571 745.5 L 568.5 759 L 560 759.5 L 558.5 758 L 550.5 712 L 553 707.5 L 555.5 710 L 558 713.5 L 565 713.5 L 574 702.5 L 594 706.5 L 604 707.5 L 619 699.5 L 641 693.5 L 657 693.5 L 668 699.5 L 670.5 692 L 659.5 667 L 676 658.5 L 683 658.5 L 689 650.5 L 689.5 650 L 696 639.5 L 701 639.5 L 708 635.5 L 709 636.5 L 716 637.5 L 725 623.5 L 745 610.5 L 755 610.5 L 764 614.5 L 786.5 615 L 786.5 616 L 789 620.5 L 800 624.5 L 802 623.5 L 812 622.5 L 815.5 625 L 815.5 626 L 821.5 633 L 819.5 647 L 831.5 663 L 829.5 665 L 827.5 676 L 824 679.5 L 809.5 683 L 813.5 691 L 805.5 700 L 805.5 705 L 810.5 715 L 799.5 729 L 799 729.5 L 795 730.5 L 785 741.5 L 754 750.5 L 753 750.5 L 752 751.5 L 745 751.5 L 744.5 752 L 744.5 753 L 740.5 757 L 734 763.5 L 716 763.5 L 708 759.5 Z",
      "bonusAnchor": {
        "x": 732.7,
        "y": 697.49
      }
    },
    {
      "id": "slovenia",
      "name": "Slovenia",
      "bonus": 1,
      "color": "#f056bf",
      "territoryIds": [
        "carniola",
        "littoral"
      ],
      "shape": "M 702.5 807 L 701 808.5 L 700.5 806 L 698.5 792 L 687.5 775 L 694.5 762 L 696 760.5 L 708 759.5 L 716 763.5 L 734 763.5 L 744.5 753 L 744.5 752 L 745 751.5 L 752 751.5 L 753 750.5 L 754 750.5 L 756 748.5 L 760 748.5 L 761 747.5 L 764 747.5 L 765 746.5 L 772 746.5 L 775 743.5 L 779 743.5 L 780 742.5 L 782 742.5 L 783 741.5 L 785 741.5 L 790.5 736 L 790.5 735 L 795 730.5 L 797 730.5 L 798 729.5 L 799 729.5 L 801 731.5 L 806.5 737 L 809 747.5 L 808 747.5 L 788.5 765 L 790.5 777 L 774.5 793 L 775.5 803 L 768.5 807 L 768.5 808 L 765.5 813 L 764 814.5 L 749 815.5 L 745 812.5 L 738 812.5 L 730 817.5 L 710 821.5 L 702.5 816 Z",
      "bonusAnchor": {
        "x": 745.66,
        "y": 786.19
      }
    },
    {
      "id": "czech-republic",
      "name": "Czech Republic",
      "bonus": 2,
      "color": "#fdd4ed",
      "territoryIds": [
        "bohemia",
        "moravia",
        "czech-silesia"
      ],
      "shape": "M 697 639.5 L 696.5 639 L 692.5 629 L 675 617.5 L 653.5 597 L 649.5 590 L 649.5 589 L 640.5 563 L 641.5 558 L 632.5 547 L 645.5 522 L 662 509.5 L 670 509.5 L 676 503.5 L 690 497.5 L 711 494.5 L 712 493.5 L 726 486.5 L 728 487.5 L 763 506.5 L 773 506.5 L 778 510.5 L 783 510.5 L 788 515.5 L 798 527.5 L 800 526.5 L 804 524.5 L 830 525.5 L 861 538.5 L 869.5 545 L 879.5 569 L 876.5 572 L 875.5 586 L 866 592.5 L 853 595.5 L 845 607.5 L 826 608.5 L 820.5 614 L 820.5 620 L 815 624.5 L 814 623.5 L 801 624.5 L 799 623.5 L 789 620.5 L 786.5 615 L 786 614.5 L 764 614.5 L 755 610.5 L 745 610.5 L 725 623.5 L 716 637.5 L 708 635.5 L 707 636.5 Z",
      "bonusAnchor": {
        "x": 757.15,
        "y": 559.12
      }
    },
    {
      "id": "slovakia",
      "name": "Slovakia",
      "bonus": 2,
      "color": "#99d56d",
      "territoryIds": [
        "spis",
        "liptov",
        "pressburg"
      ],
      "shape": "M 868 672.5 L 849 671.5 L 832 663.5 L 830.5 662 L 819.5 647 L 821.5 633 L 815.5 624 L 817 622.5 L 826 608.5 L 845 607.5 L 853 595.5 L 866 592.5 L 870 588.5 L 875.5 586 L 876.5 572 L 880 568.5 L 886 568.5 L 891 573.5 L 911 570.5 L 927 580.5 L 930 580.5 L 934.5 573 L 935 572.5 L 945 569.5 L 955 567.5 L 962 569.5 L 967 562.5 L 975 558.5 L 991 558.5 L 1026.5 575 L 1025.5 576 L 1018.5 585 L 1015 611.5 L 1014 611.5 L 1001 619.5 L 987 619.5 L 971 611.5 L 956.5 613 L 956.5 614 L 950.5 623 L 948.5 631 L 941 638.5 L 929 643.5 L 927 641.5 L 920 640.5 L 913 647.5 L 897 653.5 L 890.5 661 L 890.5 665 L 883 671.5 Z",
      "bonusAnchor": {
        "x": 910.47,
        "y": 609.14
      }
    },
    {
      "id": "hungary",
      "name": "Hungary",
      "bonus": 2,
      "color": "#9c8c01",
      "territoryIds": [
        "partium",
        "great-plain",
        "transdanubia",
        "pest"
      ],
      "shape": "M 809.5 747 L 806.5 737 L 799.5 730 L 799.5 728 L 809.5 719 L 810.5 715 L 805.5 705 L 805.5 700 L 813.5 691 L 809.5 683 L 824 679.5 L 827.5 676 L 831 663.5 L 834 663.5 L 849 671.5 L 869 673.5 L 885 670.5 L 890.5 665 L 890.5 661 L 891.5 660 L 897 653.5 L 913 647.5 L 920 640.5 L 929 643.5 L 930 642.5 L 941 638.5 L 948.5 631 L 954.5 619 L 956.5 613 L 957 612.5 L 971 611.5 L 987 619.5 L 1001 619.5 L 1017 611.5 L 1026 621.5 L 1032 620.5 L 1050.5 629 L 1049.5 630 L 1042 643.5 L 1030 646.5 L 1019.5 660 L 1013.5 691 L 1007.5 703 L 1005.5 716 L 999.5 725 L 999.5 737 L 992 742.5 L 985 741.5 L 982 744.5 L 965 754.5 L 945 754.5 L 938 755.5 L 933 760.5 L 927 766.5 L 917 769.5 L 908 776.5 L 907 775.5 L 903 775.5 L 896 782.5 L 887 786.5 L 881 785.5 L 880 786.5 L 868 787.5 L 850 778.5 Z",
      "bonusAnchor": {
        "x": 921.67,
        "y": 709.2
      }
    },
    {
      "id": "croatia",
      "name": "Croatia",
      "bonus": 2,
      "color": "#fcfb86",
      "territoryIds": [
        "slavonia",
        "zagorje",
        "dalmatia"
      ],
      "shape": "M 880 956.5 L 866 956.5 L 859 952.5 L 843 935.5 L 825 927.5 L 815 918.5 L 808 924.5 L 795 921.5 L 787.5 916 L 771.5 891 L 753.5 862 L 751.5 846 L 743 831.5 L 733 829.5 L 730.5 832 L 731.5 841 L 720 847.5 L 718 852.5 L 705.5 851 L 693.5 831 L 693.5 822 L 697.5 815 L 701 813.5 L 702.5 816 L 710 821.5 L 730 817.5 L 738 812.5 L 745 812.5 L 749 815.5 L 762 815.5 L 765.5 813 L 765.5 812 L 768.5 807 L 769 806.5 L 775.5 803 L 774.5 793 L 790.5 777 L 788.5 765 L 810 747.5 L 813 750.5 L 836 765.5 L 850 778.5 L 868 787.5 L 881 785.5 L 883 785.5 L 892 784.5 L 903 775.5 L 908.5 777 L 908.5 778 L 913.5 785 L 918.5 804 L 929.5 815 L 924.5 821 L 925.5 831 L 919 835.5 L 908 826.5 L 902 827.5 L 880 822.5 L 873 827.5 L 848 827.5 L 843 830.5 L 842 829.5 L 834 825.5 L 820 826.5 L 810 838.5 L 797 827.5 L 788.5 827 L 788.5 828 L 788.5 846 L 793 855.5 L 795 855.5 L 810.5 870 L 816.5 887 L 834.5 902 L 847 917.5 L 856 922.5 L 862.5 932 L 878.5 945 Z M 874.5 951 L 871 947.5 L 868.5 949 L 874 951.5 Z",
      "bonusAnchor": {
        "x": 767.68,
        "y": 874.45
      }
    },
    {
      "id": "bosnia-and-herzegovina",
      "name": "Bosnia and Herzegovina",
      "bonus": 2,
      "color": "#fd8001",
      "territoryIds": [
        "krajina",
        "sarajevo",
        "drina"
      ],
      "shape": "M 912 959.5 L 882 956.5 L 881 956.5 L 880.5 956 L 878.5 945 L 862.5 932 L 856 922.5 L 847 917.5 L 833 900.5 L 816.5 887 L 810.5 870 L 793 855.5 L 791.5 854 L 788.5 846 L 788.5 827 L 789 826.5 L 797 827.5 L 810 838.5 L 820 826.5 L 834 825.5 L 843 830.5 L 844 829.5 L 873 827.5 L 880 822.5 L 903 826.5 L 908 826.5 L 919 835.5 L 926 830.5 L 931 830.5 L 937.5 836 L 934.5 849 L 935.5 868 L 947 874.5 L 950.5 881 L 944.5 886 L 944.5 890 L 953.5 898 L 955.5 905 L 932.5 915 L 932.5 921 L 921.5 934 L 921.5 940 L 915.5 948 Z",
      "bonusAnchor": {
        "x": 880.48,
        "y": 878.1
      }
    },
    {
      "id": "serbia",
      "name": "Serbia",
      "bonus": 2,
      "color": "#fdd5ee",
      "territoryIds": [
        "vojvodina",
        "belgrade",
        "sumadija",
        "nis"
      ],
      "shape": "M 913.5 958 L 915.5 948 L 921.5 940 L 921.5 934 L 932.5 921 L 932.5 915 L 955.5 905 L 953.5 898 L 944.5 890 L 950.5 878 L 935.5 868 L 934.5 849 L 937.5 836 L 934 831.5 L 927 830.5 L 926.5 830 L 924.5 821 L 929.5 815 L 918.5 804 L 908.5 776 L 910 774.5 L 927 766.5 L 938 755.5 L 944 755.5 L 963 754.5 L 963.5 755 L 970 764.5 L 986.5 777 L 987.5 784 L 996 793.5 L 1011 800.5 L 1022 802.5 L 1024.5 808 L 1022.5 810 L 1025.5 822 L 1036 830.5 L 1046 829.5 L 1054 834.5 L 1065 823.5 L 1069 824.5 L 1073.5 829 L 1069.5 839 L 1080.5 850 L 1079.5 852 L 1071.5 864 L 1072.5 877 L 1078.5 888 L 1088 897.5 L 1093 897.5 L 1099.5 903 L 1102.5 910 L 1095.5 923 L 1085.5 930 L 1087.5 944 L 1092.5 949 L 1092.5 953 L 1088 957.5 L 1069 962.5 L 1045 977.5 L 1035 976.5 L 1017 987.5 L 1011.5 983 L 1008 976.5 L 1000 973.5 L 988 961.5 L 976 965.5 L 975.5 966 L 961.5 976 L 956.5 986 L 955.5 997 L 942 992.5 L 932.5 982 L 932.5 977 L 926.5 969 L 918 964.5 L 915 959.5 L 913 960.5 Z",
      "bonusAnchor": {
        "x": 1003.46,
        "y": 892.34
      }
    },
    {
      "id": "albania",
      "name": "Albania",
      "bonus": 1,
      "color": "#fdfc04",
      "territoryIds": [
        "shkoder"
      ],
      "shape": "M 1046 1067.5 L 969 1067.5 L 968.5 1067 L 968.5 1062 L 969.5 1061 L 969.5 1059 L 970.5 1058 L 970.5 1057 L 969.5 1056 L 969.5 1054 L 968.5 1053 L 968.5 1042 L 969.5 1041 L 969.5 1024 L 970.5 1023 L 970.5 1022 L 971.5 1021 L 971.5 1019 L 972.5 1018 L 972.5 1015 L 971 1013.5 L 968 1013.5 L 967 1012.5 L 966 1012.5 L 962.5 1009 L 962.5 1008 L 962 1007.5 L 961 1007.5 L 957.5 1004 L 957.5 1001 L 957 1000.5 L 956 1000.5 L 955.5 1000 L 955.5 996 L 956.5 995 L 956.5 986 L 958.5 984 L 958.5 983 L 959.5 982 L 959.5 980 L 960.5 979 L 960.5 978 L 961.5 977 L 961.5 976 L 963 974.5 L 964 974.5 L 965 973.5 L 966 973.5 L 967 972.5 L 968 972.5 L 969 971.5 L 970 971.5 L 972 969.5 L 973 969.5 L 975.5 967 L 975.5 966 L 976 965.5 L 978 965.5 L 979 964.5 L 981 964.5 L 983 962.5 L 984 962.5 L 985 961.5 L 988 961.5 L 990 963.5 L 991 963.5 L 992 964.5 L 993 964.5 L 994.5 966 L 994.5 967 L 995.5 968 L 995.5 969 L 1000 973.5 L 1002 973.5 L 1003 974.5 L 1004 974.5 L 1005 975.5 L 1006 975.5 L 1007 976.5 L 1008 976.5 L 1010.5 979 L 1010.5 980 L 1011.5 981 L 1011.5 983 L 1016.5 988 L 1016.5 990 L 1017.5 991 L 1017.5 993 L 1016.5 994 L 1016.5 995 L 1015.5 996 L 1015.5 998 L 1013.5 1000 L 1013.5 1003 L 1012.5 1004 L 1012.5 1006 L 1013.5 1007 L 1013.5 1009 L 1014.5 1010 L 1014.5 1011 L 1015.5 1012 L 1015.5 1014 L 1014.5 1015 L 1014.5 1016 L 1013.5 1017 L 1013.5 1021 L 1015.5 1023 L 1015.5 1024 L 1016.5 1025 L 1016.5 1034 L 1017.5 1035 L 1017.5 1036 L 1019.5 1038 L 1019.5 1039 L 1021 1040.5 L 1023 1040.5 L 1025.5 1043 L 1025.5 1044 L 1026.5 1045 L 1026.5 1047 L 1027.5 1048 L 1027.5 1049 L 1031 1052.5 L 1038 1052.5 L 1043.5 1058 L 1043.5 1062 L 1045.5 1064 L 1045.5 1065 L 1046.5 1066 L 1046.5 1067 L 1046 1067.5 Z",
      "bonusAnchor": {
        "x": 984.83,
        "y": 1034.4
      }
    },
    {
      "id": "north-macedonia",
      "name": "North Macedonia",
      "bonus": 1,
      "color": "#fdbd4e",
      "territoryIds": [
        "skopje"
      ],
      "shape": "M 1044 1057.5 L 1043 1057.5 L 1038 1052.5 L 1031 1052.5 L 1027.5 1049 L 1027.5 1048 L 1026.5 1047 L 1026.5 1045 L 1025.5 1044 L 1025.5 1043 L 1023 1040.5 L 1021 1040.5 L 1019.5 1039 L 1019.5 1038 L 1017.5 1036 L 1017.5 1035 L 1016.5 1034 L 1016.5 1025 L 1015.5 1024 L 1015.5 1023 L 1013.5 1021 L 1013.5 1017 L 1014.5 1016 L 1014.5 1015 L 1015.5 1014 L 1015.5 1012 L 1014.5 1011 L 1014.5 1010 L 1013.5 1009 L 1013.5 1007 L 1012.5 1006 L 1012.5 1004 L 1013.5 1003 L 1013.5 1000 L 1015.5 998 L 1015.5 996 L 1016.5 995 L 1016.5 994 L 1017.5 993 L 1017.5 991 L 1016.5 990 L 1016.5 988 L 1020 984.5 L 1022 984.5 L 1023 983.5 L 1024 983.5 L 1025 982.5 L 1026 982.5 L 1027 981.5 L 1028 981.5 L 1030 979.5 L 1031 979.5 L 1033 977.5 L 1034 977.5 L 1035 976.5 L 1037 976.5 L 1038 977.5 L 1045 977.5 L 1046 976.5 L 1047 976.5 L 1048 975.5 L 1050 975.5 L 1051 974.5 L 1052 974.5 L 1055 971.5 L 1056 971.5 L 1057 970.5 L 1058 970.5 L 1059 969.5 L 1060 969.5 L 1062 967.5 L 1063 967.5 L 1067 963.5 L 1068 963.5 L 1069 962.5 L 1076 962.5 L 1077 961.5 L 1078 961.5 L 1079 960.5 L 1080 960.5 L 1081 959.5 L 1082 959.5 L 1084 957.5 L 1088 957.5 L 1088.5 958 L 1088.5 959 L 1090.5 961 L 1090.5 962 L 1092.5 964 L 1092.5 965 L 1093 965.5 L 1094 965.5 L 1099 970.5 L 1100 970.5 L 1101 971.5 L 1103 971.5 L 1107 975.5 L 1109 975.5 L 1110.5 977 L 1110.5 978 L 1113.5 981 L 1113.5 982 L 1114.5 983 L 1114.5 985 L 1118.5 989 L 1118.5 990 L 1119.5 991 L 1119.5 992 L 1120.5 993 L 1119.5 994 L 1119.5 999 L 1121.5 1001 L 1121.5 1002 L 1122.5 1003 L 1122.5 1011 L 1120.5 1013 L 1120.5 1014 L 1119.5 1015 L 1119.5 1017 L 1110 1026.5 L 1109 1026.5 L 1108 1027.5 L 1096 1027.5 L 1095 1028.5 L 1093 1028.5 L 1092 1029.5 L 1090 1029.5 L 1086 1033.5 L 1085 1033.5 L 1084 1034.5 L 1083 1034.5 L 1078.5 1039 L 1078.5 1041 L 1075 1044.5 L 1074 1044.5 L 1073 1045.5 L 1072 1045.5 L 1070 1047.5 L 1069 1047.5 L 1067 1049.5 L 1066 1049.5 L 1065 1050.5 L 1058 1050.5 L 1057 1051.5 L 1056 1051.5 L 1055 1052.5 L 1054 1052.5 L 1053 1053.5 L 1052 1053.5 L 1051 1054.5 L 1048 1054.5 L 1046 1056.5 L 1045 1056.5 L 1044 1057.5 Z",
      "bonusAnchor": {
        "x": 1062.54,
        "y": 1006.86
      }
    },
    {
      "id": "greece",
      "name": "Greece",
      "bonus": 1,
      "color": "#8d63c5",
      "territoryIds": [
        "western-thrace",
        "salonika"
      ],
      "shape": "M 1133 1067.5 L 1132.5 1067 L 1132.5 1057 L 1129 1053.5 L 1128 1053.5 L 1127 1054.5 L 1121 1054.5 L 1120 1055.5 L 1119 1055.5 L 1118 1056.5 L 1117 1056.5 L 1116.5 1057 L 1116.5 1060 L 1117.5 1061 L 1117.5 1067 L 1117 1067.5 L 1047 1067.5 L 1046.5 1067 L 1046.5 1066 L 1045.5 1065 L 1045.5 1064 L 1043.5 1062 L 1043.5 1058 L 1045 1056.5 L 1067 1049.5 L 1090 1029.5 L 1110 1026.5 L 1122 1011.5 L 1124 1011.5 L 1129 1013.5 L 1140 1007.5 L 1141 1006.5 L 1142 1006.5 L 1145 1003.5 L 1150 1003.5 L 1151 1002.5 L 1152 1002.5 L 1153 1001.5 L 1155 1001.5 L 1157 999.5 L 1158 999.5 L 1159 998.5 L 1162 998.5 L 1163 997.5 L 1164 997.5 L 1168 993.5 L 1169 993.5 L 1170.5 992 L 1170.5 991 L 1173 988.5 L 1176 988.5 L 1177 989.5 L 1178 989.5 L 1179 988.5 L 1181 988.5 L 1182 989.5 L 1183 989.5 L 1184 988.5 L 1187 988.5 L 1188 989.5 L 1190 989.5 L 1194 993.5 L 1195 993.5 L 1196 994.5 L 1201 994.5 L 1202 993.5 L 1217 993.5 L 1218 994.5 L 1219 994.5 L 1223 998.5 L 1224 997.5 L 1226 997.5 L 1227 996.5 L 1228 996.5 L 1229 995.5 L 1231 995.5 L 1232 994.5 L 1233 994.5 L 1234 993.5 L 1235 993.5 L 1236 992.5 L 1237 992.5 L 1238 991.5 L 1242 991.5 L 1245 988.5 L 1246 988.5 L 1248 986.5 L 1252 986.5 L 1253 985.5 L 1254 985.5 L 1258 981.5 L 1259 981.5 L 1259.5 981 L 1259.5 980 L 1258.5 979 L 1258.5 975 L 1259.5 974 L 1258.5 973 L 1258.5 972 L 1256.5 970 L 1256.5 969 L 1254.5 967 L 1254.5 966 L 1253.5 965 L 1253.5 964 L 1257 960.5 L 1259 960.5 L 1260 959.5 L 1261 959.5 L 1264 956.5 L 1265 957.5 L 1277.5 966 L 1281.5 975 L 1270.5 990 L 1276.5 1004 L 1270.5 1011 L 1270 1018.5 L 1204 1019.5 L 1183 1040.5 L 1168.5 1044 L 1168.5 1049 L 1179.5 1056 L 1177 1067.5 Z",
      "bonusAnchor": {
        "x": 1156.1,
        "y": 1033.45
      }
    },
    {
      "id": "poland",
      "name": "Poland",
      "bonus": 5,
      "color": "#fd7547",
      "territoryIds": [
        "masuria",
        "pomerelia",
        "podlachia",
        "pomerania",
        "masovia",
        "greater-poland",
        "kuyavia",
        "lublin",
        "lesser-poland",
        "red-ruthenia"
      ],
      "shape": "M 879.5 568 L 879.5 567 L 869.5 545 L 849 532.5 L 843 532.5 L 830 525.5 L 804 524.5 L 799 527.5 L 797 526.5 L 783 510.5 L 778 510.5 L 773 506.5 L 763 506.5 L 736 493.5 L 726.5 486 L 727.5 474 L 719.5 468 L 714.5 456 L 718.5 435 L 710.5 419 L 712.5 411 L 710.5 409 L 692.5 390 L 692.5 388 L 700.5 371 L 694.5 345 L 698 334.5 L 708.5 328 L 715 315.5 L 724 311.5 L 746 310.5 L 753 305.5 L 759 296.5 L 767 291.5 L 772 292.5 L 777 281.5 L 799 279.5 L 805 273.5 L 821 273.5 L 836 277.5 L 839 287.5 L 854 287.5 L 871 281.5 L 872 280.5 L 875 278.5 L 881 280.5 L 938 278.5 L 968 273.5 L 976 267.5 L 983 267.5 L 997 274.5 L 1009.5 291 L 1009.5 294 L 1012.5 306 L 1034.5 347 L 1033.5 348 L 1033.5 355 L 1021.5 366 L 1015.5 379 L 1015.5 387 L 1030.5 396 L 1030.5 410 L 1033.5 419 L 1033.5 423 L 1037.5 431 L 1039.5 437 L 1056.5 457 L 1057.5 467 L 1065.5 473 L 1065 485.5 L 1064 485.5 L 1056 489.5 L 1046.5 502 L 1043.5 513 L 1034.5 524 L 1025.5 542 L 1027.5 558 L 1032.5 571 L 1027 574.5 L 1025 573.5 L 991 558.5 L 975 558.5 L 967 562.5 L 962 569.5 L 950 567.5 L 944 570.5 L 934.5 573 L 934.5 574 L 930 580.5 L 927 580.5 L 911 570.5 L 891 573.5 L 886 568.5 Z",
      "bonusAnchor": {
        "x": 893.79,
        "y": 419.07
      }
    },
    {
      "id": "estonia",
      "name": "Estonia",
      "bonus": 1,
      "color": "#9068c8",
      "territoryIds": [
        "dorpat"
      ],
      "shape": "M 1059 63.5 L 1055 63.5 L 1053 61.5 L 1049 61.5 L 1042 54.5 L 1041 54.5 L 1040 53.5 L 1039 53.5 L 1038 52.5 L 1036 52.5 L 1031 47.5 L 1026 47.5 L 1025 48.5 L 1024 47.5 L 1023 47.5 L 1022 46.5 L 1021 46.5 L 1020 45.5 L 1012 45.5 L 1011 46.5 L 1005 46.5 L 1001 50.5 L 999 50.5 L 998 51.5 L 996 51.5 L 995 52.5 L 991 52.5 L 989.5 51 L 989.5 50 L 988.5 49 L 988.5 43 L 989.5 42 L 989.5 41 L 989 40.5 L 988 40.5 L 987 39.5 L 986 39.5 L 985 38.5 L 981 38.5 L 980.5 38 L 980.5 37 L 980 36.5 L 978 36.5 L 977 35.5 L 976 35.5 L 975 34.5 L 974 34.5 L 973 33.5 L 972 33.5 L 967 28.5 L 962 28.5 L 961 27.5 L 960 27.5 L 959 26.5 L 958 26.5 L 955 23.5 L 954 23.5 L 953.5 23 L 953.5 22 L 952.5 21 L 952.5 20 L 953.5 19 L 952.5 18 L 952.5 17 L 951.5 16 L 951.5 10 L 950.5 9 L 950.5 8 L 949.5 7 L 949.5 4 L 947.5 2 L 947.5 1 L 946.5 0 L 947 -0.5 L 1070 -0.5 L 1070.5 0 L 1070.5 4 L 1072.5 6 L 1072.5 10 L 1073.5 11 L 1073.5 19 L 1077 22.5 L 1078 22.5 L 1080.5 25 L 1080.5 28 L 1081.5 29 L 1081.5 30 L 1083.5 32 L 1083.5 33 L 1084.5 34 L 1084.5 35 L 1085.5 36 L 1085.5 37 L 1084.5 38 L 1084.5 40 L 1083.5 41 L 1083.5 42 L 1082.5 43 L 1082.5 44 L 1080.5 46 L 1080.5 53 L 1079.5 54 L 1079.5 56 L 1077 58.5 L 1075 58.5 L 1074 57.5 L 1067 57.5 L 1063 61.5 L 1062 61.5 L 1061 62.5 L 1060 62.5 L 1059 63.5 Z",
      "bonusAnchor": {
        "x": 1022.27,
        "y": 23.02
      }
    },
    {
      "id": "latvia",
      "name": "Latvia",
      "bonus": 1,
      "color": "#fdbd4d",
      "territoryIds": [
        "livonia",
        "courland"
      ],
      "shape": "M 902 174.5 L 900.5 164 L 897.5 161 L 897.5 139 L 902.5 131 L 905.5 108 L 908 105.5 L 912 105.5 L 927 92.5 L 940 90.5 L 944 96.5 L 961 102.5 L 963 111.5 L 983 111.5 L 987.5 106 L 986.5 105 L 988.5 55 L 995 52.5 L 1005 46.5 L 1020 45.5 L 1025 48.5 L 1031 47.5 L 1055 63.5 L 1067 57.5 L 1077 58.5 L 1079 56.5 L 1081 56.5 L 1097.5 68 L 1097.5 70 L 1099.5 91 L 1118.5 110 L 1123.5 119 L 1125 129.5 L 1124 129.5 L 1118.5 136 L 1113.5 151 L 1105 157.5 L 1096 158.5 L 1085 171.5 L 1083 170.5 L 1047 150.5 L 1032 151.5 L 1020 141.5 L 1013.5 144 L 1000 153.5 L 983 154.5 L 981 152.5 L 959 153.5 L 931 159.5 L 911 172.5 Z",
      "bonusAnchor": {
        "x": 1015.77,
        "y": 106.25
      }
    },
    {
      "id": "lithuania",
      "name": "Lithuania",
      "bonus": 2,
      "color": "#fdfc03",
      "territoryIds": [
        "aukstaitija",
        "samogitia",
        "vilna"
      ],
      "shape": "M 1010 291.5 L 1008.5 290 L 997 274.5 L 986 268.5 L 977 267.5 L 976.5 267 L 973.5 253 L 974.5 240 L 962 228.5 L 961 229.5 L 946 234.5 L 925 227.5 L 913 226.5 L 909.5 219 L 909.5 203 L 901.5 181 L 902.5 175 L 907 174.5 L 931 159.5 L 942 156.5 L 971 152.5 L 983 154.5 L 985 154.5 L 1005 151.5 L 1016 141.5 L 1022 142.5 L 1032 151.5 L 1047 150.5 L 1085.5 173 L 1087.5 185 L 1093.5 192 L 1092.5 196 L 1091 197.5 L 1073.5 217 L 1069.5 227 L 1070.5 228 L 1073.5 234 L 1071.5 247 L 1074.5 254 L 1071 257.5 L 1062 258.5 L 1050.5 269 L 1049.5 273 L 1037 283.5 L 1019 286.5 Z"
    },
    {
      "id": "belarus",
      "name": "Belarus",
      "bonus": 5,
      "color": "#a18857",
      "territoryIds": [
        "polotsk",
        "vitebsk",
        "navahrudak",
        "mogilev",
        "minsk",
        "grodno",
        "slutsk",
        "gomel",
        "brest"
      ],
      "shape": "M 1031.5 417 L 1030.5 396 L 1015.5 387 L 1015.5 379 L 1018.5 370 L 1033.5 355 L 1034.5 347 L 1033.5 346 L 1012.5 306 L 1009.5 292 L 1011 290.5 L 1037 283.5 L 1050.5 272 L 1050.5 269 L 1062 258.5 L 1071 257.5 L 1074.5 254 L 1071.5 247 L 1073.5 234 L 1069.5 227 L 1069.5 224 L 1081.5 210 L 1082.5 205 L 1092.5 196 L 1092.5 194 L 1084.5 172 L 1092.5 164 L 1096 158.5 L 1110 154.5 L 1119.5 134 L 1127 129.5 L 1134 132.5 L 1142 128.5 L 1150 134.5 L 1157 130.5 L 1167 130.5 L 1170.5 134 L 1170.5 139 L 1177 144.5 L 1181 140.5 L 1193 131.5 L 1208 131.5 L 1212 135.5 L 1213 135.5 L 1215 137.5 L 1216 137.5 L 1217 138.5 L 1218 138.5 L 1219 139.5 L 1220 138.5 L 1221 138.5 L 1222 139.5 L 1223 139.5 L 1226.5 143 L 1226.5 146 L 1227.5 147 L 1227.5 148 L 1225.5 150 L 1225.5 151 L 1224.5 152 L 1224.5 155 L 1226 156.5 L 1227 156.5 L 1229.5 159 L 1229.5 160 L 1230.5 161 L 1230.5 162 L 1234.5 166 L 1234.5 167 L 1235.5 168 L 1234.5 169 L 1234.5 170 L 1233.5 171 L 1233.5 172 L 1232.5 173 L 1232.5 174 L 1231.5 175 L 1231.5 176 L 1230.5 177 L 1231.5 178 L 1231.5 179 L 1237 184.5 L 1238 184.5 L 1243 189.5 L 1245 189.5 L 1248.5 193 L 1248.5 194 L 1255.5 201 L 1255.5 202 L 1257.5 204 L 1261 210.5 L 1264 210.5 L 1277 213.5 L 1284 226.5 L 1288 228.5 L 1292 225.5 L 1301 226.5 L 1308 234.5 L 1314 236.5 L 1317.5 240 L 1317.5 244 L 1307 260.5 L 1298 264.5 L 1288 262.5 L 1280.5 270 L 1282.5 277 L 1295.5 289 L 1294.5 296 L 1297.5 304 L 1302.5 309 L 1308 321.5 L 1307 321.5 L 1292 328.5 L 1281.5 343 L 1278.5 361 L 1285.5 373 L 1282 381.5 L 1281 380.5 L 1272 373.5 L 1256 380.5 L 1248 380.5 L 1244 384.5 L 1232 377.5 L 1226 377.5 L 1225 378.5 L 1216 385.5 L 1196 385.5 L 1183 392.5 L 1181 392.5 L 1177 389.5 L 1168 391.5 L 1152 385.5 L 1150 385.5 L 1146 387.5 L 1107 387.5 L 1060 402.5 L 1057.5 410 L 1048 417.5 L 1034 419.5 Z"
    },
    {
      "id": "ukraine",
      "name": "Ukraine",
      "bonus": 6,
      "color": "#9066c7",
      "territoryIds": [
        "chernihiv",
        "poltava",
        "kyiv",
        "zhytomyr",
        "volhynia",
        "cherkasy",
        "bratslav",
        "podolia",
        "transcarpathia",
        "zaporizhzhia",
        "odessa"
      ],
      "shape": "M 1300.5 722 L 1300.5 720 L 1298.5 713 L 1305.5 701 L 1310.5 682 L 1306.5 674 L 1307.5 665 L 1318 661.5 L 1329 662.5 L 1336.5 656 L 1337.5 648 L 1333.5 638 L 1324 634.5 L 1312.5 617 L 1298.5 606 L 1290.5 590 L 1280.5 583 L 1279 581.5 L 1269 574.5 L 1257 576.5 L 1253 573.5 L 1242 573.5 L 1230 567.5 L 1221 566.5 L 1204 577.5 L 1197 578.5 L 1192 584.5 L 1190 584.5 L 1180 589.5 L 1179.5 590 L 1167 607.5 L 1143 615.5 L 1128 629.5 L 1124 626.5 L 1111 620.5 L 1087 626.5 L 1058 622.5 L 1050 628.5 L 1047 625.5 L 1039 625.5 L 1032 620.5 L 1026 621.5 L 1016 611.5 L 1015.5 611 L 1018.5 585 L 1030 571.5 L 1032.5 571 L 1027.5 558 L 1025.5 542 L 1034.5 524 L 1043.5 513 L 1046.5 502 L 1056 489.5 L 1065 485.5 L 1065.5 485 L 1065.5 473 L 1057.5 467 L 1056.5 457 L 1036.5 430 L 1033.5 420 L 1034 419.5 L 1052 415.5 L 1057.5 410 L 1058.5 404 L 1070 397.5 L 1084 396.5 L 1107 387.5 L 1152 385.5 L 1153 386.5 L 1162 387.5 L 1168 391.5 L 1177 389.5 L 1183 392.5 L 1184 391.5 L 1196 385.5 L 1216 385.5 L 1226 377.5 L 1232 377.5 L 1244 384.5 L 1248 380.5 L 1256 380.5 L 1272 373.5 L 1282 381.5 L 1284.5 379 L 1285.5 373 L 1278.5 361 L 1281.5 343 L 1292 328.5 L 1310 321.5 L 1318 324.5 L 1319 323.5 L 1329.5 316 L 1329.5 307 L 1334 302.5 L 1341 302.5 L 1349 298.5 L 1357 290.5 L 1380 288.5 L 1395 304.5 L 1405.5 310 L 1401.5 321 L 1415 339.5 L 1417 339.5 L 1437.5 338 L 1437.5 615 L 1430 616.5 L 1427 612.5 L 1420 612.5 L 1409 622.5 L 1392 625.5 L 1363.5 646 L 1364.5 694 L 1359 700.5 L 1352 700.5 L 1342.5 708 L 1343.5 716 L 1340 721.5 L 1338 720.5 L 1329 719.5 L 1325 723.5 Z",
      "bonusAnchor": {
        "x": 1284.95,
        "y": 473.85
      }
    },
    {
      "id": "moldova",
      "name": "Moldova",
      "bonus": 1,
      "color": "#fdfc04",
      "territoryIds": [
        "bessarabia",
        "budjak"
      ],
      "shape": "M 1283 723.5 L 1282.5 723 L 1274.5 698 L 1273.5 672 L 1263.5 651 L 1253 640.5 L 1251 640.5 L 1250 639.5 L 1249 639.5 L 1247.5 638 L 1202 588.5 L 1192.5 584 L 1193.5 583 L 1197 578.5 L 1204 577.5 L 1221 566.5 L 1255 575.5 L 1269 574.5 L 1280.5 583 L 1280.5 584 L 1290.5 590 L 1302 609.5 L 1312.5 617 L 1324 634.5 L 1333.5 638 L 1337.5 654 L 1329 662.5 L 1318 661.5 L 1307.5 665 L 1306.5 674 L 1310.5 682 L 1305.5 701 L 1298.5 713 L 1300.5 723 L 1300 723.5 L 1287 725.5 Z",
      "bonusAnchor": {
        "x": 1279.68,
        "y": 629.84
      }
    },
    {
      "id": "romania",
      "name": "Romania",
      "bonus": 5,
      "color": "#fdbe4f",
      "territoryIds": [
        "maramures",
        "crisana",
        "moldavia",
        "transylvania",
        "banat",
        "szekely-land",
        "dobruja",
        "oltenia",
        "wallachia"
      ],
      "shape": "M 1075.5 845 L 1069.5 839 L 1073.5 829 L 1069 824.5 L 1065 823.5 L 1054 834.5 L 1046 829.5 L 1036 830.5 L 1025.5 822 L 1022.5 814 L 1024.5 808 L 1024.5 806 L 1020 801.5 L 1010 799.5 L 996 793.5 L 987.5 784 L 986.5 777 L 970 764.5 L 964 754.5 L 965 754.5 L 969 750.5 L 976 749.5 L 985 741.5 L 992 742.5 L 999.5 737 L 999.5 725 L 1005.5 716 L 1013.5 688 L 1019.5 669 L 1019.5 660 L 1030 646.5 L 1042 643.5 L 1051 628.5 L 1052 628.5 L 1058 622.5 L 1087 626.5 L 1113 620.5 L 1127 629.5 L 1129 628.5 L 1143 615.5 L 1167 607.5 L 1180 589.5 L 1182 589.5 L 1193 584.5 L 1194 585.5 L 1202 588.5 L 1249 639.5 L 1250 639.5 L 1251 640.5 L 1253 640.5 L 1263.5 651 L 1273.5 672 L 1274.5 698 L 1283 723.5 L 1284 723.5 L 1297 725.5 L 1301 722.5 L 1325 723.5 L 1329 719.5 L 1340 722.5 L 1346.5 726 L 1347 730.5 L 1353.5 732 L 1353.5 748 L 1335 749.5 L 1325.5 756 L 1328.5 764 L 1327.5 814 L 1330.5 821 L 1328 821.5 L 1310 824.5 L 1298 817.5 L 1280 818.5 L 1272 814.5 L 1259 815.5 L 1248 820.5 L 1246 822.5 L 1231 829.5 L 1220.5 839 L 1218.5 846 L 1213 852.5 L 1202 857.5 L 1183 858.5 L 1179 856.5 L 1177 857.5 L 1173 860.5 L 1161 860.5 L 1154 866.5 L 1111 863.5 L 1104 868.5 L 1097 869.5 L 1090.5 864 L 1093.5 857 Z M 1349.5 743 L 1348.5 737 L 1349 743.5 Z",
      "bonusAnchor": {
        "x": 1169.15,
        "y": 734.99
      }
    },
    {
      "id": "bulgaria",
      "name": "Bulgaria",
      "bonus": 2,
      "color": "#9ed574",
      "territoryIds": [
        "varna",
        "eastern-rumelia",
        "sofia"
      ],
      "shape": "M 1123 1011.5 L 1122.5 1011 L 1122.5 1003 L 1121.5 1002 L 1121.5 1001 L 1119.5 999 L 1119.5 994 L 1120.5 993 L 1119.5 992 L 1119.5 991 L 1118.5 990 L 1118.5 989 L 1114.5 985 L 1114.5 983 L 1113.5 982 L 1113.5 981 L 1110.5 978 L 1110.5 977 L 1109 975.5 L 1107 975.5 L 1103 971.5 L 1101 971.5 L 1100 970.5 L 1099 970.5 L 1094 965.5 L 1093 965.5 L 1092.5 965 L 1092.5 964 L 1090.5 962 L 1090.5 961 L 1088.5 959 L 1088.5 957 L 1092.5 953 L 1091.5 947 L 1087.5 944 L 1085.5 930 L 1095.5 923 L 1102.5 908 L 1095 898.5 L 1088 897.5 L 1078.5 888 L 1072.5 877 L 1071.5 864 L 1081 850.5 L 1093.5 857 L 1090.5 864 L 1097 869.5 L 1104 868.5 L 1111 863.5 L 1129 863.5 L 1138 866.5 L 1154 866.5 L 1157 863.5 L 1161 860.5 L 1173 860.5 L 1178 856.5 L 1180 857.5 L 1202 857.5 L 1213 852.5 L 1219.5 845 L 1220.5 839 L 1231 829.5 L 1248 820.5 L 1252 820.5 L 1259 815.5 L 1272 814.5 L 1280 818.5 L 1298 817.5 L 1310 824.5 L 1331 821.5 L 1330.5 841 L 1319.5 850 L 1320.5 858 L 1315.5 864 L 1312.5 876 L 1299.5 891 L 1299.5 897 L 1303.5 902 L 1302.5 913 L 1304 911.5 L 1311 915.5 L 1315 921.5 L 1322 921.5 L 1324.5 925 L 1322.5 927 L 1310 935.5 L 1301 929.5 L 1295 929.5 L 1271.5 946 L 1264.5 956 L 1261 959.5 L 1253.5 964 L 1259.5 974 L 1259.5 981 L 1226 997.5 L 1223 998.5 L 1217 993.5 L 1196 994.5 L 1187 988.5 L 1173 988.5 L 1170.5 991 L 1170.5 992 L 1169 993.5 L 1168 993.5 L 1164 997.5 L 1163 997.5 L 1162 998.5 L 1159 998.5 L 1158 999.5 L 1157 999.5 L 1155 1001.5 L 1153 1001.5 L 1152 1002.5 L 1151 1002.5 L 1150 1003.5 L 1145 1003.5 L 1142 1006.5 L 1141 1006.5 L 1140 1007.5 L 1137 1007.5 L 1136 1008.5 L 1135 1008.5 L 1131 1012.5 L 1130 1012.5 L 1129 1013.5 L 1127 1013.5 L 1126 1012.5 L 1125 1012.5 L 1124 1011.5 Z",
      "bonusAnchor": {
        "x": 1209.07,
        "y": 903.24
      }
    },
    {
      "id": "turkey",
      "name": "Turkey",
      "bonus": 2,
      "color": "#fc7445",
      "territoryIds": [
        "edirne",
        "constantinople",
        "gallipoli"
      ],
      "shape": "M 1285 1067.5 L 1286 1036.5 L 1297 1035.5 L 1309 1029.5 L 1313 1030.5 L 1320 1022.5 L 1337 1027.5 L 1342.5 1024 L 1343 1020.5 L 1362 1019.5 L 1369 1013.5 L 1380 1010.5 L 1407.5 1001 L 1409.5 994 L 1404.5 989 L 1404.5 985 L 1399 983.5 L 1358 983.5 L 1345 990.5 L 1340 989.5 L 1335 993.5 L 1330 993.5 L 1321.5 1003 L 1321.5 1011 L 1313 1018.5 L 1270.5 1018 L 1270.5 1011 L 1276.5 1001 L 1270.5 994 L 1270.5 990 L 1281.5 975 L 1277.5 966 L 1264.5 957 L 1264.5 954 L 1277 940.5 L 1295 929.5 L 1301 929.5 L 1310 935.5 L 1314 934.5 L 1324 925.5 L 1332.5 933 L 1337 941.5 L 1355 952.5 L 1358 950.5 L 1404 950.5 L 1408 953.5 L 1414 953.5 L 1430 941.5 L 1437.5 943 L 1437 1067.5 Z M 1433.5 949 L 1434 945.5 L 1431.5 948 L 1433 949.5 Z",
      "bonusAnchor": {
        "x": 1380.4,
        "y": 1003.04
      }
    },
    {
      "id": "prussia",
      "name": "Prussia",
      "bonus": 1,
      "color": "#9cd471",
      "territoryIds": [
        "konigsberg"
      ],
      "shape": "M 910 280.5 L 896 280.5 L 895 279.5 L 888 279.5 L 887 280.5 L 881 280.5 L 880 279.5 L 877 279.5 L 876 278.5 L 875 278.5 L 874.5 278 L 876.5 276 L 876.5 270 L 880.5 266 L 880.5 265 L 881.5 264 L 881.5 263 L 884.5 260 L 884.5 259 L 889 254.5 L 891 254.5 L 892 253.5 L 893 253.5 L 893.5 253 L 893.5 252 L 894 251.5 L 895 251.5 L 896 250.5 L 899 250.5 L 900 251.5 L 903 251.5 L 905 249.5 L 907 249.5 L 911 245.5 L 913 245.5 L 913.5 245 L 913.5 244 L 914.5 243 L 914.5 242 L 913.5 241 L 913.5 227 L 914 226.5 L 920 226.5 L 921 227.5 L 925 227.5 L 926 228.5 L 927 228.5 L 928 229.5 L 933 229.5 L 934 230.5 L 935 230.5 L 936 231.5 L 939 231.5 L 940 232.5 L 942 232.5 L 943 233.5 L 945 233.5 L 946 234.5 L 950 234.5 L 951 233.5 L 952 233.5 L 953 232.5 L 956 232.5 L 957 231.5 L 958 231.5 L 960 229.5 L 961 229.5 L 962 228.5 L 963 229.5 L 964 229.5 L 971 236.5 L 972 236.5 L 973.5 238 L 973.5 239 L 974.5 240 L 974.5 242 L 975.5 243 L 974.5 244 L 974.5 246 L 973.5 247 L 973.5 253 L 974.5 254 L 974.5 263 L 975.5 264 L 975.5 265 L 976.5 266 L 976.5 267 L 974 269.5 L 973 269.5 L 970 272.5 L 969 272.5 L 968 273.5 L 964 273.5 L 963 274.5 L 953 274.5 L 952 275.5 L 948 275.5 L 947 276.5 L 942 276.5 L 941 277.5 L 939 277.5 L 938 278.5 L 935 278.5 L 934 277.5 L 930 277.5 L 929 278.5 L 914 278.5 L 913 279.5 L 911 279.5 L 910 280.5 Z M 889.5 263 L 891.5 261 L 891 260.5 L 890 260.5 L 889.5 261 L 889.5 262 L 888.5 263 L 889 263.5 L 889.5 263 Z M 881.5 274 L 883.5 272 L 883 271.5 L 882 272.5 L 881 272.5 L 880.5 273 L 880.5 274 L 881 274.5 L 881.5 274 Z",
      "bonusAnchor": {
        "x": 929.45,
        "y": 256.71
      }
    },
    {
      "id": "russia",
      "name": "Russia",
      "bonus": 4,
      "color": "#9fd474",
      "territoryIds": [
        "pskov",
        "novgorod",
        "tver",
        "velikiye-luki",
        "toropets",
        "rzhev",
        "smolensk",
        "kaluga",
        "bryansk"
      ],
      "shape": "M 1415 339.5 L 1413.5 338 L 1401.5 321 L 1405.5 310 L 1395 304.5 L 1380 288.5 L 1357 290.5 L 1349 298.5 L 1341 302.5 L 1334 302.5 L 1329.5 307 L 1329.5 316 L 1318 324.5 L 1315 324.5 L 1309 321.5 L 1308.5 321 L 1297.5 304 L 1297.5 301 L 1294.5 296 L 1295.5 289 L 1282.5 277 L 1280.5 270 L 1288 262.5 L 1298 264.5 L 1307 260.5 L 1318.5 242 L 1314 236.5 L 1312 236.5 L 1311 235.5 L 1310 235.5 L 1309 234.5 L 1308 234.5 L 1304.5 231 L 1304.5 229 L 1303 227.5 L 1302 227.5 L 1301 226.5 L 1295 226.5 L 1294 225.5 L 1292 225.5 L 1290 227.5 L 1289 227.5 L 1288 228.5 L 1287 227.5 L 1286 227.5 L 1285 226.5 L 1284 226.5 L 1282.5 225 L 1282.5 221 L 1281.5 220 L 1281.5 219 L 1279.5 217 L 1279.5 216 L 1277 213.5 L 1269 213.5 L 1268 212.5 L 1267 212.5 L 1266 211.5 L 1265 211.5 L 1264 210.5 L 1261 210.5 L 1260.5 210 L 1255.5 202 L 1230.5 177 L 1235.5 168 L 1224.5 155 L 1227.5 148 L 1226.5 143 L 1208 131.5 L 1203 131.5 L 1193 131.5 L 1177 144.5 L 1176 143.5 L 1170.5 139 L 1170.5 134 L 1167 130.5 L 1157 130.5 L 1150 134.5 L 1142 128.5 L 1134 132.5 L 1126 129.5 L 1125.5 129 L 1118.5 110 L 1099.5 91 L 1097.5 68 L 1097 67.5 L 1080 56.5 L 1079.5 56 L 1080.5 46 L 1085.5 36 L 1080.5 25 L 1073.5 19 L 1071 -0.5 L 1437 -0.5 L 1437.5 337 L 1437 337.5 Z",
      "bonusAnchor": {
        "x": 1321.17,
        "y": 92.15
      }
    }
  ],
  "seaRoutes": [
    {
      "aId": "ulster",
      "bId": "galloway",
      "from": {
        "x": 46.5,
        "y": 254
      },
      "to": {
        "x": 57.5,
        "y": 246
      }
    },
    {
      "aId": "grampian",
      "bId": "rogaland",
      "from": {
        "x": 181.5,
        "y": 102
      },
      "to": {
        "x": 399.5,
        "y": 4
      }
    },
    {
      "aId": "wessex",
      "bId": "picardy",
      "from": {
        "x": 202,
        "y": 498.5
      },
      "to": {
        "x": 223,
        "y": 546.5
      }
    },
    {
      "aId": "provence",
      "bId": "corsica",
      "from": {
        "x": 439,
        "y": 932.5
      },
      "to": {
        "x": 496.5,
        "y": 989
      }
    },
    {
      "aId": "corsica",
      "bId": "tuscany",
      "from": {
        "x": 532.5,
        "y": 980
      },
      "to": {
        "x": 573.5,
        "y": 960
      }
    },
    {
      "aId": "viken",
      "bId": "vastergotland",
      "from": {
        "x": 583.3356277145693,
        "y": 23.203958634952148
      },
      "to": {
        "x": 611.1643722854307,
        "y": 26.296041365047852
      }
    },
    {
      "aId": "viken",
      "bId": "jutland",
      "from": {
        "x": 503,
        "y": 86.5
      },
      "to": {
        "x": 540,
        "y": 129.5
      }
    },
    {
      "aId": "jutland",
      "bId": "zealand",
      "from": {
        "x": 585.5,
        "y": 211
      },
      "to": {
        "x": 598.5,
        "y": 219
      }
    },
    {
      "aId": "schleswig",
      "bId": "zealand",
      "from": {
        "x": 578.5,
        "y": 252
      },
      "to": {
        "x": 589.5,
        "y": 246
      }
    },
    {
      "aId": "zealand",
      "bId": "scania",
      "from": {
        "x": 625,
        "y": 206.5
      },
      "to": {
        "x": 632.5,
        "y": 203
      }
    }
  ],
  "forceSeaRoutes": [
    [
      "grampian",
      "rogaland"
    ],
    [
      "viken",
      "jutland"
    ],
    [
      "jutland",
      "zealand"
    ],
    [
      "schleswig",
      "zealand"
    ],
    [
      "ulster",
      "galloway"
    ],
    [
      "wessex",
      "picardy"
    ],
    [
      "provence",
      "corsica"
    ],
    [
      "corsica",
      "tuscany"
    ],
    [
      "viken",
      "vastergotland"
    ],
    [
      "zealand",
      "scania"
    ]
  ],
  "suppressSeaRoutes": [],
  "addedOn": "2026-10-28",
  "geometryVersion": "v1-e8b6c92f-ffb89e38"
}
